import { ref } from 'vue'
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal'
import { Collapse } from 'vue-collapsed'
// import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Autoplay, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import Swal from 'sweetalert2'

import 'maz-ui/styles' // or import 'maz-ui/css/main.css'
import MazInput from 'maz-ui/components/MazInput'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

export const sharedFunction = {
  components: {
    MazPhoneNumberInput,
    Keyboard,
    Collapse,
    Swiper,
    SwiperSlide,
    VueFinalModal,
    ModalsContainer
  },
  data () {
    return {
      qr_version: 4,
      // "Do you want to order something else?" popup (QR menu). Reset in restart().
      reorderPopupTimer: null,
      reorderPopupDone: false,
      reorderPopupOpen: false,
      blockKioskFiscalError: false,
      lastOrderNumberForFiscalError: null,
      fiscalErrorInfo: null,
      // Ce caz de refiscalizare e comanda blocata:
      //  'place_and_fiscal' = comanda nu a ajuns in cloud (trebuie pusa + fiscalizata)
      //  'fiscal_only'      = comanda e in cloud dar nu s-a fiscalizat (doar refiscalizare)
      fiscalErrorCase: null,
      // Lista comenzilor nefiscalizate gasite pe API la pornire (de obicei 0 sau 1).
      pendingFiscalOrders: [],
      selectedPeopleAndProducts: {},
      addToCartDisabled: false,
      addProductInCartRequest: 0,
      waiterStep0: false,
      waiterStep1: false,
      waiterStep2: false,
      client: null,
      new_client: null,
      order_phone: null,
      order_phone_country_code: null,
      keysForHandleKeyUpClientModal: '',
      orderComments: '',
      shiftPressed: null,
      fontSwall: '3rem',
      bounceCartQuantity: false,
      optionsInSteps: false,
      loader: true,
      countdown: 50,
      email_to_send: '',
      keyForPhone: 0,
      phone_to_send: '',
      oldOrder: {},
      countryCode: ref('RO'),
      resultsPhone: ref(),
      infoShown: {
        top: false,
        bottom: false,
        permanentDisabled: false,
      },
      activeFilter: {
        top: false,
        bottom: false,
      },
      activeProductList: {
        top: false,
        bottom: false,
      },
      allLang: window.allLang,
      languageNamesFromApi: {},
      listOfLangIsOpen: 0,
      topReach: 0,
      bottomReach: 0,
      touchstartX: 0,
      touchstartY: 0,
      touchendX: 0,
      touchendY: 0,
      swiperModule: [Autoplay, EffectFade ],
      swiperModuleTutorial: [Autoplay, EffectFade ],
      swiperTutorial: null,
      qr_code: null,
      checkIfPaymentIsCompleteTimeout: null,
      timeoutRestartFinishOrder: null,
      timeoutCartReload: null,
      activitiDetected: null,
      checkIfIsCloseTimeout: null,
      finishOrderNr: null,
      activeKeyboard: false,
      activeKeyboardClient: false,
      keyboard: null,
      packed: false,
      loading: false,
      openingProduct: false,
      isExpended: null,
      orderComent: '',
      packingMethod: null,
      customMethod: 'self_ordering',
      settingOrderMethod: false,
      orderMethodRequestId: 0,
      currency_symbol: null,
      selectedCategory: null,
      selectedTopCategory: null,
      showRemoveTextFromSearch: 0,
      top_category: null,
      category: null,
      products: null,
      banners: null,
      products_id_has_stock_active: [],
      stocksForProducts: {},
      productDiscountAvailability: {},
      indisponibleProducts: {},
      lastIndisponibilityCheckAt: 0,
      product_options_id_has_stock_active: [],
      stocksForProductOptions: {},
      productOptionsCovStockMap: {},
      selectedFingerprint: null,
      splashScreenBanners: [],
      sliderNextTimeout: null,
      nextSplashScreenSlider: 0,
      searchText: '',
      debounceSearchText: null,
      couponText: '',
      couponApplied: false,
      cuiText: '',
      cui: '',
      pagerText: '',
      pager: '',
      onCreatedAfterLoginFlag: false,
      selectedPaymentMethod: '',
      formloadCounter: 0,
      newTextTimeout: null,
      paymentLinkForIframe: '',
      showSplashScreenModal: false,
      showOptionModal: false,
      showOptionModalEffectOut: false,
      showProductModal: false,
      showCartModal: false,
      showPaymentModal: false,
      showClientModal: false,
      showCouponModal: false,
      showPagerModal: false,
      showIframeModal: false,
      showCompleteModal: false,
      showSoldWithModal: false,
      showSoldWithMenuSuggestionModal: false,
      showInfoProdModal: false,
      showInfoOptModal: false,
      showPosModal: false,
      showCompleteWaitingModal: false,
      showCashMachineModal: false,
      showSettingsModal: false,
      showPaymentSuccessModal: false,
      showP9Modal: false,
      showCuiModal: false,
      showTipModal: false,
      showCustomTipModal: false,
      selectedTipValue: null,
      customTipValue: 0,
      customTipInput: '',
      // History Z / Bon (kiosk) — tastatura numerica proprie
      showHistoryModal: false,
      historyMode: '',            // 'z' | 'bon'
      historyActiveField: 'zet',  // 'bon' | 'zet' (pt. modul 'bon')
      historyBonInput: '',
      historyZetInput: '',
      // Cauta comanda (kiosk) — lista ultimelor comenzi ale kioskului
      showSearchOrderModal: false,
      searchOrders: [],
      searchOrdersPage: 1,
      searchOrdersLastPage: 1,
      searchOrdersTotal: 0,
      searchOrdersLoading: false,
      expandedSearchOrderId: null,
      expandedSearchOrderProducts: [],
      expandedSearchOrderLoading: false,
      // Filtre cauta comanda (numerice, cu tastatura numerica proprie)
      searchActiveFilterField: 'id',   // 'id' | 'number' | 'total'
      searchFilterId: '',
      searchFilterNumber: '',
      searchFilterTotal: '',
      customMsgCashMachine: null,
      showLoaderCompleteCashMachine: false,
      corectPass: false,
      thePass: '',
      // requestId-ul ultimului request de focus FiscalNet (buton secret din settings).
      // Il folosim ca sa acceptam DOAR raspunsul care corespunde cererii noastre.
      fiscalNetRequestId: null,
      insertedMoneyInCashMachine: 0,
      soldWithCategory: null,
      selectedSoldWithProducts: [],
      extraCostSoldWith: 0,
      currentOptionInPopup: null,
      cart: null,
      payMethod: '',
      curentLang: 'ro',
      freePaymentEnabled: false,
      cashPaymentEnabled: false,
      cardPaymentEnabled: false,
      posOnDeliveryPaymentEnabled: false,
      kioskPosOnDeliveryPaymentEnabled: false,
      posPaymentEnabled: false,
      // Cand posul bancar e configurat (DBpos / DBfiscal) dar /isOnline nu raspunde
      // pozitiv (offline sau request esuat), NU afisam butonul de card. In schimb
      // aratam un card "Posul bancar este deconectat" cu buton de "Reincearca".
      posOffline: false,
      // Cat timp reincercam /isOnline, dezactivam butonul de reincearca.
      posRetrying: false,
      onePaymentAllreadyPicked: false,
      disablePaymentClass: '',
      editToCartUpdateQuantityIsAllready: false,
      dataToSendToVivaWallet: null,
      // Timeout de siguranta: daca nu vine raspuns de la Viva Wallet, deblocam
      // butoanele de plata dupa 5 min ca sa nu ramana blocate la infinit.
      vivaLockTimeout: null,
      // Anti-spam: cat timp e true, NU se mai poate porni un alt intent Viva
      // (altfel se creau DRAFT_AWAITING_PAYMENT multiple la apasari repetate).
      // Se elibereaza DOAR la final definitiv: succes, esec split/retea, timeout.
      vivaInProgress: false,
      // Overlay-ul de asteptare Viva ("Se asteapta deschiderea aplicatiei Viva").
      // Butonul "Reincearca" apare dupa 10s de la trimiterea intentului si
      // reincearca DOAR intentul (postMessage), nu si restul requesturilor.
      showVivaRetry: false,
      vivaRetryTimeout: null,
      selectedTip: null,
      customTip: '',
      tipValue: 0,
      lastKey: null,
      showWalletModal: false,
      walletValue: null,
      timeoutGetCompanyData: null,
      swiperOptions: {
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        // initialSlide: this.$f7route.params.initial,
        on: {
          // slideNextTransitionEnd: this.sliderChangedNext,
          // slidePrevTransitionEnd: this.sliderChangedPrev
        }
      },
      // loadingCompleteOrder: false,
      currentProductInPopup: null,
      currentProductInInfoPopup: null,
      currentOptInInfoPopup: null,
      extraInfoJsonToBePrinted: {},
    }
  },
  created () {
    // in onCreatedAfterLogin()
  },
  beforeDestroy () {
    clearTimeout(this.timeoutGetCompanyData)
  },
  watch: {
    // showSplashScreenModal(newVal, oldVal) {
    //   console.log('Mesajul s-a schimbat din', oldVal, 'în', newVal)
    //   if (newVal) {
    //     this.checkIfIsClose()
    //   }
    // }
  },
  methods: {
    // Pricing APIs need source + delivery_method for mapSourceMethod / PPP / campaign discounts.
    // Do not use on update-cart / get-cart (those use order.order_source_id).
    getPricingSource () {
      return this.json && this.json.type == 'Kiosk' ? 'Kiosk' : 'QR'
    },
    getPricingDeliveryMethod () {
      // Must match OrderController / DiscountCampaignService::resolveSourceMethodFromOrder
      // otherwise menu can show EatIn discounts while takeAway add validates ToGo (no campaign).
      const packing = (this.packingMethod || this.packing_method || '').toString()
      if (packing === 'dineIn') {
        return 'EAT_LOCATION'
      }
      if (['takeaway', 'takeAway', 'toGo', 'to_go'].indexOf(packing) !== -1) {
        return 'PICK_UP'
      }

      const method = (this.customMethod || 'self_ordering').toString().toLowerCase()
      const map = {
        self_ordering: 'SELF_ORDERING',
        eat_location: 'EAT_LOCATION',
        pick_up: 'PICK_UP',
        delivery: 'DELIVERY',
        meet_half: 'MEET_HALF'
      }
      return map[method] || method.toUpperCase()
    },
    appendPricingContext (data) {
      data = data || {}
      data.source = this.getPricingSource()
      data.delivery_method = this.getPricingDeliveryMethod()
      if (this.locationTrueId) {
        data.location_true_id = this.locationTrueId
      }
      return data
    },
    // PPP numeric ids for discount availability (Kiosk EatIn=1 / Takeout=2).
    getPricingPppIds () {
      const sourceName = this.getPricingSource()
      const deliveryMethod = this.getPricingDeliveryMethod()
      const sourceMap = { Website: 1, QR: 2, Kiosk: 3, POS: 4, App: 5, GLOVO: 6, BOLT: 7, WOLT: 8 }
      const methodMap = {
        EAT_LOCATION: 1,
        SELF_ORDERING: 1,
        PICK_UP: 2,
        MEET_HALF: 2,
        DELIVERY: 3
      }
      return {
        source: sourceMap[sourceName] || 3,
        method: methodMap[deliveryMethod] || 1
      }
    },
    // Discounted qty already in cart, keyed by product_id (for availability remaining).
    // Includes parent products and is_product options (qty = option × parent).
    getCartDiscountedQuantitiesMap (excludeIndex = null) {
      const map = {}
      const addQty = (productId, qty) => {
        const pid = parseInt(productId, 10)
        if (!pid) return
        map[pid] = (map[pid] || 0) + Math.max(1, parseInt(qty, 10) || 1)
      }
      const addLine = (item) => {
        if (!item) return
        if (excludeIndex != null && item.index == excludeIndex) return
        const parentQty = Math.max(1, parseInt(item.quantity, 10) || 1)
        if (this.cartLineHasDiscount(item)) {
          addQty(item.product_id || item.id, parentQty)
        }
        const options = item.options || item.prod_options || []
        if (!Array.isArray(options)) return
        options.forEach((opt) => {
          if (!opt || !this.cartLineHasDiscount(opt)) return
          const optPid = opt.product_id
            || (opt.company_option_value && opt.company_option_value.product_id)
          if (!optPid) return
          const optQty = Math.max(1, parseInt(opt.quantity, 10) || 1) * parentQty
          addQty(optPid, optQty)
        })
      }
      // Prefer myCart.products (kiosk/QR cart payload with discount objects).
      const products = (this.cart && this.cart.myCart && this.cart.myCart.products) || []
      if (products.length) {
        products.forEach(addLine)
        return map
      }
      const parts = (this.cart && this.cart.parts) || []
      parts.forEach((part) => {
        const items = Array.isArray(part.items) ? part.items : []
        items.forEach(addLine)
      })
      return map
    },
    // Catalog product_ids linked from is_product option values that currently
    // carry a campaign discount (soft-gate input for availability).
    collectDiscountedOptionProductIds (product) {
      const ids = []
      const seen = {}
      const push = (id) => {
        const pid = parseInt(id, 10)
        if (!pid || seen[pid]) return
        seen[pid] = true
        ids.push(pid)
      }
      if (!product || !Array.isArray(product.product_options)) return ids
      product.product_options.forEach((option) => {
        ;(option.values || []).forEach((value) => {
          if (!this.optionHasDiscount || !this.optionHasDiscount(value)) return
          const pid = this.optionValueStockProductId(value)
            || (value && value.product_id)
            || (value && value.company_option_value && value.company_option_value.product_id)
          push(pid)
        })
      })
      return ids
    },
    productNeedsDiscountAvailability (product) {
      if (!product) return false
      if (this.productHasDiscount && this.productHasDiscount(product)) return true
      return this.collectDiscountedOptionProductIds(product).length > 0
    },
    /**
     * Soft gate: only poll availability for products/options that already have
     * a campaign discount object from menu/detail (not every category id).
     */
    collectDiscountAvailabilityProductIds (products) {
      const ids = []
      const seen = {}
      const push = (id) => {
        const pid = parseInt(id, 10)
        if (!pid || seen[pid]) return
        seen[pid] = true
        ids.push(pid)
      }
      ;(products || []).forEach((product) => {
        if (!product) return
        if (this.productHasDiscount && this.productHasDiscount(product)) {
          push(product.id)
        }
        this.collectDiscountedOptionProductIds(product).forEach(push)
      })
      return ids
    },
    /**
     * Product ids to check for campaign availability on the current menu/detail view.
     * Always include visible catalog products — menu does not embed discounts, so a
     * soft-gate on "already has discount" would skip the first fetch (and re-fetch
     * after units recover), causing full price / ribbon flicker across refreshes.
     */
    collectMenuDiscountProductIds (products) {
      const ids = []
      const seen = {}
      const push = (id) => {
        const pid = parseInt(id, 10)
        if (!pid || seen[pid]) return
        seen[pid] = true
        ids.push(pid)
      }
      ;(products || []).forEach((product) => {
        if (!product) return
        push(product.id)
        this.collectOptionDiscountProductIds(product).forEach(push)
      })
      return ids
    },
    // All is_product option catalog ids (stock map / COV) — used when applying
    // availability onto option values after a fetch that already targeted them.
    collectOptionDiscountProductIds (product) {
      const ids = []
      const seen = {}
      const push = (id) => {
        const pid = parseInt(id, 10)
        if (!pid || seen[pid]) return
        seen[pid] = true
        ids.push(pid)
      }
      if (!product) return ids
      const rawStocks = product.product_options_stocks || []
      rawStocks.forEach((item) => {
        if (item && typeof item === 'object' && item.product_id != null) {
          push(item.product_id)
        } else if (item != null && typeof item !== 'object') {
          push(item)
        }
      })
      ;(product.product_options || []).forEach((option) => {
        ;(option.values || []).forEach((value) => {
          const fromMap = this.optionValueStockProductId
            ? this.optionValueStockProductId(value)
            : null
          if (fromMap != null) {
            push(fromMap)
            return
          }
          if (value && value.product_id != null) {
            push(value.product_id)
            return
          }
          if (value && value.company_option_value && value.company_option_value.product_id != null) {
            push(value.company_option_value.product_id)
          }
        })
      })
      return ids
    },
    getDiscountUnitsRemaining (product) {
      if (!product) return null
      const productId = product.id != null ? product.id : product.product_id
      const fromAvail = this.productDiscountAvailability[productId]
        || this.productDiscountAvailability[String(productId)]
      if (fromAvail && fromAvail.units_remaining != null) {
        return parseInt(fromAvail.units_remaining, 10)
      }
      if (product.discount && product.discount.units_remaining != null) {
        return parseInt(product.discount.units_remaining, 10)
      }
      return null
    },
    markDiscountPriceChange (target, nextDiscount, nextPrice) {
      if (!target || !target.discount || target.discount.discounted_price == null) return
      const previous = Number(target.discount.discounted_price)
      const next = nextDiscount && nextDiscount.discounted_price != null
        ? Number(nextDiscount.discounted_price)
        : Number(nextPrice)
      if (Number.isFinite(previous) && Number.isFinite(next) && Math.abs(previous - next) >= 0.005) {
        target._discountPriceReviewRequired = true
      }
    },
    // A newly opened details view already presents the refreshed prices for review.
    // Keep reviews for subsequent changes while that view is open and for cart edits.
    prepareDiscountPricesForOpening (product) {
      if (!product || product.in_edit) return
      const remaining = this.getDiscountUnitsRemaining(product)
      if (product.discount && remaining != null && remaining <= 0) {
        this.clearProductMenuDiscount(product)
      }
      const targets = [product]
      ;(product.product_options || []).forEach(option => {
        targets.push(...(option.values || []))
      })
      targets.forEach(target => {
        target._discountPriceReviewRequired = false
        target._discountPriceReviewOpen = false
      })
    },
    requireDiscountPriceReview (target) {
      if (!target || !target._discountPriceReviewRequired) return false
      if (!target._discountPriceReviewOpen) {
        // A primitive token keeps its identity when Vue proxies products and popup clones.
        const review = Symbol('discount-price-review')
        target._discountPriceReviewOpen = review
        Swal.fire({
          title: this.$t('addOrder.discountPriceChanged'),
          target: document.getElementById('swal-template'),
          customClass: { container: this.json && this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall' }
        }).then(() => {
          // Availability refreshes may replace the popup with a shallow clone while the alert is open.
          const candidates = [target, this.currentProductInPopup, ...(this.products || [])]
          candidates.forEach((candidate) => {
            if (candidate && candidate._discountPriceReviewOpen === review) {
              candidate._discountPriceReviewRequired = false
              candidate._discountPriceReviewOpen = false
            }
          })
        })
      }
      return true
    },
    applyDiscountAvailabilityToProduct (product, availability) {
      if (!product || !availability) return product
      // Preserve the cart's claim until the API validates an edited cart line.
      if (product.in_edit && product.discount && (!availability.available || !availability.discount)) return product
      const discount = availability.available ? availability.discount : null
      const price = availability.price != null ? availability.price : product.price
      this.markDiscountPriceChange(product, discount, price)
      if (availability.price != null) product.price = availability.price
      product.discount = discount || null
      product.campaign_discount = discount && discount.campaigns ? { campaigns: discount.campaigns } : null
      if (discount && availability.units_remaining != null) {
        discount.units_remaining = availability.units_remaining
      }
      return product
    },
    applyDiscountAvailabilityToOptionValue (value, availability) {
      if (!value || !availability) return value
      const discount = availability.available ? availability.discount : null
      const price = availability.price != null ? availability.price : this.getOptionListUnitPriceWithoutSgr(value)
      this.markDiscountPriceChange(value, discount, price)
      // Details can contain a payable price in `price`; restore the list price before clearing a promo.
      value.price = price
      if (value.price_details) value.price_details.price = price
      value.discount = discount || null
      value.campaign_discount = discount && discount.campaigns ? { campaigns: discount.campaigns } : null
      if (discount && availability.units_remaining != null) discount.units_remaining = availability.units_remaining
      return value
    },
    // True when the campaign discount is capped by unit limits (not unlimited).
    discountHasUnitLimit (discount) {
      if (!discount || typeof discount !== 'object') return false
      if (discount.number_of_units != null || discount.units_remaining != null) return true
      const campaigns = discount.campaigns
      if (!Array.isArray(campaigns)) return false
      return campaigns.some((c) => c && (c.number_of_units != null || c.units_remaining != null))
    },
    applyDiscountAvailabilityToProductOptions (product, discounts) {
      if (!product || !discounts || !Array.isArray(product.product_options)) return
      product.product_options.forEach((option) => {
        ;(option.values || []).forEach((value) => {
          const pid = this.optionValueStockProductId(value)
            || (value && value.product_id)
            || (value && value.company_option_value && value.company_option_value.product_id)
          if (pid == null) return
          const avail = discounts[pid] || discounts[String(pid)]
          if (!avail) return
          this.applyDiscountAvailabilityToOptionValue(value, avail)
        })
      })
    },
    /**
     * Stamp product campaign_discount from discount.campaigns for cart claim.
     * Exhausted/stale promos require a price review before a new full-price add.
     */
    stampAndValidateProductDiscountForCart (product) {
      if (!product) return true
      const remaining = this.getDiscountUnitsRemaining(product)
      if (product.discount && remaining != null && remaining <= 0 && !product.in_edit) {
        this.clearProductMenuDiscount(product)
        product._discountPriceReviewRequired = true
      }
      if (this.requireDiscountPriceReview(product)) return false
      if (!this.productHasDiscount(product)) {
        product.discount = null
        product.campaign_discount = null
        return true
      }

      // Price-list resolution sets edit_price; that must not block campaign claim on the API.
      product.edit_price = false

      if (product.discount && product.discount.campaigns && !product.campaign_discount) {
        product.campaign_discount = { campaigns: product.discount.campaigns }
      }

      const qty = Math.max(1, parseInt(product.quantity, 10) || 1)
      if (remaining != null && qty > remaining) {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
        Swal.fire({
          title: this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'),
          target: document.getElementById('swal-template'),
          customClass: { container: className }
        })
        return false
      }
      return true
    },
    /** Remove campaign promo from a menu/cart product payload (keeps catalog price). */
    clearProductMenuDiscount (product) {
      if (!product) return
      if (product.discount) {
        this.$delete ? this.$delete(product, 'discount') : delete product.discount
      }
      product.discount = null
      product.campaign_discount = null
      const pid = product.id != null ? product.id : product.product_id
      if (pid != null && this.productDiscountAvailability) {
        const key = pid
        const strKey = String(pid)
        if (this.productDiscountAvailability[key]) {
          this.$set
            ? this.$set(this.productDiscountAvailability, key, {
              ...this.productDiscountAvailability[key],
              available: false,
              discount: null,
              units_remaining: 0,
              reason: 'campaign_discount_unavailable'
            })
            : (this.productDiscountAvailability[key] = {
              ...this.productDiscountAvailability[key],
              available: false,
              discount: null,
              units_remaining: 0,
              reason: 'campaign_discount_unavailable'
            })
        }
        if (this.productDiscountAvailability[strKey]) {
          this.productDiscountAvailability[strKey] = {
            ...this.productDiscountAvailability[strKey],
            available: false,
            discount: null,
            units_remaining: 0,
            reason: 'campaign_discount_unavailable'
          }
        }
      }
    },
    /** After add/edit failure or unit consume — refresh menu so ribbon matches reality. */
    refreshMenuDiscountsAfterCartChange (productIds = null) {
      const ids = productIds && productIds.length
        ? productIds
        : (this.currentProductInPopup ? [this.currentProductInPopup.id] : null)
      this.getDiscountsForProducts(null, ids)
    },
    /**
     * Ensure selected product-backed options carry product_id + campaign_discount
     * for cart/reservation. Returns false if a selected discounted option exceeds units.
     */
    stampAndValidateOptionDiscountsForCart (product) {
      if (!product || !Array.isArray(product.product_options)) return true
      const parentQty = Math.max(1, parseInt(product.quantity, 10) || 1)
      let ok = true
      let unitsExceeded = false

      product.product_options.forEach((option) => {
        ;(option.values || []).forEach((value) => {
          const selected = option.type === 'radio'
            ? (option.checked === value.id || value.checked)
            : !!value.checked
          if (!selected) return

          const pid = this.optionValueStockProductId(value)
            || (value && value.product_id)
            || (value && value.company_option_value && value.company_option_value.product_id)
          if (pid != null) {
            value.product_id = parseInt(pid, 10)
          }

          if (this.requireDiscountPriceReview(value)) {
            ok = false
            return
          }
          if (!this.optionHasDiscount || !this.optionHasDiscount(value)) {
            value.campaign_discount = null
            return
          }

          if (value.discount && value.discount.campaigns && !value.campaign_discount) {
            value.campaign_discount = { campaigns: value.discount.campaigns }
          }

          const remaining = this.getDiscountUnitsRemaining({ id: value.product_id, discount: value.discount })
          if (remaining != null && remaining <= 0) {
            value.price = this.getOptionListUnitPriceWithoutSgr(value)
            if (value.price_details) value.price_details.price = value.price
            value.discount = null
            value.campaign_discount = null
            value._discountPriceReviewRequired = true
            this.requireDiscountPriceReview(value)
            ok = false
            return
          }
          const optQty = (option.type === 'checkbox' && value.company_option_value && value.company_option_value.allow_quantity)
            ? Math.max(1, parseInt(value.quantity, 10) || 1)
            : 1
          const needed = optQty * parentQty
          if (remaining != null && needed > remaining) {
            ok = false
            unitsExceeded = true
          }
        })
      })

      if (unitsExceeded) {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
        Swal.fire({
          title: this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'),
          target: document.getElementById('swal-template'),
          customClass: { container: className }
        })
      }
      return ok
    },
    cartLineIsUnorderable (prod) {
      if (!prod) return false
      if (prod.unorderable) return true
      const err = prod.campaign_discount_error
      return err === 'campaign_discount_unavailable' || err === 'units_limit_reached'
    },
    /**
     * True when update-cart errors allow payment/cart success to continue.
     * Price-change notices are handled before continuing payment.
     * Hard campaign/stock errors = not ok.
     */
    cartValidationErrorsAreClear (errors) {
      if (Array.isArray(errors)) {
        return errors.length === 0
      }
      if (!errors || typeof errors !== 'object') {
        return true
      }
      if (errors.campaign_discount_invalid || errors.no_availability === true || errors.close || errors.shopping_cart_id) {
        return false
      }
      // Ignore obsolete soft-only notice
      const keys = Object.keys(errors)
      if (keys.length === 1 && keys[0] === 'campaign_discount_updated') {
        return true
      }
      if (keys.length === 0) {
        return true
      }
      return false
    },
    /**
     * Stop checkout for unavailable claims or corrected campaign prices.
     * Apply the server cart and require a review before the customer retries.
     */
    handleUnavailableCartValidation (response, options = {}) {
      if (!response || !response.data) return false
      const payload = response.data
      const data = payload.data || {}
      const errors = payload.errors
      const errorsObj = errors && !Array.isArray(errors) ? errors : null
      const noAvail = data.no_availability
      const hasDiscountError = !!(errorsObj && (
        errorsObj.campaign_discount_invalid ||
        errorsObj.no_availability === true
      ))
      const hasUnorderableNoAvail = Array.isArray(noAvail) && noAvail.some((row) => {
        if (!row) return false
        if (row.unorderable) return true
        const reason = row.reason || ''
        return reason === 'campaign_discount_unavailable' ||
          reason === 'units_limit_reached'
      })
      const cartProducts = (data.myCart && data.myCart.products) || []
      const hasUnorderableInCart = cartProducts.some((p) => this.cartLineIsUnorderable(p))
      const updatedCampaign = data.updated_campaign_products || payload.updated_campaign_products || []
      const hasUnorderableUpdated = Array.isArray(updatedCampaign) && updatedCampaign.some((row) => row && row.unorderable)

      const isHardUnavailable = hasDiscountError || hasUnorderableNoAvail || hasUnorderableInCart || hasUnorderableUpdated
      if (!isHardUnavailable) {
        const pricesChanged = Array.isArray(updatedCampaign) && updatedCampaign.some((row) => {
          return row && row.previous_price != null && row.price != null &&
            Math.abs(Number(row.previous_price) - Number(row.price)) >= 0.005
        })
        if (!pricesChanged && !(errorsObj && errorsObj.campaign_discount_updated)) return false
        if (data.myCart || data.shopping_cart_id || data.order_id) {
          this.cart = data
          if (typeof this.modificationsInCart === 'function') this.modificationsInCart()
        }
        if (options.closePayment !== false) {
          this.selectedPaymentMethod = ''
          this.onePaymentAllreadyPicked = false
          this.showPaymentModal = false
        }
        if (options.showCart !== false && typeof this.showCart === 'function') this.showCart()
        Swal.fire({
          title: this.$t('addOrder.campaignDiscountUpdated'),
          target: document.getElementById('swal-template'),
          customClass: { container: this.json && this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall' }
        })
        return true
      }

      if (data.myCart || data.shopping_cart_id || data.order_id) {
        this.cart = data
        if (typeof this.modificationsInCart === 'function') {
          this.modificationsInCart()
        }
      }

      if (Array.isArray(noAvail) && noAvail.length) {
        this.setIndisponibleFromNoAvailability(noAvail)
        if (typeof this.checkProductIndisponibility === 'function') {
          this.checkProductIndisponibility(null, true)
        }
        this.stampUnorderableFromNoAvailability(noAvail)
      }

      this.markUnorderableCartLinesFromResponse(payload)
      if (this.cart && this.cart.myCart && Array.isArray(this.cart.myCart.products)) {
        this.cart.myCart.products.forEach((prod) => {
          if (!this.cartLineIsUnorderable(prod)) return
          if (this.$set) {
            this.$set(prod, 'out_of_stock', true)
            this.$set(prod, 'product_is_indisponible', true)
            this.$set(prod, 'unorderable', true)
          } else {
            prod.out_of_stock = true
            prod.product_is_indisponible = true
            prod.unorderable = true
          }
        })
      }

      if (typeof this.getDiscountsForProducts === 'function') {
        this.getDiscountsForProducts()
      }

      if (options.closePayment !== false) {
        this.selectedPaymentMethod = ''
        this.onePaymentAllreadyPicked = false
        this.showPaymentModal = false
      }
      if (options.showCart !== false && typeof this.showCart === 'function') {
        this.showCart()
      }

      const reasonFromNoAvail = Array.isArray(noAvail) && noAvail[0] && noAvail[0].reason
      const isUnitsLimit = reasonFromNoAvail === 'units_limit_reached' ||
        (cartProducts || []).some((p) => p && p.campaign_discount_error === 'units_limit_reached') ||
        (Array.isArray(updatedCampaign) && updatedCampaign.some((r) => r && r.reason === 'units_limit_reached'))
      const className = this.json && this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
      Swal.fire({
        title: isUnitsLimit
          ? (this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'))
          : (this.$t('addOrder.campaignDiscountUnavailable') || this.$t('addOrder.productUnavailable')),
        target: document.getElementById('swal-template'),
        customClass: { container: className }
      })
      return true
    },
    /** Mark cart lines from no_availability rows (stock-like / campaign hard fail). */
    stampUnorderableFromNoAvailability (list) {
      if (!Array.isArray(list) || !this.cart || !this.cart.myCart || !Array.isArray(this.cart.myCart.products)) {
        return
      }
      list.forEach((row) => {
        if (!row) return
        const reason = row.reason || 'campaign_discount_unavailable'
        const shouldMark = !!row.unorderable ||
          reason === 'campaign_discount_unavailable' ||
          reason === 'units_limit_reached'
        if (!shouldMark) return

        this.cart.myCart.products.forEach((prod) => {
          const byItemId = row.order_part_item_id != null &&
            prod.order_part_item_id == row.order_part_item_id
          const byProductId = row.product_id != null &&
            (prod.id == row.product_id || prod.product_id == row.product_id) &&
            (row.index == null || prod.index == row.index)
          if (!byItemId && !byProductId) return

          if (this.$set) {
            this.$set(prod, 'unorderable', true)
            this.$set(prod, 'campaign_discount_error', reason)
            this.$set(prod, 'out_of_stock', true)
            this.$set(prod, 'product_is_indisponible', true)
          } else {
            prod.unorderable = true
            prod.campaign_discount_error = reason
            prod.out_of_stock = true
            prod.product_is_indisponible = true
          }
        })
      })
    },
    markUnorderableCartLinesFromResponse (responseData) {
      if (!responseData || !this.cart || !this.cart.myCart || !Array.isArray(this.cart.myCart.products)) {
        return
      }
      const updated = responseData.updated_campaign_products ||
        (responseData.data && responseData.data.updated_campaign_products) ||
        []
      const markProd = (prod, reason) => {
        if (this.$set) {
          this.$set(prod, 'unorderable', true)
          this.$set(prod, 'campaign_discount_error', reason || 'campaign_discount_unavailable')
          this.$set(prod, 'out_of_stock', true)
          this.$set(prod, 'product_is_indisponible', true)
        } else {
          prod.unorderable = true
          prod.campaign_discount_error = reason || 'campaign_discount_unavailable'
          prod.out_of_stock = true
          prod.product_is_indisponible = true
        }
      }
      if (!updated.length) {
        // Still mirror unorderable flags already present on myCart products from API.
        this.cart.myCart.products.forEach((prod) => {
          if (this.cartLineIsUnorderable(prod)) {
            markProd(prod, prod.campaign_discount_error)
          }
        })
        return
      }
      updated.forEach((row) => {
        if (!row || !row.unorderable) return
        this.cart.myCart.products.forEach((prod) => {
          const indexMatch = row.index == null || prod.index == row.index
          if (!indexMatch) return

          const isOptionRow = row.type === 'option'
          const productMatch = !isOptionRow && prod.id == row.id
          let optionMatch = false
          if (isOptionRow) {
            const options = prod.options || prod.prod_options || []
            optionMatch = Array.isArray(options) && options.some((opt) => {
              if (!opt) return false
              if (row.option_id != null && (opt.id == row.option_id || opt.option_value_id == row.option_id)) {
                return true
              }
              return opt.product_id != null && opt.product_id == row.id
            })
          }

          if (!productMatch && !optionMatch) return
          markProd(prod, row.reason || 'campaign_discount_unavailable')
        })
      })
    },
    getDiscountsForProducts (callback, productIds = null, excludeCartIndex = null) {
      const sources = []
      const pushSource = (prod) => {
        if (!prod || sources.indexOf(prod) !== -1) return
        sources.push(prod)
      }

      if (productIds && productIds.length) {
        productIds.forEach((id) => {
          if (this.currentProductInPopup && this.currentProductInPopup.id == id) {
            pushSource(this.currentProductInPopup)
          }
          if (Array.isArray(this.products)) {
            const fromList = this.products.find(p => p && p.id == id)
            if (fromList) pushSource(fromList)
          }
          // Explicit id with no in-memory product still needs an availability probe.
          pushSource({ id: parseInt(id, 10) })
        })
      } else if (Array.isArray(this.products)) {
        this.products.forEach(pushSource)
      }

      if (this.currentProductInPopup) {
        pushSource(this.currentProductInPopup)
      }

      const ids = this.collectMenuDiscountProductIds(sources)

      if (!ids.length || !this.json || !this.json.company_id || !this.locationTrueId) {
        if (callback) callback()
        return
      }
      const ppp = this.getPricingPppIds()
      const data = this.appendPricingContext({
        company_id: this.json.company_id,
        location_true_id: this.locationTrueId,
        source: ppp.source,
        method: ppp.method,
        products_ids: ids,
        cart_quantities: this.getCartDiscountedQuantitiesMap(excludeCartIndex),
        order_id: (this.cart && this.cart.order_id) || null,
        shopping_cart_id: (this.cart && this.cart.shopping_cart_id) || this.shopping_cart_id || null
      })
      this.apiRequest('/noauth/get-products-discounts', 'POST', data, (response) => {
        const discounts = response && response.data && response.data.status &&
          response.data.data && response.data.data.discounts
        if (!discounts || typeof discounts !== 'object' || Array.isArray(discounts)) {
          // A failed refresh is not evidence that every campaign disappeared.
          if (callback) callback(null)
          return
        }
        this.productDiscountAvailability = { ...this.productDiscountAvailability, ...discounts }

        if (Array.isArray(this.products)) {
          this.products = this.products.map((prod) => {
            const avail = discounts[prod.id] || discounts[String(prod.id)]
            // A partial reply says nothing about products outside that reply.
            if (!avail) return prod
            return this.applyDiscountAvailabilityToProduct(prod, avail)
          })
        }

        if (this.currentProductInPopup) {
          const avail = discounts[this.currentProductInPopup.id] || discounts[String(this.currentProductInPopup.id)]
          if (avail) {
            this.applyDiscountAvailabilityToProduct(this.currentProductInPopup, avail)
          }
          this.applyDiscountAvailabilityToProductOptions(this.currentProductInPopup, discounts)
          // Force Vue 2 reactivity after in-place mutate
          this.currentProductInPopup = Object.assign({}, this.currentProductInPopup)
        }

        if (callback) callback(discounts)
      })
    },
    resizeProdImage (imgUrl, sizeInPx = 800) {
      if (!imgUrl) {
        return 'https://cdntaptasty.com/dynamic-product-image-resize/' + sizeInPx;
      }
      if (typeof imgUrl === 'string') {
        // Caută pattern-ul dynamic-product-image-resize/<număr>/
        const regex = /dynamic-product-image-resize\/(\d+)\//;

        if (regex.test(imgUrl)) {
          // Înlocuiește numărul cu sizeInPx
          imgUrl = imgUrl.replace(regex, `dynamic-product-image-resize/${sizeInPx}/`);
        }

        return imgUrl;
      }
      return 'https://cdntaptasty.com/dynamic-product-image-resize/' + sizeInPx;
    },
    callFromOptions (functionName, params) {
      this[functionName](params)
    },
    onCreatedAfterLogin () {
      this.onCreatedAfterLoginFlag = true
      if (this.isUsingCashMachine) {
        if (!this.socket.connected) {
          this.socket.connect()
        }

        this.socket.on('OPEN', (data) => {
          console.log('OPEN')
          console.log(data)
        });    

        this.socket.on('EMPTIED', (data) => {
          console.log('EMPTIED')
          this.loader = false
        });    

        this.socket.on('NOTE_STORED_IN_PAYOUT', (data) => {
          console.log('NOTE_STORED_IN_PAYOUT')
          console.log(data)
        });

        this.socket.on('READ_NOTE', (data) => {
          console.log('READ_NOTE')
          console.log()
          if (data && data.data && data.data.total) {
            this.insertedMoneyInCashMachine = (data.data.total / 100)
          }
        });

        this.socket.on('COMPLETE_ORDER', (data) => {
          console.log('COMPLETE_ORDER')
          console.log(data)
          this.customMsgCashMachine = null
          this.showLoaderCompleteCashMachine = true
          this.completeOrder('cash_machine')
        });

        this.socket.on('TOO_MANY', (data) => {
          this.showCashMachineModal = false
          this.customMsgCashMachine = null
          console.log('TOO_MANY')
          console.log(data)
        });

        this.socket.on('MONEY_BACK', (data) => {
          this.customMsgCashMachine = 'Aparatul nu va poate da rest. Va va da banii inapoi!';
          console.log('MONEY_BACK')
          console.log(data)
        });
      }

      if (this.withVivaWallet) {
        window.addEventListener('message', (event) => {
            // if (event.origin !== 'http://localhost') return;
            const data = event.data
            // Reactionam DOAR la raspunsurile reale de la Viva Wallet (au `status` si
            // nu sunt mesaje de checkFiscalNet). Alte postMessage-uri straine nu mai
            // deblocheaza butoanele (inainte se deblocau la ORICE mesaj primit).
            if (data && typeof data === 'object' && data.status !== undefined && data.type !== 'checkFiscalNetResult') {
              // A venit raspuns de la Viva => oprim timeout-ul de siguranta.
              if (this.vivaLockTimeout) {
                clearTimeout(this.vivaLockTimeout)
                this.vivaLockTimeout = null
              }
              // Logam MEREU raspunsul primit inapoi de la Viva Wallet (succes SAU eroare).
              this.kioskLog({
                order_id: (this.dataToSendToVivaWallet && this.dataToSendToVivaWallet.order_id) ? this.dataToSendToVivaWallet.order_id : null,
                stage: 'viva_response',
                event: (data.status === 'success') ? 'received_success' : 'received_error',
                message: data.message || null,
                data_to: this.dataToSendToVivaWallet || null,
                data_from: data
              })
              if (data.status === "success") {
                // Succes: completeOrderQrVivaWallet deblocheaza la final (succes SAU eroare).
                this.completeOrderQrVivaWallet(data);
              } else {
                // Orice raspuns non-success de la Viva (ex: (-4) USER_CANCEL, fail,
                // decline) => stergem/revenim comanda ramasa in DRAFT_AWAITING_PAYMENT
                // (sa nu stea agatata) si deblocam butoanele ca sa se poata reincerca.
                // Native-ul trimite un raspuns DEFINITIV per tranzactie, nu mesaje
                // intermediare, deci e sigur sa facem asta aici.
                this.cancelVivaOrder()
                this.resetPaymentLock()
              }
            }
        })
      }

      if (this.json.type == 'Kiosk' && this.DBfiscalNet && this.checkFiscalNet) {
        window.addEventListener('message', (event) => {
          const data = event.data;
          if (!data) {
            return;
          }
          if (data.type === 'checkFiscalNetResult') {
            const status = Number(data.status);
            if (status === 1) {
              console.log('FiscalNet este online');
            } else {
              console.log('FiscalNet este offline');
              this.blockKioskFiscalError = true
              this.lastOrderNumberForFiscalError = null
              this.fiscalErrorInfo = null
              this.fiscalErrorCase = null
            }
          }
        });
      }

      // Raspunsul Electron pentru butonul secret "Deschide FiscalNet" (focusFiscalNet).
      // Electron trimite raspunsul ca JSON string prin fereastra parinte.
      if (this.json.type == 'Kiosk') {
        window.addEventListener('message', (event) => {
          // Acceptam raspunsul numai de la fereastra parinte.
          if (event.source !== window.parent) {
            return;
          }
          let message = event.data;
          if (typeof message === 'string') {
            try {
              message = JSON.parse(message);
            } catch (e) {
              return;
            }
          }
          if (
            !message ||
            message.action !== 'focusFiscalNetResult' ||
            message.requestId !== this.fiscalNetRequestId
          ) {
            return;
          }
          if (message.ok) {
            console.log('FiscalNet adus in prim-plan:', message.data && message.data.processId)
            this.secretMenuLog('focus_fiscalnet_success', { data_from: message })
          } else {
            console.error(
              'FiscalNet nu a putut fi activat:',
              message.error && message.error.code,
              message.error && message.error.message
            )
            this.secretMenuLog('focus_fiscalnet_fail', { data_from: message })
          }
        });
      }

      clearTimeout(this.timeoutGetCompanyData)
      this.timeoutGetCompanyData = setTimeout(()=>{
        this.getCompanyData()
      }, 60000 * 5) // x mins
    },
    cashMachineEmptyAll () {
      this.secretMenuLog('cash_empty_all')
      this.loader = true
      this.socket.emit('empty_all')
    },
    cashMachinePay () {
      this.secretMenuLog('cash_start_pay')
      this.socket.emit('start_pay', null)
    },
    cashMachineStop () {
      this.secretMenuLog('cash_stop_pay')
      this.socket.emit('stop_pay')
    },
    cashMachinePayout () {
      this.secretMenuLog('cash_payout')
      this.socket.emit('payout')
      this.showCashMachineModal = false
      this.customMsgCashMachine = null
      this.onePaymentAllreadyPicked = false
    },
    async cashMachineGetAmount () {
      this.secretMenuLog('cash_get_amount')
      this.socket.emit('get_amount_money_from_machine', async (res) => {
        if (res) {
          let totalSum = 0;
          let tableData = Object.values(res)
            .map((item) => {
              let totalValue = (item.value * item.denomination_level) / 100;
              totalSum += totalValue; // Adăugăm la suma totală

              return `<tr>
                        <td width="33%">${item.denomination_level}</td>
                        <td width="33%">${item.value / 100} ${item.country_code}</td>
                        <td width="33%">${totalValue.toFixed(2)} ${item.country_code}</td>
                      </tr>`;
            })
            .join("");

          // Adăugăm rândul cu totalul final
          tableData += `<tr style="font-weight: bold;">
                          <td colspan="2">Total:</td>
                          <td>${totalSum.toFixed(2)} ${Object.values(res)[0]?.country_code || ''}</td>
                        </tr>`;

          let tableHtml = `
            <style>
              table {
                width: 100%;
                border-collapse: collapse;
              }
              
              th, td {
                border: 1px solid #ccc;
                padding: 8px;
                text-align: center;
              }

              th {
                background-color: #f4f4f4;
              }

              tr:nth-child(even) {
                background-color: #f9f9f9;
              }

              tr:last-child {
                font-weight: bold;
                background-color: #e0e0e0;
              }
            </style>

            <table>
              <thead>
                <tr>
                  <th>Numar bancnote</th>
                  <th>Valoare</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                ${tableData}
              </tbody>
            </table>
          `;
          let className = this.json.type == 'Kiosk' ? 'bigSwall bigZIndex' : 'smallSwall';
          Swal.fire({
            title: "Bancnote",
            html: tableHtml,
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            },
            confirmButtonText: "OK",
          });
        }
      })
    },
    maskPhoneNumber(phoneNumber) {
      if (phoneNumber) {
        phoneNumber = phoneNumber.toString();
        if (phoneNumber.length >= 3) {
          return phoneNumber.slice(0, -3) + '***';
        } else {
          return '*'.repeat(phoneNumber.length);
        }
      }
    },
    openShowSplashScreenModal () {
      this.showSplashScreenModal = true;
      this.searchText = ''
    },
    onSwiperTutorial (swiper) {
      this.swiperTutorial = swiper
    },
    handleKeyUpClientModal (event) {
      if (event.key === 'Shift') {
        // this.shiftPressed = false;
        this.shiftPressed = true;
        return;
      }
      if (event.key.length === 1) {
        if (this.shiftPressed) {
          this.keysForHandleKeyUpClientModal += event.key.toUpperCase()
        } else {
          this.keysForHandleKeyUpClientModal += event.key
        }
      }
      this.shiftPressed = false;

      if (event.key == 'Enter') {
        console.log(this.keysForHandleKeyUpClientModal)
        let result = this.keysForHandleKeyUpClientModal
        this.keysForHandleKeyUpClientModal = ''

        result = atob(result)
        result = result.split('#')
        let user_id = result[0].substring(1)
        user_id = user_id.slice(0, -2)
        user_id = atob(user_id)
        user_id = JSON.parse(user_id).id
        let timestamp = result[1].slice(0, -1)
        let timestampNow = Math.floor((new Date()).getTime() / 1000)

        if (timestampNow - timestamp <= 600) {
          this.searchForClient(user_id)
        } else {
          this.errorQrScan()
        }
      }
      // event.preventDefault()

      // // Get the pasted data via clipboardData API
      // let clipboardData = event.clipboardData || window.clipboardData;
      // let pastedData = clipboardData.getData('Text');
    },
    async selectClientAndAddToOrder(client, isNew) {
      // seba
      if (client && !isNew && 0) { // STOP REQUEST FROM MIRON
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'

        let $html = '<h2>'+ this.$t('general.walletAppNot2') +'<h2>'
        // Swal blocant
        Swal.fire({
          title: this.$t('general.walletAppNot1'),
          html: $html,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          customClass: {
            container: className,
          },
          didOpen: () => {
            Swal.showLoading()
          }
        })

        let sendResp = await new Promise((resolve) => {
          this.apiRequest('/two_f_auth_send_code_to_app', 'POST', {
            token: this.token,
            company_id: this.json.company_id,
            unique_key: this.json.id + '',
            table_id: this.json.id,
            user_id: client.id,
          }, resolve)
        })

        if (!sendResp || sendResp.data.status === false) {
          // Swal.close()
          Swal.fire({
            icon: 'error',
            title: this.$t('general.walletAppNotErr1'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            },
          })
          return
        }

        let twoFactorId = sendResp.data.data.two_factor_auth_id


        let approved = false
        let attempts = 0

        const checkStatus = async () => {
          attempts++

          let verifyResp = await new Promise((resolve) => {
            this.apiRequest('/verify_two_f_auth', 'POST', {
              token: this.token,
              unique_key: this.json.id + '',
              company_id: this.json.company_id,
              two_factor_auth_id: twoFactorId
            }, resolve)
          })

          if (!verifyResp || verifyResp.data.status === false) {
            Swal.close()
            Swal.fire({
              icon: 'error',
              // title: this.$t('addOrder.errorFinishOrderMsg'),
              title: this.$t('general.walletAppNotErr2'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              },
            }).then( (result) => {
              // window.location.href = this.qr_link;
              // return 0;
            })
            return
          }

          let data = verifyResp.data.data

          if (data.is_approved) {
            approved = true
            Swal.close()

            this.continueSetClient(client, isNew)

            return
          }

          if (data.is_rejected) {
            Swal.close()
            Swal.fire({
              icon: 'error',
              // title: this.$t('addOrder.errorFinishOrderMsg'),
              title: this.$t('general.walletAppNotErr3'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              },
            })
            return
          }

          if (!approved) {
            setTimeout(checkStatus, 10000) // 10 sec
          }
        }

        checkStatus()
      } else {
        this.continueSetClient(client, isNew)
      }
    },
    continueSetClient(client, isNew) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        order_id: this.cart.order_id
      }

      if (client) {
        data.user_id = client.id
      }

      this.apiRequest('/order/set-user', 'POST', data, (response) => {
        if (response && response.data.status === true) {
          this.client = client
          this.new_client = isNew

          if (response.data.data) {
            this.cart = response.data.data
            this.modificationsInCart()
          }
        }
      })
    },
    removeClient () {
       // Call to remove loyalty points
      this.useOrRemoveLoyaltyPoints(0); 

      this.selectClientAndAddToOrder (null, null)
      this.order_phone = null
      this.order_phone_country_code = null
      this.$nextTick(() => {
        if (this.$refs.modal_bg && this.$refs.modal_bg.focus) {
          this.$refs.modal_bg.focus()
        }
        // document.querySelector(".clientModal .payment__buttons").focus()
        setTimeout(() => {
          if (this.$refs.modal_bg && this.$refs.modal_bg.focus) {
            this.$refs.modal_bg.focus()
          }
          // document.querySelector(".clientModal .payment__buttons").focus()
        }, 1000)
      })
    },
    errorQrScan () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.qrError'),
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      });
    },
    searchForClient (user_id = null) {
      if (user_id) {
        var data2 = {
          token: this.token,
          company_id: this.json.company_id,
          from_kiosk: 1,
          search: user_id
        }
        this.apiRequest('/search-by-id', 'GET', data2, (response) => {
          if (response && response.data.status === true && response.data.data.clients.length) {
            this.selectClientAndAddToOrder(response.data.data.clients[0], false)
          } else {
            this.errorQrScan()
          }
        })
      } else {
        if (this.phone_to_send != '') {
          const phoneInput = document.getElementById('phone_to_send');
          if (this.resultsPhone && this.resultsPhone.isValid) {
            this.order_phone = this.resultsPhone.formatNational.replace(/\s+/g, '');
            this.order_phone_country_code = this.resultsPhone.countryCallingCode
          } else {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.phoneError'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
            return 0;
          }
          
          var data2 = {
            token: this.token,
            company_id: this.json.company_id,
            from_kiosk: 1,
            search: this.order_phone
          }
          this.phone_to_send = ''
          this.keyboard.clearInput()
          this.apiRequest('/search-by-phone', 'GET', data2, (response) => {
            if (response && response.data.status === true) {
              if (response.data.data.clients.length) {
                this.selectClientAndAddToOrder(response.data.data.clients[0], false)
              } else {
                this.selectClientAndAddToOrder(null, true)
              }
            }
          })
        }
      }
    },
    searchForClientMobile () {
      if (this.resultsPhone && this.resultsPhone.isValid) {
        this.order_phone = this.resultsPhone.formatNational
        this.order_phone_country_code = this.resultsPhone.countryCallingCode
        var data2 = {
          token: this.token,
          company_id: this.json.company_id,
          from_kiosk: 1,
          search: this.phone_to_send
        }
        this.phone_to_send = ''
        this.apiRequest('/search-by-phone', 'GET', data2, (response) => {
          if (response && response.data.status === true) {
            if (response.data.data.clients.length) {
              this.selectClientAndAddToOrder(response.data.data.clients[0], false)
            } else {
              this.selectClientAndAddToOrder(null, true)
            }
          }
        })
      } else {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        Swal.fire({
          title: this.$t('addOrder.phoneError'),
          target: document.getElementById('swal-template'),
          customClass: {
            container: className,
          }
        });
        return 0;
      }
    },
    openCuiModal () {
      this.cui = ''
      this.clearKeyBoard()
      this.activeKeyboard = true
      this.showCuiModal = true
      this.showPaymentModal = false //ForKeyboard
    },
    changeCui () {
      this.cui = this.cuiText
      this.closeCuiModal()
    },
    closeCuiModal () {
      this.showCuiModal = false
      this.showPaymentModal = true
      this.activeKeyboard = false
      this.keyboard.clearInput()
      this.cuiText = ''
    },
    changePhone () {
      this.phone_to_send = ''
      this.clearKeyBoard()
      this.keyForPhone = 1
      if (this.json.type != 'Kiosk') {
        this.activeKeyboard = true
      }
    },
    closeSettingsModal () {
      this.secretMenuLog('close_settings_modal')
      this.clearKeyBoard()
      this.restart()
    },
    // True cand exista o problema de plata / comanda in aer: plata deja pornita,
    // asteptam finalizarea comenzii, sau ecranul negru de eroare (card platit dar
    // cloud/fiscal a esuat). In aceste stari NU lasam reload / close, ca sa nu
    // pierdem comanda.
    isPaymentProblemActive () {
      return !!(this.blockKioskFiscalError || this.onePaymentAllreadyPicked || this.showCompleteWaitingModal)
    },
    // Log dedicat pentru optiunile din meniul secret (settings). Trece prin acelasi
    // endpoint /noauth/kiosk-log ca restul logurilor de kiosk. Fire-and-forget.
    secretMenuLog (action, extra) {
      extra = extra || {}
      this.kioskLog({
        order_id: extra.order_id || (this.cart && this.cart.order_id) || null,
        stage: 'secret_menu',
        event: action || null,
        message: extra.message || null,
        data_to: extra.data_to || null,
        data_from: extra.data_from || null
      })
    },
    // Swall generic de eroare + log, pentru requesturile care esueaza.
    // `action` = requestul/actiunea unde a dat eroarea (ex: '/self-ordering-refrash').
    // `response` = raspunsul primit de la apiRequest (null cand e eroare de retea).
    // `friendlyMessage` (optional) = mesaj pentru client (ex: "Produsul nu a putut
    //   fi incarcat"). Cand exista, il aratam ca text principal, iar apelul de unde
    //   vine eroarea il aratam in footer (ca sa se stie de la ce apel a picat).
    // Logam MEREU in kiosk_logs (la fel ca restul logurilor de kiosk). Swall-ul il
    // aratam doar daca nu e activ ecranul negru de "no internet" (ca sa nu suprapunem
    // doua mesaje pentru aceeasi problema de conexiune).
    generalErrorSwal (action, response, friendlyMessage) {
      var httpStatus = (response && response.status) ? response.status : null
      // Evitam logul DUBLU: apiRequest logheaza deja CENTRAL orice request esuat
      // (fail de transport -> api_request_fail; 200 cu eroare -> api_request_app_error).
      // Aici logam DOAR cazul rar in care raspunsul NU a fost prins de logica
      // centrala (exista, dar nu e clasificat ca eroare aplicativa), ca sa nu
      // pierdem niciun log. In rest, doar aratam swall-ul.
      if (response && !this.isErrorResponse(response)) {
        this.kioskLog({
          stage: 'general_error',
          event: action || null,
          http_status: httpStatus,
          message: friendlyMessage || null,
          data_from: response.data || response
        })
      }
      // Eroarea de retea (offline) are deja ecranul negru dedicat -> nu mai punem swall peste.
      if (this.noInternet) {
        return 0
      }
      this.loader = false
      var className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
      // Sursa erorii (de la ce apel a picat) + statusul HTTP daca exista.
      var source = action ? String(action) : ''
      if (httpStatus) {
        source = source ? (source + ' (HTTP ' + httpStatus + ')') : ('HTTP ' + httpStatus)
      }
      Swal.fire({
        icon: 'error',
        title: this.$t('general.error'),
        text: friendlyMessage || source,
        // Cand avem mesaj prietenos, aratam sursa tehnica in footer.
        footer: friendlyMessage ? source : undefined,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className + ' generalErrorSwall',
        }
      })
    },
    getRaport (raportType) {
      this.secretMenuLog(raportType == 'X' ? 'get_raport_x' : 'get_raport_z')
      this.closeSettingsModal()
      if (raportType == 'X') {
        this.localRequestFiscalNet('/api/Receipt', 'POST', '"X^",', (response) => {
            console.log(response)
        })
        // this.localRequest('/get_X', 'GET', {
        //     'fiscal': JSON.stringify(this.DBfiscal)
        //     }, (response) => {
        //     console.log(response)
        // })
      }
      if (raportType == 'Z') {
        this.localRequestFiscalNet('/api/Receipt', 'POST', '"Z^",', (response) => {
            console.log(response)
        })
        // this.localRequest('/get_Z', 'GET', {
        //     'fiscal': JSON.stringify(this.DBfiscal)
        //     }, (response) => {
        //     console.log(response)
        // })
      }
    },
    // GET HISTORY Z: comanda RAPZINFO^<nr>^<nr>. Se introduce un singur numar de Z,
    // acelasi este trimis si ca inceput si ca sfarsit al intervalului (de la Z n la Z n).
    // Deschide un modal cu tastatura numerica proprie (la fel ca la bacsis).
    // NU apelam closeSettingsModal() aici, pentru ca acela face restart() la kiosk;
    // doar ascundem settings-ul si deschidem modalul. Restart-ul se face abia dupa
    // ce s-a introdus numarul si s-a trimis comanda (in historyConfirm).
    getHistoryZ () {
      this.secretMenuLog('history_z')
      this.clearKeyBoard()
      this.showSettingsModal = false
      this.historyMode = 'z'
      this.historyActiveField = 'zet'
      this.historyBonInput = ''
      this.historyZetInput = ''
      this.showHistoryModal = true
    },
    // GET HISTORY BON: comanda BONINFO^<nr_bon>^<nr_zet>. Se introduc ambele numere.
    getHistoryBon () {
      this.secretMenuLog('history_bon')
      this.clearKeyBoard()
      this.showSettingsModal = false
      this.historyMode = 'bon'
      this.historyActiveField = 'bon'
      this.historyBonInput = ''
      this.historyZetInput = ''
      this.showHistoryModal = true
    },
    // Inchide modalul si aduce kiosk-ul in starea de idle (ca la inchiderea setarilor).
    closeHistoryModal () {
      this.showHistoryModal = false
      this.restart()
    },
    // Ce camp editeaza tastatura acum
    historyActiveKey () {
      if (this.historyMode === 'z') return 'historyZetInput'
      return this.historyActiveField === 'bon' ? 'historyBonInput' : 'historyZetInput'
    },
    // Selecteaza campul activ (doar in modul 'bon')
    setHistoryField (field) {
      if (this.historyMode !== 'bon') return
      this.historyActiveField = field
    },
    historyAppend (char) {
      const key = this.historyActiveKey()
      // fara zerouri initiale
      if (this[key] === '' && Number(char) === 0) return
      // limita de siguranta
      if (this[key].length >= 6) return
      this[key] += char.toString()
    },
    historyBackspace () {
      const key = this.historyActiveKey()
      this[key] = this[key].slice(0, -1)
    },
    historyConfirm () {
      if (this.historyMode === 'z') {
        let n = parseInt(this.historyZetInput)
        if (!n || n < 1) return
        this.localRequestFiscalNet('/api/Receipt', 'POST', '"RAPZINFO^' + n + '^' + n + '",', (response) => {
          this.printFiscalNetReceiptInfo(response)
        })
      } else {
        let bon = parseInt(this.historyBonInput)
        let zet = parseInt(this.historyZetInput)
        if (!bon || bon < 1 || !zet || zet < 1) return
        this.localRequestFiscalNet('/api/Receipt', 'POST', '"BONINFO^' + zet + '^' + bon + '",', (response) => {
          this.printFiscalNetReceiptInfo(response)
        })
      }
      // dupa trimiterea comenzii facem restart la kiosk (ca la GET X / GET Z)
      this.closeHistoryModal()
    },
    // RAPZINFO / BONINFO NU printeaza pe casa; intorc bonul in raspuns, in campul
    // JSON `ReceiptInfo` (text integral, cu liniile separate prin \r\n). Ca sa iasa
    // pe imprimanta il retrimitem ca bon nefiscal: fiecare linie cu prefix "TL^",
    // exact ca la generateNonFiscalTextFiscalNet.
    printFiscalNetReceiptInfo (response) {
      if (!response || !response.data || !response.data.ReceiptInfo) return
      // Raportul intern e formatat pe 48 de coloane (fontul condensat al casei), dar
      // fontul cu care printeaza TL^ e mai lat si taie ce trece de aceasta latime,
      // asa ca valoarea din capatul din dreapta (ex. "16.00") se pierde. Recompunem
      // liniile "eticheta ... valoare" ca sa incapa in latimea de mai jos.
      // Daca valoarea tot se taie, scade WIDTH; daca vrei liniile mai late, creste-l.
      const WIDTH = 40
      let lines = response.data.ReceiptInfo.split(/\r\n|\n|\r/)
      let payload = ''
      lines.forEach((line) => {
        // pastram spatiile de aliniere (centrare), scoatem diacriticele si ghilimelele
        let text = this.removeDiacritics(line).replace(/"/g, '')
        // daca dupa TL^ nu ramane nimic (linie goala / doar spatii) nu o mai trimitem
        if (text.trim() === '') return
        // doar liniile care depasesc latimea si au forma "eticheta<gol>valoare"
        // le recompactam, ca sa nu se piarda valoarea din dreapta
        if (text.length > WIDTH) {
          let m = text.match(/^(\s*\S.*?\S)\s{2,}(\S.*)$/)
          if (m) {
            let label = m[1]
            let value = m[2]
            let gap = WIDTH - label.length - value.length
            if (gap < 1) gap = 1
            text = label + ' '.repeat(gap) + value
          }
        }
        payload += `"TL^${text}",\n`
      })
      if (!payload) return
      this.localRequestFiscalNet('/api/Receipt', 'POST', payload, (res) => {
        console.log(res)
      })
    },
    // ===== Cauta comanda (kiosk) =====
    // Deschide popupul cu ultimele comenzi ale acestui kiosk. La reload de kiosk
    // starea Vue se reseteaza, deci popupul se inchide automat.
    openSearchOrderModal () {
      this.secretMenuLog('search_order')
      this.clearKeyBoard()
      this.showSettingsModal = false
      this.searchOrders = []
      this.searchOrdersPage = 1
      this.searchOrdersLastPage = 1
      this.searchOrdersTotal = 0
      this.expandedSearchOrderId = null
      this.expandedSearchOrderProducts = []
      this.searchActiveFilterField = 'id'
      this.searchFilterId = ''
      this.searchFilterNumber = ''
      this.searchFilterTotal = ''
      this.showSearchOrderModal = true
      this.loadKioskOrders(1)
    },
    closeSearchOrderModal () {
      this.showSearchOrderModal = false
      this.restart()
    },
    // Aduce comenzile filtrate strict pe acest kiosk (company + location + table_id),
    // doar din ultimele 24h, plus filtrele numerice optionale (id / numar / total).
    loadKioskOrders (page) {
      this.searchOrdersLoading = true
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        location_id: this.locationTrueId,
        table_id: this.json.id,
        page: page,
        per_page: 7
      }
      if (this.searchFilterId !== '')     { data.filter_id = this.searchFilterId }
      if (this.searchFilterNumber !== '') { data.filter_number = this.searchFilterNumber }
      if (this.searchFilterTotal !== '')  { data.filter_total = this.searchFilterTotal }
      this.apiRequest('/noauth/kiosk-orders', 'GET', data, (response) => {
        this.searchOrdersLoading = false
        if (response && response.data && response.data.data) {
          this.searchOrders = response.data.data.orders || []
          this.searchOrdersPage = response.data.data.current_page || 1
          this.searchOrdersLastPage = response.data.data.last_page || 1
          this.searchOrdersTotal = response.data.data.total || 0
        }
      })
    },
    searchOrdersNextPage () {
      if (this.searchOrdersLoading) return
      if (this.searchOrdersPage < this.searchOrdersLastPage) {
        this.expandedSearchOrderId = null
        this.expandedSearchOrderProducts = []
        this.loadKioskOrders(this.searchOrdersPage + 1)
      }
    },
    searchOrdersPrevPage () {
      if (this.searchOrdersLoading) return
      if (this.searchOrdersPage > 1) {
        this.expandedSearchOrderId = null
        this.expandedSearchOrderProducts = []
        this.loadKioskOrders(this.searchOrdersPage - 1)
      }
    },
    // ---- Filtre (tastatura numerica proprie) ----
    // Cheia campului activ din model, ca sa scriem in el cu tastatura.
    searchFilterActiveKey () {
      if (this.searchActiveFilterField === 'number') return 'searchFilterNumber'
      if (this.searchActiveFilterField === 'total') return 'searchFilterTotal'
      return 'searchFilterId'
    },
    setSearchFilterField (field) {
      this.searchActiveFilterField = field
    },
    searchFilterAppend (char) {
      const key = this.searchFilterActiveKey()
      // Punctul zecimal e permis doar la total si o singura data.
      if (char === '.') {
        if (this.searchActiveFilterField !== 'total') return
        if (this[key].includes('.')) return
        if (this[key] === '') { this[key] = '0'; }
        this[key] += '.'
        return
      }
      // Fara zerouri initiale (dar permitem "0." la total).
      if (this[key] === '' && Number(char) === 0 && this.searchActiveFilterField !== 'total') return
      if (this[key].length >= 12) return
      this[key] += char.toString()
    },
    searchFilterBackspace () {
      const key = this.searchFilterActiveKey()
      this[key] = this[key].slice(0, -1)
    },
    // Aplica filtrele: reincepe de la pagina 1.
    applySearchFilter () {
      this.expandedSearchOrderId = null
      this.expandedSearchOrderProducts = []
      this.loadKioskOrders(1)
    },
    // Reseteaza toate filtrele si reincarca.
    resetSearchFilter () {
      this.searchFilterId = ''
      this.searchFilterNumber = ''
      this.searchFilterTotal = ''
      this.searchActiveFilterField = 'id'
      this.expandedSearchOrderId = null
      this.expandedSearchOrderProducts = []
      this.loadKioskOrders(1)
    },
    hasAnySearchFilter () {
      return this.searchFilterId !== '' || this.searchFilterNumber !== '' || this.searchFilterTotal !== ''
    },
    // O comanda e considerata fiscalizata daca are AMBELE numere (bon + Z).
    searchOrderHasFiscal (order) {
      return !!(order && order.fiscal_nr && order.fiscal_nrz)
    },
    // Reprinteaza bonul unei comenzi deja fiscalizate — exact ca la GET HISTORY BON,
    // luand nr. bon si nr. Z de pe comanda (BONINFO^<zet>^<bon>).
    reprintOrderBon (order) {
      if (!this.searchOrderHasFiscal(order)) return
      let bon = parseInt(order.fiscal_nr)
      let zet = parseInt(order.fiscal_nrz)
      if (!bon || bon < 1 || !zet || zet < 1) return
      this.localRequestFiscalNet('/api/Receipt', 'POST', '"BONINFO^' + zet + '^' + bon + '",', (response) => {
        this.printFiscalNetReceiptInfo(response)
      })
    },
    // Fiscalizeaza o comanda care nu are inca nr. bon / nr. Z. Cere confirmare, apoi
    // reia fiscalizarea exact ca la refiscalizarea din kiosk (get-cart-by-id + printFiscalNet...).
    async fiscalizeOrderFromSearch (order) {
      let className = this.json.type == 'Kiosk' ? 'bigSwall bigZIndex' : 'smallSwall'
      const result = await Swal.fire({
        title: 'Sunteti sigur ca fiscalizati aceasta comanda?',
        showCancelButton: true,
        confirmButtonText: 'Da',
        cancelButtonText: 'Nu',
        confirmButtonColor: '#2c7a3f',
        cancelButtonColor: '#c0392b',
        reverseButtons: true,
        allowOutsideClick: false,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className + ' fiscalConfirmSwall'
        }
      })
      if (!result || !result.isConfirmed) return

      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        id: order.order_id,
        method: 'self_ordering'
      }
      this.loader = true
      this.apiRequest('/get-cart-by-id', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          let oldOrder = response.data.data
          let payMethod = 'cash'
          if (oldOrder.payment_type == 'CARD' || oldOrder.payment_type == 'CARD_POS') {
            payMethod = 'card'
          }
          const afterFiscal = () => {
            this.loader = false
            // Reincarcam pagina curenta ca sa apara nr. bon / nr. Z proaspete.
            // printFiscalNetAndFinish salveaza raspunsul casei (print-fiscal-net-answer)
            // asincron, fara sa il asteptam aici, asa ca lasam un mic delay ca sa apuce
            // sa se persiste fiscal_nr / fiscal_nrz inainte de reload.
            setTimeout(() => {
              this.loadKioskOrders(this.searchOrdersPage)
            }, 1800)
          }
          if (this.DBfiscal && !this.DBfiscalNet) {
            this.printFiscalAndFinish(oldOrder, payMethod, 1, () => { afterFiscal(); return 0 })
          } else if (this.DBfiscalNet) {
            this.printFiscalNetAndFinish(oldOrder, payMethod, 1, () => { afterFiscal(); return 0 })
          } else {
            this.loader = false
          }
        } else {
          this.loader = false
        }
      })
    },
    // Dropdown per comanda: la deschidere aduce produsele/optiunile prin get-cart-by-id.
    toggleSearchOrderProducts (order) {
      if (this.expandedSearchOrderId === order.order_id) {
        this.expandedSearchOrderId = null
        this.expandedSearchOrderProducts = []
        return
      }
      this.expandedSearchOrderId = order.order_id
      this.expandedSearchOrderProducts = []
      this.expandedSearchOrderLoading = true
      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        id: order.order_id,
        method: 'self_ordering'
      }
      this.apiRequest('/get-cart-by-id', 'GET', data, (response) => {
        this.expandedSearchOrderLoading = false
        if (response && response.data && response.data.data && response.data.data.myCart) {
          this.expandedSearchOrderProducts = response.data.data.myCart.products || []
        }
      })
    },
    verifyPass () {
      if (this.kiosk_pass == this.thePass) {
        this.corectPass = true
        this.secretMenuLog('unlock_success')
      } else {
        this.secretMenuLog('unlock_fail')
        this.closeSettingsModal()
      }
      this.clearKeyBoard()
    },
    goToSettings () {
      this.thePass = ''
      this.corectPass = false
      this.showSettingsModal = true
      this.activeKeyboard = true

      this.loader = false
      this.error = false
      if (this.json.type == 'Kiosk') {
        this.definKeyboard()
      }
      // console.log('settings')
    },
    setScroolVars (el, active) {
      // let heightOfEl = document.querySelector(".productList").offsetHeight
      const productList = document.querySelector(".productList")
      if (!el || !productList) {
        return
      }
      if (el.scrollTop > 120 && productList.scrollHeight > window.screen.height) {
        active.top = true
      } else {
        active.top = false
      }
      if (el.scrollHeight - el.offsetHeight <= el.scrollTop + 2) {
        active.bottom = false
      } else {
        active.bottom = true
      }
    },
    handleGesture (touchableElement) {

      // (this.touchstartY - this.touchendY > 50)
      let flagForDetDir = true;
      if (this.json.type != 'Kiosk') {
        if (this.touchstartY > this.touchendY && (this.touchstartY - this.touchendY > 50) ) {
          flagForDetDir = false;
        }
        if (this.touchendY > this.touchstartY && (this.touchendY - this.touchstartY > 50) ) {
          flagForDetDir = false;
        }
      }

      if (this.touchendX < this.touchstartX && (this.touchstartX - this.touchendX > 50) && flagForDetDir && this.json.type != 'Kiosk') {
        // console.log('Swiped Left Go Right');
        this.goNextOrPriv(1)
        // for (var i = this.category.length - 1; i >= 0; i--) {
        //   if (this.category[i].id == this.selectedCategory) {
        //     if (i+1 < this.category.length) {
        //       this.getProducts(this.category[i+1].id, this.selectedTopCategory)
        //     } else {
        //       this.getProducts(this.category[0].id, this.selectedTopCategory)
        //     }
        //     return 0
        //   }
        // } 
      }

      if (this.touchendX > this.touchstartX && (this.touchendX - this.touchstartX > 50) && flagForDetDir && this.json.type != 'Kiosk') {
        // console.log('Swiped Right Go Left');
        this.goNextOrPriv(-1)
        // for (var i = this.category.length - 1; i >= 0; i--) {
        //   if (this.category[i].id == this.selectedCategory) {
        //     if (i-1 >= 0) {
        //       this.getProducts(this.category[i-1].id, this.selectedTopCategory)
        //     } else {
        //       this.getProducts(this.category[this.category.length-1].id, this.selectedTopCategory)
        //     }
        //     return 0
        //   }
        // }
      }

      if (this.touchendY < this.touchstartY && (this.touchstartY - this.touchendY > 50) && this.json.type == 'Kiosk' ) {
          // console.log('Swiped Up Go Down')
          if (touchableElement.scrollHeight - touchableElement.offsetHeight <= touchableElement.scrollTop + 2) {
          // if(touchableElement.scrollTop + touchableElement.offsetHeight == touchableElement.scrollHeight) {
            if (this.bottomReach) {
              this.goNextOrPriv(1)
              if (this.infoShown.bottom == true) {
                this.infoShown.permanentDisabled = true
              }
              // for (var i = this.category.length - 1; i >= 0; i--) {
              //   if (this.category[i].id == this.selectedCategory) {
              //     if (i+1 < this.category.length) {
              //       this.getProducts(this.category[i+1].id, this.selectedTopCategory)
              //       if (this.infoShown.bottom == true) {
              //         this.infoShown.permanentDisabled = true
              //       }
              //       return 0
              //     }
              //   }
              // } 
            }
          }
          // if (touchableElement.offsetHeight - touchableElement.scrollHeight == 0) { // No scrool in page
          //   for (var i = this.category.length - 1; i >= 0; i--) {
          //     if (this.category[i].id == this.selectedCategory) {
          //       if (i+1 < this.category.length) {
          //         this.getProducts(this.category[i+1].id)
          //         return 0
          //       }
          //     }
          //   } 
          // }
      }

      if (this.touchendY > this.touchstartY && (this.touchendY - this.touchstartY > 50) && this.json.type == 'Kiosk' ) {
        // console.log('Swiped Down Go Up');
        if(touchableElement.scrollTop == 0) {
          if (this.topReach) {
            this.goNextOrPriv(-1)
            // for (var i = this.category.length - 1; i >= 0; i--) {
            //   if (this.category[i].id == this.selectedCategory) {
            //     if (i-1 >= 0) {
            //       this.getProducts(this.category[i-1].id, this.selectedTopCategory)
            //       return 0
            //     }
            //   }
            // }
          }
        }
      }

      // if (this.touchendY === this.touchstartY) {
      //     console.log('Tap');
      // }
    },
    goNextOrPriv (number) {
      let allCategories = []
      for (var i = 0; i < this.top_category.length; i++) {
        for (var j = 0; j < this.top_category[i].categories.length; j++) {
          allCategories.push(this.top_category[i].categories[j])
        }
      }
      for (var i = 0; i < this.category.length; i++) {
        allCategories.push(this.category[i])
      }

      // this.selectedCategory
      for (var i = 0; i < allCategories.length; i++) {
        if (allCategories[i].id == this.selectedCategory) {
          if (i+number < 0) {
            this.getProducts(allCategories[allCategories.length-1].id, allCategories[allCategories.length-1].top_category_id)
          } else if (i+number < allCategories.length) {
            this.getProducts(allCategories[i+number].id, allCategories[i+number].top_category_id)
          } else {
            this.getProducts(allCategories[0].id, allCategories[0].top_category_id)
          }
          return 0; // IMPORTANT TO STOP HERE
        }
      }
    },
    goNextOrPriv2 (number) {
      for (var i = this.category.length - 1; i >= 0; i--) {
        if (this.category[i].id == this.selectedCategory) {
          if (i+number < 0) {
            this.getProducts(this.category[this.category.length-1].id, this.selectedTopCategory)
          } else if (i+number < this.category.length) {
            this.getProducts(this.category[i+number].id, this.selectedTopCategory)
          } else {
            this.getProducts(this.category[0].id, this.selectedTopCategory)
          }
          return 0; // IMPORTANT TO STOP HERE
        }
      } 
    },
    checkIfIsClose() {
      // // console.log('setInterval')
      // clearInterval(this.checkIfIsCloseTimeout)
      // this.checkIfIsCloseTimeout = setInterval(() => {
      //   // console.log('IN Timeout 2')
      //   if (this.showSplashScreenModal == true && this.packed == false) { // in FIRST PAGE
      //     this.error = false
      //     // console.log('First Restart')
      //     this.restart()
      //     // console.log('end Restart')
      //   }
      // }, 60000 * 10)
    },
    detectActivity () {
      clearTimeout(this.activitiDetected)
      // console.log('detectActivity');
        this.activitiDetected = setTimeout(() => {
          // console.log('TIMEOUT detect');
          if (!(this.showSplashScreenModal == true && this.packed == false) && this.showPaymentModal == false) { 
            if (!this.showPosModal && !this.showSettingsModal && !this.onePaymentAllreadyPicked) { // or in payment or in settings
              this.restart()
              // console.log('restart')
            }
          }
        }, 60000 * 3) // 3 mins
    },
    exitSplashScreen () {
      if (this.json.type == 'Kiosk') {
        if (this.packing_method) {
          this.packingMethod = this.packing_method;
          this.showSplashScreenModal = false;
          this.chooseMetod();
          this.packed = false;
        } else {
          this.packed = true;
        }
        this.goFullScreen();
        clearTimeout(this.sliderNextTimeout)
      } else {
        this.showSplashScreenModal = false
        this.promptFirstNameIfNeeded()
      }
    },
    chooseMetod (packMethod) {
      if (this.settingOrderMethod) return

      const previousPackingMethod = this.packingMethod
      if (packMethod) {
        this.packingMethod = packMethod;
        this.showSplashScreenModal = false;
      }
      // Packing drives EatIn vs ToGo campaign lines — refresh menu promos immediately.
      if (typeof this.getDiscountsForProducts === 'function' && Array.isArray(this.products) && this.products.length) {
        this.getDiscountsForProducts()
      }
      if (this.json.type == 'Kiosk' && this.DBfiscalNet && this.checkFiscalNet) {
        this.sendCheckSignalFiscalIsOnnline()
      }
      if (this.useMethods) {
        const method = this.packingMethod == 'dineIn' ? 'eat_location' : 'pick_up'
        const requestId = ++this.orderMethodRequestId
        this.settingOrderMethod = true
        this.loader = true

        this.setOrderType(method, (res) => {
          if (requestId !== this.orderMethodRequestId) return

          if (!(res && res.data && res.data.status && res.data.data && res.data.data.order)) {
            this.settingOrderMethod = false
            this.loader = false
            this.packingMethod = previousPackingMethod
            this.showSplashScreenModal = true
            this.packed = !this.packing_method
            this.generalErrorSwal('order/set-method', res, this.$t('general.errOrderMethod'))
            return
          }

          this.cart = res.data.data.order
          this.customMethod = method
          // Load/preload only after the cart has confirmed the chosen method.
          this.getProducts(null,null,null,null, ()=> {
            if (requestId !== this.orderMethodRequestId) return
            this.settingOrderMethod = false
            this.loader = false
            if (this.json.type != 'Kiosk') {
              this.createCacheForMenu();
            }
            if (this.json.type == 'Kiosk') {
              this.definKeyboard()
            }
          })
        })
      }
    },
    sendCheckSignalFiscalIsOnnline () {
      console.log('send postMessage checkFiscalNet')
      window.postMessage({
        type: 'checkFiscalNet'
       }, '*');

      // for test
      // setTimeout( () => {
      //   this.blockKioskFiscalError = true
      //   this.lastOrderNumberForFiscalError = null
      // }, 1000);
    },
    // Buton secret (settings) -> cere Electron-ului sa aduca fereastra FiscalNet in
    // prim-plan. Trimitem un request cu requestId unic si asteptam focusFiscalNetResult
    // pe listenerul din init (care valideaza requestId-ul).
    bringFiscalNetToFront () {
      this.fiscalNetRequestId =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        ('fiscalnet-' + Date.now())

      const request = {
        version: 1,
        requestId: this.fiscalNetRequestId,
        action: 'focusFiscalNet',
        payload: {}
      }

      this.secretMenuLog('focus_fiscalnet', { data_to: request })
      window.parent.postMessage(JSON.stringify(request), '*')
    },
    setOrderType (method, callback = null) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        order_id: this.cart.order_id,
        method: method
      }
      this.apiRequest('order/set-method', 'POST', data, (response) => {
        if (response) {
          // error seba
        }
        if(callback) callback(response);
      })
    },
    async definKeyboard () {
      if (this.keyboard) {
        this.keyboard.destroy()
      }
      this.keyboard = new Keyboard(".simple-keyboard", {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        mergeDisplay: true,
        layoutName: this.showClientModal || this.showWalletModal ? "phone" : "default",
        layout: {
          default: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m {backspace}",
            "{space} {ent}"
          ],
          shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shift} Z X C V B N M {backspace}",
            "{space} {ent}"
          ],
          phone: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "+ 0 {backspace}",
            "{ent}",
          ],
        },
        display: {
          "{space}": "space",
          "{numbers}": "123",
          "{ent}": "enter",
          "{escape}": "esc ⎋",
          "{tab}": "tab ⇥",
          "{backspace}": "⌫",
          "{capslock}": "caps lock ⇪",
          "{shift}": "⇧",
          "{controlleft}": "ctrl ⌃",
          "{controlright}": "ctrl ⌃",
          "{altleft}": "alt ⌥",
          "{altright}": "alt ⌥",
          "{metaleft}": "cmd ⌘",
          "{metaright}": "cmd ⌘",
          "{abc}": "ABC"
        }
      });
    },
    definKeyboardClient () {
      if (this.keyboard) {
        this.keyboard.destroy()
      }
      this.keyboard = new Keyboard(".simple-keyboard-client", {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        mergeDisplay: true,
        layoutName: this.showClientModal ? "phone" : "default",
        layout: {
          default: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m {backspace}",
            "{space} {ent}"
          ],
          shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shift} Z X C V B N M {backspace}",
            "{space} {ent}"
          ],
          phone: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "+ 0 {backspace}"
            // "{ent}",
          ],
        },
        display: {
          "{space}": "space",
          "{numbers}": "123",
          "{ent}": "enter",
          "{escape}": "esc ⎋",
          "{tab}": "tab ⇥",
          "{backspace}": "⌫",
          "{capslock}": "caps lock ⇪",
          "{shift}": "⇧",
          "{controlleft}": "ctrl ⌃",
          "{controlright}": "ctrl ⌃",
          "{altleft}": "alt ⌥",
          "{altright}": "alt ⌥",
          "{metaleft}": "cmd ⌘",
          "{metaright}": "cmd ⌘",
          "{abc}": "ABC"
        }
      });
    },
    onChange (input) {
      if (input.length >= 255 && this.lastKey !== "{bksp}") {
        return false;
      }
      let enterInOne = false
      if (this.showCouponModal) {
        this.couponText = input
        enterInOne = true
      }
      if (this.showClientModal) {
        this.phone_to_send = input
        enterInOne = true
        // this.$nextTick(() => {
        //   if (this.$refs["clientPhoneField"]) this.$refs["clientPhoneField"].focus()
        //   setTimeout(() => {
        //     if (this.$refs["clientPhoneField"]) this.$refs["clientPhoneField"].focus()
        //   }, 500)
        // })
      }
      if (this.showWalletModal) {
        this.walletValue = input
        enterInOne = true
        // this.$nextTick(() => {
        //   if (this.$refs["clientPhoneField"]) this.$refs["clientPhoneField"].focus()
        //   setTimeout(() => {
        //     if (this.$refs["clientPhoneField"]) this.$refs["clientPhoneField"].focus()
        //   }, 500)
        // })
      }
      if (this.showCuiModal) {
        this.cuiText = input
        enterInOne = true
        this.$nextTick(() => {
          if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 500)
        })
      }
      if (this.showPagerModal) {
        this.pagerText = input
        enterInOne = true
        this.$nextTick(() => {
          if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 500)
        })
      }
      if (this.showProductModal) {
        this.currentProductInPopup.additional_info = input
        enterInOne = true
      }
      if (this.showSettingsModal) {
        this.thePass = input
        enterInOne = true
      }
      if (this.showPaymentModal) {
        // if (this.keyForPhone) {
          this.phone_to_send = input
        // } else {
        //   this.cui = input
        // }
        
        enterInOne = true
      }
      if (!enterInOne) {
        this.searchText = input
      }
      // this.keyboard.input.default = this.searchText
      // this.newText()
    },
    onKeyPress (button) {
      this.lastKey = button
      if (button === "{ent}") {
        let enterInOne = false
        if (this.showWalletModal) {
          enterInOne = true
          this.applyWallet()
          return 0;
        }
        if (this.showClientModal) {
          this.searchForClient()
          return 0;
        }
        if (this.showCuiModal) {
          enterInOne = true
          this.changeCui()
        }
        if (this.showCouponModal) {
          enterInOne = true
          this.applyCoupon(1)
        }
        if (this.showPagerModal) {
          enterInOne = true
          this.applyPager()
        }
        if (this.showProductModal) {
          enterInOne = true
          //silence
        }
        if (this.showSettingsModal) {
          this.verifyPass()
          enterInOne = true
        }
        if (this.showPaymentModal) {
          enterInOne = true
          //silence
        }
        if (!enterInOne) {
          this.newText()
        }
        setTimeout( ()=> {
          this.activeKeyboard = false;
        }, 200);
      }
      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    },
    clearKeyBoard () {
      this.keyForPhone = 0
      if (this.keyboard) {
        // this.searchFilterShow = false
        this.showRemoveTextFromSearch = 0
        this.activeKeyboard = false
        this.keyboard.clearInput(this.$refs.searchText)
        this.keyboard.clearInput()
      }
      if (this.json.type == 'Kiosk') {
        this.searchText = ''
      }
    },
    openListOfLang () {
      this.listOfLangIsOpen = !this.listOfLangIsOpen
    },
    changeLanguageLocal (lng, noList = false) {
      // if (this.top_category && this.curentLang != lng) {
      //   for (var i = this.top_category.length - 1; i >= 0; i--) {
      //     if (this.top_category[i].name.toLowerCase() == lng.toLowerCase()) {
      //       this.getProducts (null, this.top_category[i].id)
      //       break;
      //     }
      //   }
      // }
      this.curentLang = this.changeLanguage(lng)
      if (!noList) {
        this.openListOfLang()
      }
    },
    // Merge the company languages received on login-table with the defaults (ro, en).
    setKioskLanguages (languages) {
      if (!Array.isArray(languages)) {
        return
      }
      let names = {}
      let shorts = []
      languages.forEach((lang) => {
        if (lang && lang.short) {
          shorts.push(lang.short)
          if (lang.name) {
            names[lang.short] = lang.name
          }
        }
      })
      this.languageNamesFromApi = names
      // Romanian and English stay the default, extra admin languages come after.
      this.allLang = Array.from(new Set(['ro', 'en', ...shorts]))
    },
    // Native / display name for a language short code.
    langLabel (short) {
      const nativeNames = {
        ro: 'Română',
        en: 'English',
        hu: 'Magyar',
        de: 'Deutsch',
        fr: 'Français',
        it: 'Italiano',
        es: 'Español',
        el: 'Ελληνικά',
        nl: 'Nederlands',
        cz: 'Čeština'
      }
      if (nativeNames[short]) {
        return nativeNames[short]
      }
      if (this.languageNamesFromApi && this.languageNamesFromApi[short]) {
        return this.languageNamesFromApi[short]
      }
      return short ? short.toUpperCase() : ''
    },
    // Flag image path for a language short code (served from /public).
    // process.env.BASE_URL is inlined by Vue CLI at build time.
    langFlagSrc (short) {
      return (process.env.BASE_URL || '/') + short + '-flag.svg'
    },
    waiterSteps () {
      if (this.waiterStep0) {
        this.waiterStep0 = false;
        this.waiterStep1 = false;
        this.waiterStep2 = false;
      } else {
        this.waiterStep0 = true;
        setTimeout(() => {
          this.waiterStep1 = true;
        }, 300);
        // setTimeout(() => {
        //   this.waiterStep2 = true;
        // }, 600);
      }
    },
    confirmCallWaiter() {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
      Swal.fire({
        title: this.$t('addOrder.sendWaiter'),
        target: document.getElementById('swal-template'),
        input: 'text',
        inputPlaceholder: this.$t('addOrder.placeholderWaiter'),
        showCancelButton: true,
        cancelButtonText: this.$t('addOrder.no'),
        confirmButtonText: this.$t('addOrder.yes'),
        reverseButtons: true,
        customClass: {
          container: className,
        },
        inputValidator: (value) => {
          if (!value) {
            return this.$t('addOrder.sendWaiterValidate')
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.callWaiter(result.value);
        }
      });
    },
    callWaiter(reason) {
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        location_id: this.json.location_token,
        table_id: this.json.id,
        shopping_cart_id: this.cart.shopping_cart_id,
        reason: reason || 'bill'
      };
  
      this.apiRequest('/call-waiter', 'GET', data2, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.waiter_called'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
        }
      });
    },
    updateCategories (opId = null, valId = null) {
      var sumToBeAdded = 0

      // ========== STOC PE OPȚIUNI: debifează valorile fără stoc înainte de calcule ==========
      if (this.currentProductInPopup.product_options && this.currentProductInPopup.product_options.length) {
        this.currentProductInPopup.product_options.forEach((op) => {
          (op.values || []).forEach((val) => {
            const stockProductId = this.optionValueStockProductId(val)
            if (stockProductId == null) return
            const minQty = (val.company_option_value && val.company_option_value.min_quantity) || 1
            const stk = this.getOptionValueStock(stockProductId)
            const noStock = this.optionValueHasNoStock(stockProductId) || (stk !== false && stk < minQty)
            if (noStock) {
              if (op.type === 'checkbox') {
                val.checked = false
              } else if (op.type === 'radio' && op.checked === val.id) {
                op.checked = null
              }
            }
          })
        })
      }
      // ====================================================================================

      if (this.currentProductInPopup.product_options.length) {
        for (var i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
          this.currentProductInPopup.product_options[i].optionsSelected = []
          if (this.currentProductInPopup.product_options[i].values.length) {
            for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
              
              // ========== INIȚIALIZEAZĂ QUANTITY LA MINIM PENTRU CHECKBOX ==========
              if (
                this.currentProductInPopup.product_options[i].type === 'checkbox' &&
                this.currentProductInPopup.product_options[i].values[j].checked
              ) {
                const minQty = this.currentProductInPopup.product_options[i].values[j].company_option_value?.min_quantity || 1;
                
                // Dacă quantity nu există sau e mai mic decât minimul, setează la minim
                if (
                  !this.currentProductInPopup.product_options[i].values[j].quantity ||
                  this.currentProductInPopup.product_options[i].values[j].quantity < minQty
                ) {
                  this.currentProductInPopup.product_options[i].values[j].quantity = minQty;
                }
              }
              // Dacă e debifat, resetează quantity (opțional, dar curat)
              if (
                this.currentProductInPopup.product_options[i].type === 'checkbox' &&
                !this.currentProductInPopup.product_options[i].values[j].checked
              ) {
                this.currentProductInPopup.product_options[i].values[j].quantity = 1;
              }
              // ===================================================================

              if (this.currentProductInPopup.product_options[i].type === 'radio') {
                if (this.currentProductInPopup.product_options[i].checked === this.currentProductInPopup.product_options[i].values[j].id) {
                  sumToBeAdded += this.getOptionUnitPrice(this.currentProductInPopup.product_options[i].values[j])
                  this.currentProductInPopup.product_options[i].optionsSelected[0] = this.currentProductInPopup.product_options[i].values[j].id
                  this.currentProductInPopup.product_options[i].values[j].checked = true
                } else {
                  this.currentProductInPopup.product_options[i].values[j].checked = false
                }
              }
              if (this.currentProductInPopup.product_options[i].type === 'checkbox') {

                if (
                    opId &&
                    valId &&
                    this.currentProductInPopup.product_options[i].max_no == 1
                ) {
                    if (opId == this.currentProductInPopup.product_options[i].id && valId != this.currentProductInPopup.product_options[i].values[j].id) {
                      this.currentProductInPopup.product_options[i].values[j].checked = false;
                    } else {
                      if (this.currentProductInPopup.product_options[i].values[j].checked) {
                        this.currentProductInPopup.product_options[i].optionsSelected = [];
                        this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                      }
                    }
                } else {
                  if (this.currentProductInPopup.product_options[i].values[j].checked) {
                    this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                  }
                }
              }
              if (this.currentProductInPopup.product_options[i].values[j].checked) {
                this.currentProductInPopup.product_options[i].values[j].checked = true
              } else {
                this.currentProductInPopup.product_options[i].values[j].checked = false
              }

              // ========== CALCUL PREȚ CU QUANTITY ==========
              if (
                this.currentProductInPopup.product_options[i].type === 'checkbox' && 
                this.currentProductInPopup.product_options[i].values[j].checked
              ) {
                const qty = this.currentProductInPopup.product_options[i].values[j].quantity || 1;
                sumToBeAdded += this.getOptionUnitPrice(this.currentProductInPopup.product_options[i].values[j]) * qty;
              }
              // ==============================================
            }
          }
        }
      }
      
      this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price) * parseFloat(this.currentProductInPopup.quantity)
      this.currentProductInPopup.price_details.price = this.currentProductInPopup.price_details.price + (parseFloat(sumToBeAdded) * parseFloat(this.currentProductInPopup.quantity))
      this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price_details.price).toFixed(2)

      let verifyCart = 1
      if (this.currentProductInPopup.product_options.length) {
        for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
          if (this.currentProductInPopup.product_options[i].required) {
            if (!this.currentProductInPopup.product_options[i].optionsSelected.length) {
              verifyCart = 0
            }
          }
          // ========== min_no / max_no pe SUMA cantităților (nu nr. de valori) ==========
          const opt = this.currentProductInPopup.product_options[i]
          const selectedQty = this.getOptionSelectedQuantity(opt)

          if (opt.min_no) {
            if (!(parseInt(opt.min_no) <= selectedQty)) {
              verifyCart = 0
            }
          }
          if (opt.max_no) {
            const maxNo = parseInt(opt.max_no)
            const remaining = maxNo - selectedQty // câtă cantitate mai încape
            for (var j = opt.values.length - 1; j >= 0; j--) {
              const val = opt.values[j]
              if (val.checked) {
                // valoarea bifată rămâne activă; QuantitySelector limitează creșterea
                // cantității prin getOptionValueMaxQuantity (buget rămas din max_no)
                val.disabled = false
              } else if (maxNo != 1) {
                // costul de a adăuga această valoare = min_quantity (sau 1); dacă nu
                // mai încape în buget, o dezactivăm
                const addCost = (opt.type === 'checkbox' && val.company_option_value && val.company_option_value.allow_quantity)
                  ? (parseInt(val.company_option_value.min_quantity) || 1)
                  : 1
                val.disabled = remaining < addCost
              }
            }
          }

          // ========== STOC PE OPȚIUNI: disable + limitare cantitate ==========
          // Cheia de stoc e product_id-ul mapat din company_option_value_id (NU values.id).
          for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
            const val = this.currentProductInPopup.product_options[i].values[j]
            const stockProductId = this.optionValueStockProductId(val)
            if (stockProductId == null) continue // valoarea nu are stoc urmărit

            const minQty = (val.company_option_value && val.company_option_value.min_quantity) || 1

            if (this.optionValueHasNoStock(stockProductId)) {
              val.disabled = true
              continue
            }

            const availableStock = this.getOptionValueStock(stockProductId)
            if (availableStock !== false) {
              // stoc pozitiv dar sub minimul comandabil => nu poate fi selectată
              if (availableStock < minQty) {
                val.disabled = true
                continue
              }
              // limitează cantitatea maximă selectabilă la stocul disponibil
              if (val.company_option_value && val.company_option_value.allow_quantity) {
                const cappedMax = Math.min(val.company_option_value.max_quantity || 99, availableStock)
                val.company_option_value.max_quantity = cappedMax
                if (val.quantity && val.quantity > cappedMax) {
                  val.quantity = cappedMax
                }
              }
            }
          }
          // ========== DISCOUNT UNITS PE OPȚIUNI (is_product) ==========
          for (var dj = this.currentProductInPopup.product_options[i].values.length - 1; dj >= 0; dj--) {
            const dVal = this.currentProductInPopup.product_options[i].values[dj]
            const discountProductId = this.optionValueStockProductId(dVal)
              || (dVal && dVal.product_id)
              || (dVal && dVal.company_option_value && dVal.company_option_value.product_id)
            if (discountProductId == null) continue
            if (!this.optionHasDiscount || !this.optionHasDiscount(dVal)) continue

            const remaining = this.getDiscountUnitsRemaining({ id: discountProductId, discount: dVal.discount })
            if (remaining == null || isNaN(remaining)) continue

            const dMinQty = (dVal.company_option_value && dVal.company_option_value.min_quantity) || 1
            if (remaining < dMinQty) {
              // Promo exhausted: strip badge (full price still selectable unless stock blocks).
              this.applyDiscountAvailabilityToOptionValue(dVal, {
                available: false,
                discount: null,
                units_remaining: 0
              })
              continue
            }
            if (dVal.company_option_value && dVal.company_option_value.allow_quantity) {
              const cappedMax = Math.min(dVal.company_option_value.max_quantity || 99, remaining)
              dVal.company_option_value.max_quantity = cappedMax
              if (dVal.quantity && dVal.quantity > cappedMax) {
                dVal.quantity = cappedMax
              }
            }
          }
          // =====================================================================
        }
      }
      
      let prod = this.currentProductInPopup
      const quantityLimit = this.getProductQuantityLimit(prod)
      if (quantityLimit !== false) {
        // Dacă se mărește cantitatea unei opțiuni, produsul nu poate rămâne
        // peste stocul disponibil pentru combinația selectată.
        if (quantityLimit > 0 && prod.quantity > quantityLimit) {
          prod.quantity = quantityLimit
        }
        // O combinație de opțiuni poate consuma mai mult decât stocul chiar
        // pentru un singur produs (de exemplu valori care au același stoc).
        if (quantityLimit < 1) {
          verifyCart = 0
        }
      }
      this.currentProductInPopup = null
      this.currentProductInPopup = prod

      if (verifyCart) {
        this.addToCartDisabled = false
      } else {
        this.addToCartDisabled = true
      }
    },
    modificationsInCart () {
      this.customTip = (this.cart.tip_value && this.cart.tip_value > 0) ? this.cart.tip_value : ''
      if (this.cart.myCart.products_count <= 0) {
        this.showCartModal = false
      }
      if ((this.cart.myCart.total_cart_price - (this.cart.myCart.total_pay_from_wallet || 0)) <= 0) {
        this.payMethod = 'free'
      } else if (this.payMethod === 'free') {
        if (this.cashIsAvailable) {
          this.payMethod = 'cash'
        } else {
          this.payMethod = ''
        }
      }
    },
    showCart (callback) {
      // this.loader = true
      this.searchText = ''
      this.getTheCart( ()=> {
        // this.loader = false
        this.showProductModal = false;
        this.showCartModal = true;
        // if (this.withVivaWallet) {
          this.selectedFingerprint = 'all';
        // }
        if (callback) {
          callback()
        }
      })
    },
    updateStock (prodId) {
      let stock = this.getProductStock(prodId)
      if (stock !== false) {
        this.getStocksForProducts()
      }
    },
    // Colecteaza DOAR optiunile alese, intr-o singura trecere, ca lista plata.
    // Criteriul de selectie e identic cu cel folosit in restul appului
    // (radio: group.checked === value.id; checkbox: value.checked truthy).
    // Backendul (options_prebuilt) rezolva restul campurilor din DB in cateva
    // query-uri batch, deci nu mai e nevoie sa trimitem tot arborele de optiuni.
    buildSelectedOptions (prod) {
      const selected = []
      const groups = (prod && prod.product_options) || []
      for (let i = 0; i < groups.length; i++) {
        const group = groups[i]
        const companyOptionId = group.company_option_id || group.id || null
        const values = group.values || []
        for (let j = 0; j < values.length; j++) {
          const val = values[j]
          const isSelected = group.type === 'radio'
            ? group.checked === val.id
            : Boolean(val.checked)
          if (!isSelected) continue

          const quantity = group.type === 'checkbox' && val.company_option_value && val.company_option_value.allow_quantity
            ? Math.max(1, Number(val.quantity) || 1)
            : 1

          selected.push({
            id: val.id,
            company_option_id: companyOptionId,
            company_option_value_id: (val.company_option_value_id != null)
              ? val.company_option_value_id
              : ((val.company_option_value && val.company_option_value.id) || null),
            quantity: quantity,
            name: val.name,
            price: val.price,
            product_id: val.product_id,
            profile_product_id: val.profile_product_id,
            campaign_discount: val.campaign_discount,
            discount: val.discount,
            original_price_after_discount: val.original_price_after_discount,
            pos_id: val.pos_id,
            file: val.file || null,
            section_id: val.section_id || (val.company_option_value && val.company_option_value.section_id) || null,
            pos_id_per_product: (val.pos_id_per_product != null) ? val.pos_id_per_product : null,
            quantity_per_option: (val.quantity_per_option != null) ? val.quantity_per_option : null,
            vat_id: (val.vat_id != null) ? val.vat_id : null,
            name_sgr: val.name_sgr,
            vat_id_sgr: val.vat_id_sgr,
            pos_id_sgr: val.pos_id_sgr,
            price_sgr: val.price_sgr
          })
        }
      }
      return selected
    },
    // Payload subtire pentru cos: pastreaza campurile scalare ale produsului,
    // dar scoate arborele greu de optiuni si trimite doar optiunile alese.
    buildLeanCartProduct (prod) {
      const selectedOptions = this.buildSelectedOptions(prod)
      const payload = Object.assign({}, prod)
      // The API fast option builder drops campaign claims. Keep the validated
      // tree for discounted options so their prices and reservations are checked.
      if (selectedOptions.some(option => option.campaign_discount && option.campaign_discount.campaigns && option.campaign_discount.campaigns.length)) {
        payload.categories = (prod.product_options || []).map(group => Object.assign({}, group, { options: group.values || [] }))
        return payload
      }
      delete payload.product_options
      delete payload.categories
      payload.selected_options = selectedOptions
      return payload
    },
    addToCart () {
      if (this.addProductInCartRequest > 0) return 0
      if (this.version <= 2 && this.json.type != 'Kiosk') {
        this.currentProductInPopup.hide_from_kds = 1;
      }

      const cartPrice = this.getProductPrice(this.currentProductInPopup)

      // Claim discount explicitly (or clear). Never silent full-price when a promo was shown.
      if (!this.stampAndValidateProductDiscountForCart(this.currentProductInPopup)) {
        return 0
      }

      // Stamp is_product option catalog ids + campaign meta for API reservation/validation.
      if (!this.stampAndValidateOptionDiscountsForCart(this.currentProductInPopup)) {
        return 0
      }

      let orderForm = this.json.type + ' ' + this.json.zone + ' ' + this.json.number;
      if (this.packingMethod) {
        orderForm = orderForm + ' (' + this.$t('addOrder.' + this.packingMethod) + ')';
      }

      // The transport price includes selected options. Keep the editable base price
      // unchanged so a rejected add cannot count those options a second time.
      const cartProduct = this.buildLeanCartProduct(JSON.parse(JSON.stringify(this.currentProductInPopup)))
      cartProduct.price = cartPrice
      this.addProductInCartRequest++
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        packing_method: this.packingMethod,
        action: 'add',
        add_order: true,
        order_from: orderForm,
        order_source_id: this.json.type == 'Kiosk' ? 1 : 2,
        options_prebuilt: Array.isArray(cartProduct.selected_options),
        product: cartProduct
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        // `finally` garanteaza decrementarea flagului pe ORICE iesire (cele doua
        // return-uri de mai jos, succes, eroare, sau chiar o exceptie neasteptata).
        // Altfel flagul ramanea blocat != 0 pe no_availability/no_stock/raspuns null
        // si ascundea butoanele de plata / tinea loaderul pornit pana la restart.
        try {
          if (response && response.data && response.data.data && response.data.data.no_availability) {
            this.showSoldWithModal = false
            this.setIndisponibleFromNoAvailability(response.data.data.no_availability)
            this.checkProductIndisponibility(null, true)
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.productUnavailable'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
            return 0;
          }
          if (response && response.data && (
            response.data.reason === 'units_limit_reached' ||
            response.data.reason === 'campaign_discount_unavailable' ||
            response.data.unorderable
          )) {
            this.showSoldWithModal = false
            this.clearProductMenuDiscount(this.currentProductInPopup)
            if (Array.isArray(this.products)) {
              this.products.forEach((p) => {
                if (p && p.id == this.currentProductInPopup.id) this.clearProductMenuDiscount(p)
              })
            }
            this.refreshMenuDiscountsAfterCartChange([this.currentProductInPopup.id])
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
            Swal.fire({
              title: response.data.reason === 'units_limit_reached'
                ? (this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'))
                : (this.$t('addOrder.discountPriceChanged') || this.$t('addOrder.productUnavailable')),
              target: document.getElementById('swal-template'),
              customClass: { container: className }
            })
            return 0
          }
          if (response && response.data && response.data.data && response.data.data.no_stock_products) {
            this.showSoldWithModal = false
            this.getStocksForProducts()
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.productNoStock'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
            return 0;
          }
          if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.showOptionModal = false
            this.showProductModal = false
            // this.soldWith(this.currentProductInPopup.id)
            this.cart = response.data.data
            this.bounceCartQuantity = true
            setTimeout(()=>{
              this.bounceCartQuantity = false
            }, 2000)
            this.modificationsInCart()
            // Afișarea notificării
            if(this.json.type != 'Kiosk') {
              this.showNotification(this.$t('addOrder.addToCart'))
            }

            this.updateStock(this.currentProductInPopup.id)
            this.checkProductIndisponibility()
            this.refreshMenuDiscountsAfterCartChange([this.currentProductInPopup.id])
            this.markUnorderableCartLinesFromResponse(response.data)
            if (this.soldWithCategory && this.soldWithCategory.length && !this.currentProductInPopup.sold_with_menu_suggestion) {
              this.showSoldWithModal = true
            }
          } else {
            if (response && response.data && response.data.errors && response.data.errors.hasOwnProperty('freeze_order')) {
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.order_id_freeze'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
            }
            if (response && response.data && response.data.errors && response.data.errors.hasOwnProperty('shopping_cart_id')) {
              // Popup + log intai; restart-ul se face dupa OK, din showCartLostPopup().
              this.showCartLostPopup(response)
            }
          }
        } finally {
          this.addProductInCartRequest--
        }
      })
    },
    // Cart pierdut (API intoarce eroare pe `shopping_cart_id`): logam MEREU in
    // kiosk_logs cu TOT raspunsul primit de la API, aratam un popup cu mesajul
    // concret de la API (mic, jos) si facem restart DOAR dupa ce clientul apasa
    // OK. Inainte se apela this.restart() INAINTE de popup, iar restart-ul face
    // Swal.close() + reinitializeaza aplicatia => popup-ul nu apucau sa se vada.
    showCartLostPopup (response) {
      // Mesajul mic de la API (`shopping_cart_id` poate fi string sau array).
      var apiMsg = null
      try {
        var errs = (response && response.data && response.data.errors) ? response.data.errors : null
        if (errs && errs.shopping_cart_id) {
          apiMsg = Array.isArray(errs.shopping_cart_id) ? errs.shopping_cart_id.join(' ') : String(errs.shopping_cart_id)
        }
      } catch (e) {
        apiMsg = null
      }
      
      this.kioskLog({
        order_id: (this.cart && this.cart.order_id) || null,
        stage: 'cart_lost',
        event: 'shopping_cart_id',
        http_status: (response && response.status) ? response.status : null,
        message: apiMsg,
        data_from: (response && response.data) ? response.data : (response || null)
      })

      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        icon: 'error',
        title: this.$t('addOrder.cart_lost_title'),
        // Mesajul concret venit de la API, mic, jos.
        footer: apiMsg || undefined,
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className + ' generalErrorSwall',
        }
      }).then(() => {
        // Restart DOAR dupa ce clientul a apasat OK.
        this.restart()
      });
    },
    showNotification(message) {
      const notification = document.createElement('div');
      notification.className = 'notification';
      notification.innerText = message;
      document.body.appendChild(notification);
      setTimeout(() => {
        notification.classList.add('show');
      }, 10);
    
      setTimeout(() => {
        notification.classList.add('fade-out');
        setTimeout(() => {
            document.body.removeChild(notification);
        }, 1000);
      }, 1500);
    },
    soldWith (productId, callback, withOptions = true) {
      this.closeSoldWithPopup()
      var data2 = this.appendPricingContext({
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        with_cache: true
      })
      if (withOptions) {
        data2.with_options = true
      }
      this.apiRequest('/product-sold-with/' + productId , 'GET', data2, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.soldWithCategory = response.data.data
        }
        // Always continue (open product modal / add flow) even if sold-with fails or is empty.
        if (callback) {
          callback()
        }
      })
    },
    selectSoldWithProduct (prod) {
      if (prod.active) {
        prod.active = 0
        this.selectedSoldWithProducts = this.selectedSoldWithProducts.filter(el => el.id != prod.id);
      } else {
        prod.active = 1
        this.selectedSoldWithProducts.push(prod)
      }
      this.extraCostSoldWith = this.selectedSoldWithProducts.reduce((accumulator, object) => {
        return accumulator + this.soldWithProductDisplayPrice(object);
      }, 0)
      this.extraCostSoldWith = parseFloat(this.extraCostSoldWith).toFixed(2)
    },
    soldWithRequiredOptionsPrice (prod) {
      return parseFloat(prod && prod.required_options_price ? prod.required_options_price : 0) || 0
    },
    // List (pre-discount) sold-with price: product base + mandatory options/SGR.
    soldWithProductListPrice (prod) {
      const base = parseFloat(prod && prod.price) || 0
      return base + this.soldWithRequiredOptionsPrice(prod)
    },
    // Payable sold-with price: campaign discount when present + mandatory options/SGR.
    soldWithProductDisplayPrice (prod) {
      if (prod && prod.use_price_to_show && prod.price_to_show > 0 && !this.productHasDiscount(prod)) {
        return parseFloat(prod.price_to_show || 0) + this.soldWithRequiredOptionsPrice(prod)
      }
      const base = this.productHasDiscount(prod)
        ? parseFloat(prod.discount.discounted_price)
        : parseFloat(prod && prod.price) || 0
      return base + this.soldWithRequiredOptionsPrice(prod)
    },
    closeSoldWithPopup () {
      this.showSoldWithModal = false
      this.soldWithCategory = null
      this.extraCostSoldWith = 0
      this.selectedSoldWithProducts = []
    },
    addTOCartExtra () {
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        action: 'add_multiple',
        add_order: true,
        options_prebuilt: true,
        products: this.selectedSoldWithProducts.map((p) => this.buildLeanCartProduct(p))
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      if (this.version <= 2 && this.json.type != 'Kiosk') {
        data2.hide_from_kds = 1;
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
          this.closeSoldWithPopup()

          // Afișarea notificării
          if(this.json.type != 'Kiosk') {
            this.showNotification(this.$t('addOrder.addToCart'))
          }
        } else {
          if (response && response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
        }
      })
    },
    nextOptionToCart ($goPrev, $first) {
      if ($first) {
        this.currentOptionInPopup = null
      }

      if (this.currentOptionInPopup === null) {
        this.currentOptionInPopup = this.currentProductInPopup.product_options[0]
        this.currentOptionInPopup.is_the_last_option = false
        this.showProductModal = false
        setTimeout(() => {
          this.showOptionModal = true
        }, 100)
        if (this.currentProductInPopup.product_options.length === 1) {
          this.currentOptionInPopup.is_the_last_option = true
        }
        return 0;
      }

      for (var i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
        if (this.currentOptionInPopup && this.currentOptionInPopup.id === this.currentProductInPopup.product_options[i].id) {
          if ($goPrev) {
            if (i > 0) {
              this.fakeEfectForOptionModal(() => {
                this.currentOptionInPopup = this.currentProductInPopup.product_options[i-1]
                this.currentOptionInPopup.is_the_last_option = false
              })
              break;
            } else {
              this.showProductModal = true
              this.showOptionModal = false
              break;
            }
          } else {
            // go next
            this.fakeEfectForOptionModal(() => {
              this.currentOptionInPopup = this.currentProductInPopup.product_options[i+1]
              this.currentOptionInPopup.is_the_last_option = false
              if (i+1 >= this.currentProductInPopup.product_options.length - 1) {
                this.currentOptionInPopup.is_the_last_option = true
              }
            })
            break;
          }
        }
      }
      return 0;
    },
    fakeEfectForOptionModal(callback) {
      this.showOptionModalEffectOut = true
      setTimeout(() => {
        if (callback) {
          callback()
        }
        setTimeout(() => {
          this.showOptionModalEffectOut = false
        }, 200)
      }, 200)
      
      // this.showOptionModal = false
      // setTimeout(() => {
      //   this.showOptionModal = true
      // }, 300)
    },
    verifyIfOptionIsDisabled () {
      if (this.currentOptionInPopup.required || this.currentOptionInPopup.min_no >=1) {
        if (this.currentOptionInPopup.optionsSelected && this.currentOptionInPopup.optionsSelected.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    editToCart () {
      if (!this.stampAndValidateProductDiscountForCart(this.currentProductInPopup)) {
        return 0
      }

      if (!this.stampAndValidateOptionDiscountsForCart(this.currentProductInPopup)) {
        return 0
      }

      // Pastram index/order_part_item_id trimitand un payload subtire cu doar
      // optiunile alese (aceeasi cale rapida ca la add).
      var leanProduct = this.buildLeanCartProduct(this.currentProductInPopup)
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        product_cart_index: this.currentProductInPopup.index,
        packing_method: this.packingMethod,
        action: 'edit',
        add_order: true,
        products_need_deleted: true,
        options_prebuilt: Array.isArray(leanProduct.selected_options),
        product: leanProduct
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      // La fel ca la add/delete: cat timp editarea e in curs, blocam butoanele de
      // plata (pe pagina de plata apare "Se calculeaza totalul...").
      this.addProductInCartRequest++
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        try {
          if (response && response.data && (
            response.data.reason === 'units_limit_reached' ||
            response.data.reason === 'campaign_discount_unavailable' ||
            response.data.unorderable
          )) {
            this.getDiscountsForProducts(null, [this.currentProductInPopup.id], this.currentProductInPopup.index)
            this.markUnorderableCartLinesFromResponse(response.data)
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
            Swal.fire({
              title: response.data.reason === 'units_limit_reached'
                ? (this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'))
                : (this.$t('addOrder.campaignDiscountUnavailable') || this.$t('addOrder.productUnavailable')),
              target: document.getElementById('swal-template'),
              customClass: { container: className }
            })
            return 0
          }
          if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.markUnorderableCartLinesFromResponse(response.data)
            // this.getStocksForProducts()
            this.updateStock(this.currentProductInPopup.id)
            this.checkProductIndisponibility()
            this.getDiscountsForProducts(null, [this.currentProductInPopup.id])
            this.goToMenuIfCartEmpty()
            this.showOptionModal = false
            this.showProductModal = false
          } else {
            if (response && response.data && response.data.errors && response.data.errors.hasOwnProperty('freeze_order')) {
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.order_id_freeze'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
            }
          }
        } finally {
          this.addProductInCartRequest--
        }
      })
    },
    getTheCart (callback = null) {
      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        add_order: true,
        shopping_cart_id: this.shopping_cart_id,
        location: this.json.location_token,
        method: this.customMethod
      }
      this.apiRequest('/get-cart', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data.data.status == 'DELIVERED' || response.data.data.status == 'CANCELED') {
            this.restart()
            console.log('restart')
            return 0;
          }
          this.cart = response.data.data

          if (this.withVivaWallet && this.cart.tip_value) {
            // this.addOrRemoveTipRequest(0)
            this.addOrRemoveTip(0)
          } else {
            this.customTip = (this.cart.tip_value && this.cart.tip_value > 0) ? this.cart.tip_value : ''
          }

          this.markUnorderableCartLinesFromResponse(response.data)
          
          if (this.json.type != 'Kiosk') {
            // this.selectedPeople = this.cart.people.map(person => person.fingerprint);

            clearTimeout(this.timeoutCartReload)
            this.timeoutCartReload = setTimeout(()=>{
              this.getTheCart()
            }, 30000) // 30sec
          }

          if (callback) {
            callback()
          }
        } else {
          if (response && response.data.errors.hasOwnProperty('shopping_cart_id')) {
            // Popup + log intai; restart-ul se face dupa OK, din showCartLostPopup().
            this.showCartLostPopup(response)
          }
        }
      })
    },
    getPaymentProfile () {
      this.sendCheckSignalFiscalIsOnnline()
      var data = {
        token: this.token,
        use_pos: true,
        add_order: true,
        company_id: this.json.company_id,
        shopping_cart_id: this.shopping_cart_id,
      }
      this.apiRequest('/paymentprofile', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cardPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'card').length
          this.cashPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'cash').length
          // Setare per-kiosk: daca "Dezactiveaza plata cash" e bifata in backend,
          // ascundem cash indiferent de ce metode a intors apelul de mai sus.
          if (this.disableCashPayment) {
            this.cashPaymentEnabled = false
          }
          this.posOnDeliveryPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'pos').length
          this.kioskPosOnDeliveryPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'kiosk_pos').length
          this.freePaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'free').length
        } else if (response && response.data && response.data.errors && response.data.errors.hasOwnProperty('shopping_cart_id')) {
          // Popup + log intai; restart-ul se face dupa OK, din showCartLostPopup().
          this.showCartLostPopup(response)
        } else {
          // Apelul de metode de plata a esuat: NU putem sti ce metode sunt permise,
          // asa ca le dezactivam pe TOATE cele care vin din acest apel (card/cash/
          // pos/kiosk_pos/free). Metodele care NU depind de acest apel (ex: Viva
          // Wallet pe QR, care vine din alt apel) raman neatinse.
          this.cardPaymentEnabled = false
          this.cashPaymentEnabled = false
          this.posOnDeliveryPaymentEnabled = false
          this.kioskPosOnDeliveryPaymentEnabled = false
          this.freePaymentEnabled = false
          this.generalErrorSwal('/paymentprofile', response, this.$t('general.errPaymentProfileLoad'))
        }
      })
    },
    editToCartUpdateQuantity (quantity, productId, productIndex, oldQuantity) {
      if (!this.editToCartUpdateQuantityIsAllready) {
        const productInCart = ((this.cart.myCart && this.cart.myCart.products) || []).find((product) => product.index === productIndex)
        if (quantity > oldQuantity && productInCart && this.verifyProductStockInCart(productInCart)) {
          return 0
        }
        // console.log('quantity', quantity);
        // console.log('oldQuantity', oldQuantity);
        if (quantity > oldQuantity) {
          let stock = this.getProductStock(productId);
          const increase = quantity - oldQuantity;
          // console.log('stock:', stock);
          // console.log('increase:', increase);
          if (stock !== false && increase > stock) {
            return 0;
          }
        }

        var data2 = {
          token: this.token,
          fingerprint: this.fingerprint,
          company_id: this.json.company_id,
          action: 'update_quantity',
          add_order: true,
          shopping_cart_id: this.cart.shopping_cart_id,
          quantity: quantity,
          product_id: productId,
          product_index: productIndex,
          products_need_deleted: true
        }
        if (this.json.type != 'Kiosk') {
          data2.qr_version = this.qr_version
        }
        if (quantity >= 1) {
          // La fel ca la add/edit/delete: blocam butoanele de plata cat timp
          // recalcularea cantitatii e in curs ("Se calculeaza totalul...").
          this.addProductInCartRequest++
          this.apiRequest('/update-cart', 'PUT', data2, (response) => {
            try {
              if (response && response.data && (
                response.data.reason === 'units_limit_reached' ||
                response.data.reason === 'campaign_discount_unavailable' ||
                response.data.unorderable
              )) {
                this.getDiscountsForProducts(null, [productId])
                this.markUnorderableCartLinesFromResponse(response.data)
                let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
                Swal.fire({
                  title: response.data.reason === 'units_limit_reached'
                    ? (this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'))
                    : (this.$t('addOrder.campaignDiscountUnavailable') || this.$t('addOrder.productUnavailable')),
                  target: document.getElementById('swal-template'),
                  customClass: { container: className }
                })
                return 0
              }
              if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
                // this.getTheCart()
                this.cart = response.data.data
                // Object.assign(this.cart, response.data.data)
                this.modificationsInCart()

                this.updateStock(productId)
                this.goToMenuIfCartEmpty()
                this.getDiscountsForProducts(null, [productId])
                this.markUnorderableCartLinesFromResponse(response.data)
              } else {
                if (response && response.data.errors.hasOwnProperty('freeze_order')) {
                  let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
                  Swal.fire({
                    title: this.$t('addOrder.order_id_freeze'),
                    target: document.getElementById('swal-template'),
                    customClass: {
                      container: className,
                    }
                  });
                }
              }
            } finally {
              this.addProductInCartRequest--
              this.editToCartUpdateQuantityIsAllready = false
            }
          })
        }
      }
      this.editToCartUpdateQuantityIsAllready = true
    },
    updateQuantity (prod, add) {
      if (prod.quantity >= 1) {
        if (add) {
          if (this.canIncreaseProductQuantity(prod)) {
            prod.quantity++
          }
        } else {
          if (prod.quantity > 1) {
            prod.quantity--
          }
        }
      }
      this.updateCategories()
    },
    changeName ($name, callback) {
      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        add_order: true,
        action: 'name_fingerprint',
        shopping_cart_id: this.cart.shopping_cart_id,
        full_name: $name
      }
      if (this.json.type != 'Kiosk') {
        data.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          // this.getTheCart()
          this.cart = response.data.data
          // Object.assign(this.cart, response.data.data)
          this.modificationsInCart()
        } else {
          if (response && response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
        }
        callback()
      })
    },
    changeNameFgp () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.titlePopupEditFgpName'),
        input: 'text',
        inputAttributes: {
          autocapitalize: 'on'
        },
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        },
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: this.$t('addOrder.addPopupEditFgpName'),
        showLoaderOnConfirm: true,
        preConfirm: (val) => {
          this.changeName (val, ()=>{
            Swal.close()
            Swal.hideLoading()
          })
        }
        // allowOutsideClick: () => !swal.isLoading()
      })
    },
    // La prima intrare in view-ul de masa, cerem prenumele daca NU e activat Viva Wallet.
    // Meniul consultativ al companiei 254 nu cere nume. Pentru restul, numele e trimis
    // cu action:'name_fingerprint' prin changeName().
    promptFirstNameIfNeeded () {
      if (this.json.type == 'Kiosk') return;
      if (Number(this.json.company_id) === 254) return;
      if (this.withVivaWallet) return;
      // "prima data" = persoana curenta (fingerprint-ul meu) nu are inca un nume setat
      let me = (this.cart && Array.isArray(this.cart.people))
        ? this.cart.people.find(p => String(p.fingerprint) === String(this.fingerprint))
        : null;
      if (me && me.full_name !== me.fingerprint) return;
      Swal.fire({
        title: this.$t('addOrder.askFirstNameTitle'),
        input: 'text',
        inputAttributes: {
          autocapitalize: 'on'
        },
        target: document.getElementById('swal-template'),
        customClass: {
          container: 'smallSwall',
        },
        confirmButtonText: this.$t('addOrder.addPopupEditFgpName'),
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showLoaderOnConfirm: true,
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return this.$t('addOrder.askFirstNameRequired');
          }
        },
        preConfirm: (val) => {
          return new Promise((resolve) => {
            this.changeName(val.trim(), () => {
              Swal.hideLoading();
              resolve();
            });
          });
        }
      })
    },
    modifyProduct (prod) {
      if (this.json.type === 'Kiosk') {
        this.openProduct(prod, true);
      } else if (this.selectedFingerprint === this.fingerprint.toString()) {
        if (((prod.hasOwnProperty('status') && (!prod.status || prod.status == 'Draft')) ||
             !prod.hasOwnProperty('status')
            )) {
          this.openProduct(prod, true);
        }
      }
    },
    deleteProduct (prodId, index) {
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        action: 'remove_product',
        add_order: true,
        product_id: prodId,
        product_index: index,
        products_need_deleted: true
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      // La fel ca la add: cat timp stergerea e in curs, blocam butoanele de plata
      // (pe pagina de plata apare "Se calculeaza totalul..."). Daca clientul ajunge
      // pe pagina de plata inainte sa vina raspunsul, trebuie sa astepte ultimul request.
      this.addProductInCartRequest++
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        // `finally` garanteaza decrementarea flagului pe ORICE iesire (succes, eroare,
        // sau exceptie neasteptata), ca sa nu ramana blocat != 0 si sa tina loaderul pornit.
        try {
          if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.updateStock(prodId)
            this.getDiscountsForProducts(null, [prodId])
            this.goToMenuIfCartEmpty()
          } else {
            if (response && response.data.errors.hasOwnProperty('freeze_order')) {
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.order_id_freeze'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
            }
          }
        } finally {
          this.addProductInCartRequest--
        }
      })
    },
    // Dupa ce raspunsul stergerii a ajuns: daca mai sunt produse in cos, ramanem pe
    // pagina de plata; daca nu mai e niciun produs, ducem clientul inapoi pe meniu
    // (inchidem modalul de plata, la fel ca unfreezeOrder). Fara asta, clientul ar
    // ramane pe o pagina de plata cu cos gol => risc de plata/bon fiscal fara produse.
    goToMenuIfCartEmpty () {
      var hasProducts = !!(this.cart && this.cart.myCart && this.cart.myCart.products && this.cart.myCart.products.length)
      if (!hasProducts && this.showPaymentModal) {
        this.showPaymentModal = false
      }
    },
    emptyCartWithQuestion () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.emptyCart'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: true,
        reverseButtons: true,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.emptyCart(false)
        }
      })
    },
    emptyCart (withTableUsers = false) {
      if (this.cart && this.cart.status != 'DRAFT') {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        Swal.fire({
              title: this.$t('addOrder.errorRelogin'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            }).then( (result) => {
          // window.location.href = "https://www.taptasty.com/";
          this.restart()
          console.log('restart')
          return 0;
        })
        return 0;
      }
      let cartId = null;
      if (this.cart) {
        cartId = this.cart.shopping_cart_id;
      } else {
        cartId = this.shopping_cart_id;
      }
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: cartId,
        action: 'empty_order',
        add_order: true,
        remove_people: 1,
        withTableUsers: withTableUsers,
        table_id: this.json.id,
        products_need_deleted: true
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      // Ca la delete: blocam butoanele de plata cat timp golirea e in curs, ca sa nu
      // se poata plati/fiscaliza un cos care tocmai a fost golit.
      this.addProductInCartRequest++
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        try {
          if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.getStocksForProducts()
            this.goToMenuIfCartEmpty()
          } else {
            if (response && response.data.errors.hasOwnProperty('freeze_order')) {
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.order_id_freeze'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
            }
          }
        } finally {
          this.addProductInCartRequest--
        }
      })
    },
    getBanner () {
      this.loading = true
      this.banners = []
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        location_id: this.json.location_token,
        delivery_method: this.getPricingDeliveryMethod()
      }
      this.apiRequest('/banner', 'GET', data2, (response) => {
        if (response && response.data.status === true) {
          this.splashScreenBanners = []
          for (var i = response.data.data.length - 1; i >= 0; i--) {
            if (response.data.data[i].image_banner && 
              response.data.data[i].image_banner != '' &&
              response.data.data[i].image_banner.indexOf('placeholder') <= -1
              ) {
              this.banners.push(response.data.data[i])
            }
            if (response.data.data[i].image_landing && 
              response.data.data[i].image_landing != '' &&
              response.data.data[i].image_landing.indexOf('placeholder') <= -1
              ) {
              this.splashScreenBanners.push(response.data.data[i])
            }
          }

          if (this.showSplashScreenModal && this.splashScreenBanners.length) {
            this.timeoutSplashScreenBanners()
          }
          this.loading = false
        }
      })
    },
    timeoutSplashScreenBanners () {
      clearTimeout(this.sliderNextTimeout);
      if (this.showSplashScreenModal && this.splashScreenBanners.length) {
        this.sliderNextTimeout = setTimeout(() => {
          if (this.nextSplashScreenSlider < (this.splashScreenBanners.length - 1)) {
            this.nextSplashScreenSlider++;
          } else {
            this.nextSplashScreenSlider = 0;
          }
          this.timeoutSplashScreenBanners()
        }, 10000 )
      }
    },
    getTop (top) {
      if (top.categories[0] && top.categories[0].id) {
        this.getProducts(top.categories[0].id, top.id)
        this.searchText = ''
      }
    },
    getStocksForProducts (callback) {
      this.products_id_has_stock_active = []
      this.stocksForProducts = {}

      if (!Array.isArray(this.products)) {
        return
      }

      this.products.forEach((p) => {
        const stock = p.stock;

        // dacă există stock și NU permite negative stock
        const hasOwnStock = !!stock && stock.allow_negative_stock === false;

        // un produs poate fi blocat și de opțiunile lui (ex: opțiune required
        // a cărei singură valoare e epuizată), chiar dacă el nu are stoc propriu
        const hasOptionStock = Array.isArray(p.product_options_stocks) && p.product_options_stocks.length > 0;

        if (hasOwnStock || hasOptionStock) {
          this.products_id_has_stock_active.push(p.id);
        }
      });

      if (this.products_id_has_stock_active && this.products_id_has_stock_active.length) {
        var data = {
          company_id: this.json.company_id,
          location_true_id: this.locationTrueId,
          source: this.getPricingSource(),
          products_ids: this.products_id_has_stock_active
        }
        // stocul returnat tine cont de ce am deja in cos, ca sa nu ni se arate
        // ca disponibil ceva ce am rezervat deja (rezervarea expira in 5 min)
        if (this.cart && this.cart.order_id) {
          data.order_id = this.cart.order_id
        }
        this.apiRequest('/get-products-stock', 'GET', data, (response) => {
          if (response.data.status) {
            this.stocksForProducts = response.data.data.stocks
            // {
            //   "38801": {
            //     "in_stock": true,
            //     "stock": {
            //       "id": 18,
            //       "stock": 2,
            //       "decrease_stock": true,
            //       "allow_negative_stock": false
            //     }
            //   }
            // }
          }
          if (callback) callback()
        });
      } else {
        if (callback) callback()
      }
    },
    // Produsele marcate indisponibile pentru compania + locatia curenta
    // (tabela availability_products, setate din POS/admin). Se afiseaza ca
    // "indisponibil" in grid, la fel ca produsele fara stoc. Aceeasi sursa care
    // intoarce eroarea no_availability la add / product_validation / complete_order.
    // Rezultatul NU depinde de categorie, deci throttle la max 1 apel / minut ca sa
    // nu se cheme de fiecare data cand navighezi printre categorii. `force = true`
    // sare peste throttle (ex: dupa o eroare no_availability).
    checkProductIndisponibility (callback, force = false) {
      const now = Date.now()
      if (!force && this.lastIndisponibilityCheckAt && (now - this.lastIndisponibilityCheckAt) < 60000) {
        if (callback) callback()
        return
      }
      this.lastIndisponibilityCheckAt = now
      if (!this.json || !this.json.company_id || !this.locationTrueId) {
        this.indisponibleProducts = {}
        if (callback) callback()
        return
      }
      var source = this.json.type
      if (this.json.type != 'Kiosk') {
        source = 'QR'
      }
      var data = {
        company_id: this.json.company_id,
        location_id: this.locationTrueId,
        source: source
      }
      this.apiRequest('/noauth/availability-products', 'GET', data, (response) => {
        const products = response && response.data && response.data.status && response.data.data
          ? response.data.data.products
          : null
        if (Array.isArray(products)) {
          const map = {}
          products.forEach((p) => {
            if (p && p.product_id != null) {
              map[p.product_id] = p
            }
          })
          this.indisponibleProducts = map
        }
        if (callback) callback()
      })
    },
    productIsIndisponible (prodId) {
      return !!this.indisponibleProducts[prodId]
    },
    // Marcheaza imediat (sincron) produsele intoarse in eroarea no_availability
    // de la add / product_validation / complete_order, ca sa se vada in cos care
    // produs e indisponibil fara sa astepti apelul de availability. Reasignam
    // obiectul pentru reactivitate (Vue 2).
    setIndisponibleFromNoAvailability (list) {
      if (!Array.isArray(list)) return
      const map = { ...this.indisponibleProducts }
      list.forEach((p) => {
        if (p && p.product_id != null) {
          map[p.product_id] = p
        }
      })
      this.indisponibleProducts = map
    },
    getStocksForProductOptions (callback) {
      const rawStocks = (this.currentProductInPopup && this.currentProductInPopup.product_options_stocks) || []
      this.stocksForProductOptions = {}
      this.productOptionsCovStockMap = {}

      // Suportă ambele formate:
      //  - nou: [{ company_option_value_id, product_id }, ...]
      //  - vechi: [product_id, ...]
      const productIds = []
      rawStocks.forEach((item) => {
        if (item && typeof item === 'object') {
          if (item.company_option_value_id != null && item.product_id != null) {
            this.productOptionsCovStockMap[item.company_option_value_id] = item.product_id
          }
          if (item.product_id != null) {
            productIds.push(item.product_id)
          }
        } else if (item != null) {
          productIds.push(item)
        }
      })
      this.product_options_id_has_stock_active = productIds

      if (this.product_options_id_has_stock_active && this.product_options_id_has_stock_active.length) {
        var data = {
          company_id: this.json.company_id,
          location_true_id: this.locationTrueId,
          source: this.getPricingSource(),
          products_ids: this.product_options_id_has_stock_active
        }
        // vezi getStocksForProducts: stocul se raporteaza la cosul curent
        if (this.cart && this.cart.order_id) {
          data.order_id = this.cart.order_id
        }
        this.apiRequest('/get-products-stock', 'GET', data, (response) => {
          // robust la wrapper: uneori vine {status, data:{stocks}}, alteori direct {stocks}
          const payload = (response && response.data) ? response.data : {}
          const stocks = (payload.data && payload.data.stocks) || payload.stocks || {}
          this.stocksForProductOptions = stocks
          // Cheia e product_id (din product_options_stocks). Legătura valoare->product_id
          // se face prin productOptionsCovStockMap (company_option_value_id -> product_id).
          // {
          //   "42401": {
          //     "in_stock": true,
          //     "stock": { "id": 42, "stock": 1, "allow_negative_stock": false }
          //   }
          // }
          if (callback) callback()
        });
      } else {
        if (callback) callback()
      }
    },
    getProducts (categoryID = null, topCategoryID = null, search = null, aiProducts = null, callback = null, forCacheOnly = null) {
      const orderMethodRequestId = this.orderMethodRequestId
      let timeoutLoading = null
      let selectedTopCategoryIsDifferent = false

      const productList = document.querySelector(".productList");
      if (productList) {
          productList.classList.remove('show');
          productList.classList.add('hide');
      }

      if (!this.kiosk_is_using_top_category) {
        topCategoryID = null
      }
      if (!forCacheOnly) {
        this.selectedCategory = categoryID
        if (this.selectedTopCategory != topCategoryID) {
          this.selectedTopCategory = topCategoryID
          selectedTopCategoryIsDifferent = true
        }
        timeoutLoading = setTimeout(() => {
          this.loading = true
        }, 300)
      }
      var data2 = this.appendPricingContext({
        company_id: this.json.company_id,
        location_id: this.json.location_token,
        with_top_category: 0,
        from_kiosk: 1,
        with_cache: true
      })
      if (categoryID) {
        data2.category_id = categoryID
      }
      if (topCategoryID) {
        data2.selected_top_category = topCategoryID
      }
      if (search) {
        data2.search = search
      } else {
        this.clearKeyBoard()
        this.searchText = ''
      }
      if (aiProducts) {
        data2.ai_products = aiProducts
      }

      let reqLink = '/admin-order-products'
      if (this.kiosk_is_using_top_category) {
        reqLink = '/kiosk-order-products'
        data2.with_top_category = 1
      }
      this.apiRequest(reqLink, 'GET', data2, (response) => {
        if (orderMethodRequestId !== this.orderMethodRequestId || data2.delivery_method !== this.getPricingDeliveryMethod()) {
          clearTimeout(timeoutLoading)
          return
        }
        if (response && response.data.status === true && !forCacheOnly) {
          this.category = response.data.data.categories
          this.products = response.data.data.products
          this.top_category = response.data.data.top_category
          if (response.data.data.products.length) {
            this.currency_symbol = response.data.data.products[0].price_details.currency_symbol
          }
          if (!categoryID && !search && this.category.length) {
            if (this.top_category.length) {
              this.selectedTopCategory = this.top_category[0].id
              this.selectedCategory = this.top_category[0].categories[0].id
            } else {
              this.selectedCategory = this.category[0].id
            }
          }

          this.checkProductIndisponibility()
          this.getStocksForProducts(()=>{
            this.getDiscountsForProducts(() => {
              this.scroolTopCategory(categoryID, selectedTopCategoryIsDifferent)
              this.scroolTopProducts()
              this.setScroolVars(document.querySelector(".productList"), this.activeProductList)
              clearTimeout(timeoutLoading)
              this.loading = false

              // Adaugă clasa 'show' când produsele sunt încărcate
              if (productList) {
                setTimeout(() => {
                    productList.classList.remove('hide');
                    productList.classList.add('show');
                }, 100);
              }
            })
          });
        } else if (!forCacheOnly && !(response && response.data && response.data.status === true)) {
          // Incarcarea produselor a esuat (fail de transport SAU 200 cu eroare):
          // anuntam clientul + aratam de la ce apel vine eroarea.
          clearTimeout(timeoutLoading)
          this.loading = false
          this.generalErrorSwal(reqLink, response, this.$t('general.errProductsLoad'))
        }
        if (callback) callback(response)

        if (!forCacheOnly && response && !response.requestFromCache && response.data && response.data.data && response.data.data.products) {
          this.openAllProducts(response.data.data.products)
        }

      })
    },
    redirectFromImage (slider) {
      if (slider.link_type == 'product' ) {
        this.openProduct({
          'id': slider.link_id
        }, null)
      } else if (slider.link_type == 'category') { 
        this.scroolTopCategory(slider.link_id, true)
        this.scroolTopProducts()
        this.getProducts(slider.link_id)
      } else if (slider.link_type == 'page') { 
        // Do nothing
      } else {
        // Do nothing
      }
    },
    scroolTopCategory (catId, selectedTopCategoryIsDifferent) {
      // let allCategories = []
      // for (var i = 0; i < this.top_category.length; i++) {
      //   for (var j = 0; j < this.top_category[i].categories.length; j++) {
      //     allCategories.push(this.top_category[i].categories[j])
      //   }
      // }
      // for (var i = 0; i < this.category.length; i++) {
      //   allCategories.push(this.category[i])
      // }
      // if (this.allCategories.filter(el => el.id == catId)[0].top_category_id) {

      // }
      if (!this.selectedTopCategory) {
        const categoryDiv = document.getElementsByClassName("filter__cat")[0]
        let thisCategory = document.querySelector('.filter__cat > a')
        if (this.json.type == 'Kiosk') {
          if (catId) {
            thisCategory = document.getElementsByClassName('' + catId)[0]
          }
          if (thisCategory) {
            categoryDiv.scrollTo({ top: thisCategory.offsetTop - 90, behavior: 'smooth'});
          }
        } else {
          if (catId) {
            thisCategory = document.getElementsByClassName('' + catId)[0]
          }
          if (thisCategory) {
            categoryDiv.scrollTo({ left: thisCategory.offsetLeft - categoryDiv.offsetWidth/2 + thisCategory.offsetWidth/2, behavior: 'smooth'});
          }
        }
      } else {
        //TopCat
        const topCategoryDiv = document.getElementsByClassName("filter__cat")[0]
        let thisTopCategory = document.querySelector('.filter__cat > .topGroup')
        
        if (this.json.type == 'Kiosk') {
          thisTopCategory = document.getElementsByClassName('' + this.selectedTopCategory)[0]
          if (thisTopCategory) {
            setTimeout(()=>{
              topCategoryDiv.scrollTo({ top: thisTopCategory.offsetTop - 90, behavior: 'smooth'});
            }, 100) // wait for prev TopCat to close up and curent TopCat to open
          }
        } else if (selectedTopCategoryIsDifferent) {
          thisTopCategory = document.getElementsByClassName('' + this.selectedTopCategory)[0]
          if (thisTopCategory) {
            topCategoryDiv.scrollTo({ left: thisTopCategory.offsetLeft - topCategoryDiv.offsetWidth/2 + thisTopCategory.offsetWidth/2, behavior: 'smooth'});
          }
        }

        //catWithTopCat
        if (this.json.type == 'Kiosk') {
          // No need for this design
          // const categoryDiv = document.querySelector(".filter .filter__cat")
          // let thisCategory = document.querySelector('.filter .filter__cat > a')
          // if (catId) {
          //   thisCategory = document.getElementsByClassName('' + catId)[0]
          // }
          // if (thisCategory) {
          //   categoryDiv.scrollTo({ top: thisCategory.offsetTop - 90, behavior: 'smooth'});
          // }
        } else {
          setTimeout(()=>{
            const categoryDiv = document.querySelector(".filter2 .filter__cat")
            let thisCategory = document.querySelector('.filter2 .filter__cat > a')
            if (catId) {
              thisCategory = document.getElementsByClassName('' + catId)[0]
            }
            if (thisCategory && categoryDiv) {
              categoryDiv.scrollTo({ left: thisCategory.offsetLeft - categoryDiv.offsetWidth/2 + thisCategory.offsetWidth/2, behavior: 'smooth'});
            }
          }, 10)
        }
      }
    },
    scroolTopProducts () {
      if (this.error || this.blockKioskFiscalError) {
        return 0;
      }
      const container = document.getElementsByClassName("productList")[0]
      container.scrollTo({ top: 0, behavior: 'smooth'});
    },
    onSwipeTop () {
      // console.log('asd');
    },
    openPagerModal () {
      if (this.json.type == 'Kiosk') {
        this.showPagerModal = true
        this.showPaymentModal = false
        this.activeKeyboard = true
        this.keyboard.clearInput()
        this.pagerText = ''
        this.$nextTick(() => {
          if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 500)
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 1000)
        })
      }
    },
    closePagerModal () {
      this.showPagerModal = false
      this.showPaymentModal = true
      this.activeKeyboard = false
      this.keyboard.clearInput()
      this.pagerText = ''
    },
    applyPager () {
      this.pager = this.pagerText
      this.closePagerModal()
      if (this.pager != '') {
        this.disablePaymentClass = '';
      } else {
        this.disablePaymentClass = 'disabled';
      }
    },
    showCoupon () {
      if (this.json.type == 'Kiosk') {
        this.showCouponModal = true
        this.activeKeyboard = true
        this.keyboard.clearInput()
        this.couponText = ''  
      } else {
        this.showCouponModal = true
        this.couponText = ''
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs["couponCode"]) this.$refs["couponCode"].focus()
        }, 500)
      })
    },
    closeCouponModal () {
      if (this.json.type == 'Kiosk') {
        this.showCouponModal = false
        this.activeKeyboard = false
        this.keyboard.clearInput()
        this.couponText = ''
      }
    },
    toggleCoupon() {
      if (this.couponApplied) {
        this.couponText = '';
        this.applyCoupon(false);
      } else if (this.couponText.trim()) {
        this.applyCoupon(true);
      }
    },
    applyCoupon (apply) {
      if (apply) {
        this.applyCouponRequest(this.couponText, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.couponApplied = true;
          }
          if (response.data.errors.wrong_coupon) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.errorPopupCoupon'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
          this.showCouponModal = false
          if(this.json.type == 'Kiosk') {
            this.couponText = ''
            this.keyboard.clearInput()
          }
        })
      } else {
        this.applyCouponRequest('', (response) => { // remove coupon
          if (response.data.status === true) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.couponApplied = false;
            this.couponText = '';
          } else {
            if (response.data.errors.hasOwnProperty('freeze_order')) {
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.order_id_freeze'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
            }
          }
        })
      }
    },
    applyCouponRequest (couponText = '', callback) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'use_coupon',
        add_order: true,
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.json.type != 'Kiosk') {
        data.qr_version = this.qr_version
      }
      if (couponText != '') {
        data.apply_coupon = true
        data.status = true
        data.coupon = couponText
        data.check_coupon= 'check_coupon'
      } else {
        data.apply_coupon = false
        data.status = false
        data.coupon = ''
      }
      this.apiRequest('/update-cart', 'PUT', data, (response) => {
        if(callback) callback(response);
      })
    },
    useOrRemoveLoyaltyPoints (flag = 0) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'use_loyalty_points',
        status: flag,
        add_order: true,
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.json.type != 'Kiosk') {
        data.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', data, (response) => {
        if (response && response.data.status === true) {
          this.cart = response.data.data
          this.modificationsInCart()
        }
      })
    },
    closeWalletModal () {
      if (this.json.type == 'Kiosk') {
        this.showWalletModal = false
        this.activeKeyboard = false
        this.keyboard.clearInput()
        this.walletValue = ''
      }
    },
    async openWalletPopup () {
      if (this.json.type == 'Kiosk') {
        await this.definKeyboard()
        this.showWalletModal = true
        this.activeKeyboard = true
        this.keyboard.clearInput()
        this.walletValue = null
      } else {
        this.showWalletModal = true
        this.walletValue = null
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs["couponCode"]) this.$refs["couponCode"].focus()
        }, 500)
      })
    },
    removeFromWallet () {
      this.useWalletRequest(0)
    },
    useWalletRequest (walletValue, callback) {
      const data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'use_wallet',
        wallet_value: walletValue,
        shopping_cart_id: this.cart.shopping_cart_id
      }

      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data
          this.modificationsInCart()
          if (callback) {
            callback()
          }
        }
      })
    },
    applyWallet () {
      if (!this.walletValue || this.walletValue <= 0) {
        Swal.fire({
            title: this.$t('general.selectWalletValueErr') + this.client.wallet_value + ' ' + this.currency_symbol,
            target: document.getElementById('swal-template'),
            customClass: {
              container: 'bigSwall',
            }
        }).then(() => {
          this.closeWalletModal()
        })
        return
      }
      
      this.walletValue = parseFloat(this.walletValue);

      if (this.walletValue > this.client.wallet_value) {
        Swal.fire({
            title: this.$t('general.selectWalletValueErr') + this.client.wallet_value + ' ' + this.currency_symbol,
            target: document.getElementById('swal-template'),
            customClass: {
              container: 'bigSwall',
            }
        }).then(() => {
          this.closeWalletModal()
        })
        return
      }

      if (this.cart.myCart.total_cart_price < this.walletValue) {
        Swal.fire({
            title: this.$t('general.selectWalletValueErr2') + this.cart.myCart.total_cart_price + ' ' + this.currency_symbol,
            target: document.getElementById('swal-template'),
            customClass: {
              container: 'bigSwall',
            }
        }).then(() => {
          this.closeWalletModal()
        })
        return
      }

      this.useWalletRequest(this.walletValue, () => {
        this.showWalletModal = false
        this.closeWalletModal()
      })
    },
    // openWalletPopup () {
    //   Swal.fire({
    //     title: this.$t('general.selectWalletValue'),
    //     input: 'number',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: this.$t('addOrder.btnPopup'),
    //     showLoaderOnConfirm: true,
    //     target: document.getElementById('swal-template'),
    //     customClass: {
    //       container: 'bigSwall',
    //     },
    //     preConfirm: (val) => {
    //       if (val <= this.client.wallet_value) {
    //         var data2 = {
    //           token: this.token,
    //           company_id: this.json.company_id,
    //           action: 'use_wallet',
    //           wallet_value: val || 0,
    //           shopping_cart_id: this.cart.shopping_cart_id
    //         }
    //         this.apiRequest('/update-cart', 'PUT', data2, (response) => {
    //           if (response.data.status === true) {
    //             this.cart = response.data.data
    //             this.modificationsInCart()
    //             Swal.close()
    //           }
    //         })
    //       } else {
    //         Swal.fire({
    //           title: this.$t('general.selectWalletValueErr') + this.client.wallet_value,
    //           target: document.getElementById('swal-template'),
    //           customClass: {
    //             container: 'bigSwall',
    //           }
    //         });
    //       }
    //     }
    //   })
    // },
    addOrRemoveTipRequest (tip_value = 0, callback) {
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'set_tip',
        add_order: true,
        tip_value: tip_value || 0,
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (callback) {
          callback(response)
        }
      })
    },
    addOrRemoveTip (flag, directToPayment = false) {
      if (flag) {
        Swal.fire({
          title: this.$t('addOrder.titlePopupTip'),
          input: 'number',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          target: document.getElementById('swal-template'),
          preConfirm: (val) => {
            this.addOrRemoveTipRequest(val, (response) => {
              if (response.data.status === true) {
                this.cart = response.data.data
                this.modificationsInCart()
                Swal.close()
                if (directToPayment) {
                  this.payNew()
                }
              }
              Swal.hideLoading()
            })
          }
          // allowOutsideClick: () => !swal.isLoading()
        })
      } else {
        this.addOrRemoveTipRequest(0, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data;
            this.modificationsInCart();
            this.selectedTip = null;
          }
        })
      }
    },
    addOrRemoveCustomTip() {
      if (this.customTip !== '') {
        const existingTip = this.cart.order_totals.find(({ name }) => name === 'Tip')?.value || '';
        if (parseFloat(this.customTip) === parseFloat(existingTip)) {
          this.removeCustomTip();
        } else {
          this.addCustomTip();
        }
      }
    },
    addCustomTip() {
      this.tipValue = parseFloat(this.customTip);
      this.addOrRemoveTipRequest(tipValue, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.selectedTip = null; // Clear selected tip if a custom tip is added
        }
      });
    },
    removeCustomTip() {
      this.addOrRemoveTipRequest(0, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.customTip = '';
          this.selectedTip = null; // Clear selected tip
          this.tipValue = 0;
        }
      });
    },
    addTipDirect(percentage) {
      if (this.selectedTip === percentage) {
        // Deselect if the same tip is clicked again
        this.addOrRemoveTipRequest(0, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data;
            this.modificationsInCart();
            this.selectedTip = null; // Reset selected tip
            this.customTip = ''; // Clear custom tip input
          }
        });
      } else {
        const totalAmount = this.cart.myCart.total_cart_price;
        const tipValue = totalAmount * (percentage / 100);
    
        this.addOrRemoveTipRequest(tipValue, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data;
            this.modificationsInCart();
            this.selectedTip = percentage;
            this.customTip = ''; // Clear custom tip input
          }
        });
      }
    },
    addTipDirectCart(percentage, justReCalc = 0) {
      if (this.selectedTip === percentage && !justReCalc) {
        // Deselect if the same tip is clicked again
        this.selectedTip = null;
        this.customTip = '';
        this.tipValue = 0;
      } else {
        let totalAmount;
  
        if (this.selectedFingerprint === 'all') {
          // When 'all' is selected, calculate tip based on the total cart price
          totalAmount = parseFloat(this.cart.myCart.total_cart_price - this.tipValue);
        } else {
          // When not 'all', find the person with the selectedFingerprint and use their total_cart_price
          const selectedPerson = this.cart.people.find(person => person.fingerprint === this.selectedFingerprint);
          if (selectedPerson) {
            totalAmount = parseFloat(selectedPerson.total_cart_price);
          } else {
            totalAmount = 0; // Default value if no matching person is found
          }
        }
        // Calculate tip value based on the total amount
        // const calculatedTipValue = Math.floor(totalAmount * (percentage / 100));
        let calculatedTipValue =  Number(totalAmount * (percentage / 100));
        calculatedTipValue =  calculatedTipValue.toFixed(2);
  
        // Set the calculated tip value and selected tip
        this.tipValue = calculatedTipValue;
        // console.log(this.tipValue); // For debugging purposes
  
        this.selectedTip = percentage;
        this.customTip = ''; // Clear custom tip if any
      }
    },
    addOrRemoveCustomTipCart() {
      const currentTipValue = parseFloat(this.customTip) || 0;
  
      if (currentTipValue === this.tipValue) {
        this.tipValue = 0;
        this.customTip = '';
      } else {
        this.tipValue = Math.floor(currentTipValue);
        this.selectedTip = null;
      }
    },
    openTipModal() {
      // Pre-populează selectedTipValue dacă există deja un tip
      // const currentTip = this.cart.order_totals.find(({ name }) => name === 'Tip');
      // if (currentTip && currentTip.value > 0) {
      //   // Încearcă să identifici dacă tipul curent e din sugestii
      //   this.selectedTipValue = this.identifyCurrentTipSource(currentTip.value);
      // }
      this.showTipModal = true;
    },
    closeTipModal() {
      this.showTipModal = false;
    },
    openCustomTipModal() {
      // this.customTipInput = this.customTipValue > 0 ? this.customTipValue.toString() : '';
      this.customTipInput = ''
      this.showTipModal = false;
      this.showCustomTipModal = true;
    },
    closeCustomTipModal() {
      this.showCustomTipModal = false;
      this.showTipModal = false;
      this.showCustomTipModal = false;
    },
    appendToCustomTip(char) {
      // Previne multiple puncte
      if (char === '.' && this.customTipInput.includes('.')) return;
      
      // Limitează zecimalele la 2
      if (this.customTipInput.includes('.')) {
        const parts = this.customTipInput.split('.');
        if (parts[1] && parts[1].length >= 2) return;
      }

      // Limitează lungimea totală
      if (this.customTipInput.length > 8) return;

      this.customTipInput += char.toString();
    },

    backspaceCustomTip() {
      this.customTipInput = this.customTipInput.slice(0, -1);
    },

    confirmCustomTip() {
      const tipAmount = parseFloat(this.customTipInput);
      if (!tipAmount || tipAmount <= 0) return;

      this.addOrRemoveTipRequest(tipAmount, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.selectedTipValue = null;  // Nu e din lista predefinită
          this.tipValue = tipAmount
          this.customTipValue = tipAmount;
          this.closeCustomTipModal();
          this.closeTipModal();
        }
      });
    },
    // identifyCurrentTipSource(currentTipValue) {
    //   if (!this.tip_suggestion || this.tip_suggestion.type !== 'proc') return null;
      
    //   const totalAmount = this.cart.myCart.total_cart_price;
      
    //   for (const val of this.tip_suggestion.values) {
    //     if (val === 0) continue;
    //     const expectedTip = totalAmount * (val / 100);
    //     // Verifică cu toleranță de 0.01 pentru rotunjiri
    //     if (Math.abs(expectedTip - currentTipValue) < 0.01) {
    //       return val;
    //     }
    //   }
    //   return null;
    // },
    getValidTipValues() {
      if (!this.tip_suggestion || !this.tip_suggestion.values) return [];
      return this.tip_suggestion.values.filter(v => v > 0);
    },
    isSelectedTip(value) {
      // return this.selectedTipValue === value && this.customTipValue === 0;
      return false
    },
    hasActiveTip() {
      const tipTotal = this.cart.order_totals.find(({ name }) => name === 'Tip');
      return tipTotal && tipTotal.value > 0;
    },
    applyTip(value) {
      let tipAmount;

      if (this.tip_suggestion.type === 'proc') {
        // Tip procentual
        const totalAmount = this.cart.myCart.total_cart_price;
        tipAmount = totalAmount * (value / 100);
      } else {
        // Tip fix
        tipAmount = parseFloat(value);
      }

      // Trimite request
      this.addOrRemoveTipRequest(tipAmount, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.selectedTipValue = value;
          this.tipValue = this.cart.tip_value;
          this.customTipValue = 0;
          this.closeTipModal();
        }
      });
    },
    removeTip() {
      this.addOrRemoveTipRequest(0, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.selectedTipValue = null;
          this.customTipValue = 0;
          this.tipValue = 0;
          this.closeTipModal();
        }
      });
    },
    handleKeyupSearch (event) {
      if (event.key === 'Enter') {
        this.newText();
      } else {
        if (this.searchText.length >= 3) {
          clearTimeout(this.debounceSearchText)
          this.debounceSearchText = setTimeout( ()=>{
            this.newText();
          }, 1000)
        }
      }
    },
    newText () {
      if (this.searchText.length >= 1) {
        this.showRemoveTextFromSearch = 1
      } else {
        this.showRemoveTextFromSearch = 0
      }
      this.getProducts(null, null, this.searchText)
    },
    deleteTextFromSearch () {
      this.clearKeyBoard()
      this.getProducts()
      this.showRemoveTextFromSearch = 0;
    },
    deleteTextFromSearchMobile () {
      this.getProducts()
      this.showRemoveTextFromSearch = 0;
      this.searchText = ''
    },
    addProductDirectlyToCart (prod) {
      if (prod.has_product_options) {
        this.openProduct(prod, 0, 0, () => {
          // this.addToCart();
        });
      } else {
        this.openProduct(prod, 0, 1, () => {
          this.addToCart();
        });
      }
    },
    openInfoPopupForOption (optFromList) {
      this.currentOptInInfoPopup = optFromList
      this.showInfoOptModal = true
    },
    closeInfoPopupForOption (prodFromList) {
      this.currentOptInInfoPopup = null
      this.showInfoOptModal = false
    },
    openInfoPopup (prodFromList) {
      this.currentProductInInfoPopup = prodFromList
      this.showInfoProdModal = true
    },
    closeInfoPopup (prodFromList) {
      this.currentProductInInfoPopup = null
      this.showInfoProdModal = false
    },
    productHasNoStock (prodId) {
      if (this.stocksForProducts[prodId] && this.stocksForProducts[prodId].in_stock === false) {
        return true;
      }
      return false;
    },
    // Returneaza:
    //   false -> produsul nu are control de stoc, cantitate nelimitata
    //   0     -> produsul e blocat (stoc propriu epuizat SAU o optiune required epuizata)
    //   N     -> mai pot fi adaugate N bucati
    getProductStock (prodId) {
      const entry = this.stocksForProducts[prodId]

      // produsul nu a fost verificat deloc -> fara control de stoc
      if (!entry) {
        return false
      }

      // Se verifica INAINTE de stocul propriu: un produs poate fi blocat de o optiune
      // required epuizata chiar daca el nu are rand in product_stocks (stock: null).
      if (entry.in_stock === false) {
        return 0
      }

      // disponibil, dar fara stoc propriu (doar optiunile lui sunt gestionate) -> nelimitat
      if (!entry.stock || !entry.stock.id) {
        return false
      }

      return entry.stock.stock
    },
    setProductOptionStocksFromResponse () {
      this.stocksForProductOptions = {}
      this.productOptionsCovStockMap = {}

      const productOptions = (this.currentProductInPopup && this.currentProductInPopup.product_options) || []
      productOptions.forEach((option) => {
        ;(option.values || []).forEach((value) => {
          if (value.company_option_value_id != null && value.product_id != null) {
            this.productOptionsCovStockMap[value.company_option_value_id] = value.product_id
          }
          if (value.product_id != null && value.stock) {
            this.stocksForProductOptions[value.product_id] = {
              in_stock: value.in_stock !== false,
              stock: value.stock
            }
          }
        })
      })
    },
    // Cantitatea pe care linia editata o ocupa deja in cos. Stocul din
    // get-products-stock are scazut TOT cosul, inclusiv linia asta, deci la editare
    // trebuie adaugata inapoi - altfel linia se blocheaza pe ea insasi (o linie cu 5
    // bucati ar vedea limita 5 si nu ar mai putea ramane la 5).
    editedCartLineQuantity (prod) {
      if (!prod || !prod.in_edit || prod.index == null) return 0

      const cartLine = ((this.cart && this.cart.myCart && this.cart.myCart.products) || [])
        .find((product) => product.index === prod.index)

      if (!cartLine || cartLine.id !== prod.id) return 0

      return Number(cartLine.quantity) || 0
    },
    getProductQuantityLimit (prod = this.currentProductInPopup) {
      if (!prod) return false

      const limits = []
      const ownQuantityInCart = this.editedCartLineQuantity(prod)
      const productStock = this.getProductStock(prod.id)
      if (productStock !== false) {
        limits.push(Math.max(0, Math.floor(Number(productStock)) + ownQuantityInCart))
      }

      // Campaign discount unit cap (module-side; API also errors if exceeded).
      if (this.productHasDiscount(prod)) {
        const remaining = this.getDiscountUnitsRemaining(prod)
        // remaining <= 0 means display-only menu promo; allow full-price qty via stock.
        if (remaining != null && !isNaN(remaining) && remaining > 0) {
          // units_remaining from availability already accounts for other cart lines
          // (and excludes this line when editing). Cap quantity at remaining.
          limits.push(Math.max(0, remaining))
        }
      }

      // Mai multe valori de opțiune pot consuma același produs din stoc.
      // Le cumulăm înainte de a calcula câte produse pot fi comandate.
      const quantitiesByStockProduct = {}
      ;(prod.product_options || []).forEach((option) => {
        ;(option.values || []).forEach((value) => {
          const isSelected = option.type === 'radio'
            ? option.checked === value.id
            : Boolean(value.checked)
          if (!isSelected) return

          const stockProductId = this.optionValueStockProductId(value)
          if (stockProductId == null) return

          const quantity = option.type === 'checkbox' && value.company_option_value && value.company_option_value.allow_quantity
            ? Math.max(1, Number(value.quantity) || 1)
            : 1
          quantitiesByStockProduct[stockProductId] = (quantitiesByStockProduct[stockProductId] || 0) + quantity
        })
      })

      Object.keys(quantitiesByStockProduct).forEach((stockProductId) => {
        const stock = this.getOptionValueStock(stockProductId)
        if (this.optionValueHasNoStock(stockProductId)) {
          limits.push(0)
        } else if (stock !== false) {
          limits.push(Math.max(0, Math.floor(Number(stock) / quantitiesByStockProduct[stockProductId])))
        }
      })

      // Same pattern for campaign discount units on selected is_product options.
      const quantitiesByDiscountProduct = {}
      ;(prod.product_options || []).forEach((option) => {
        ;(option.values || []).forEach((value) => {
          const isSelected = option.type === 'radio'
            ? option.checked === value.id
            : Boolean(value.checked)
          if (!isSelected) return
          if (!this.optionHasDiscount || !this.optionHasDiscount(value)) return

          const discountProductId = this.optionValueStockProductId(value)
            || (value && value.product_id)
            || (value && value.company_option_value && value.company_option_value.product_id)
          if (discountProductId == null) return

          const quantity = option.type === 'checkbox' && value.company_option_value && value.company_option_value.allow_quantity
            ? Math.max(1, Number(value.quantity) || 1)
            : 1
          quantitiesByDiscountProduct[discountProductId] = (quantitiesByDiscountProduct[discountProductId] || 0) + quantity
        })
      })

      Object.keys(quantitiesByDiscountProduct).forEach((discountProductId) => {
        const remaining = this.getDiscountUnitsRemaining({
          id: discountProductId,
          discount: null
        })
        // Prefer live availability; fall back to value.discount.units_remaining via map lookup only.
        // remaining <= 0: display-only promo; do not hard-cap parent qty (full-price add).
        if (remaining == null || isNaN(remaining) || remaining <= 0) return
        const perParent = quantitiesByDiscountProduct[discountProductId]
        limits.push(Math.max(0, Math.floor(Number(remaining) / perParent)))
      })

      return limits.length ? Math.min(...limits) : false
    },
    canIncreaseProductQuantity (prod = this.currentProductInPopup) {
      const limit = this.getProductQuantityLimit(prod)
      return limit === false || prod.quantity < limit
    },
    verifyProductStockInCart (prod) {
      if (prod.out_of_stock || this.cartLineIsUnorderable(prod)) {
        return true
      }
      // Discounted lines: availability remaining excludes cart qty, so increase only if remaining > 0.
      if (this.cartLineHasDiscount(prod)) {
        const remaining = this.getDiscountUnitsRemaining({ id: prod.id, discount: prod.discount })
        if (remaining != null && !isNaN(remaining) && remaining <= 0) {
          return true
        }
      }
      // Discounted is_product options on the cart line: one more parent unit needs
      // at least option.qty remaining for each discounted option product.
      const cartOptions = prod.options || prod.prod_options || []
      if (Array.isArray(cartOptions)) {
        for (let i = 0; i < cartOptions.length; i++) {
          const opt = cartOptions[i]
          if (!opt || !this.cartLineHasDiscount(opt)) continue
          const optPid = opt.product_id
            || (opt.company_option_value && opt.company_option_value.product_id)
          if (!optPid) continue
          const remaining = this.getDiscountUnitsRemaining({ id: optPid, discount: opt.discount })
          const optQty = Math.max(1, parseInt(opt.quantity, 10) || 1)
          if (remaining != null && !isNaN(remaining) && remaining < optQty) {
            return true
          }
        }
      }
      if (prod.option_stock_limit !== null && prod.option_stock_limit !== undefined && prod.quantity >= prod.option_stock_limit) {
        return true
      }
      if (prod.allow_negative_stock) {
        return false
      }
      // stock null/undefined = produsul nu are stoc gestionat, deci e nelimitat.
      // Fara verificarea asta, `quantity >= null` e true (null devine 0 in comparatie)
      // si produsele fara control de stoc ar aparea ca epuizate.
      if (prod.stock === null || prod.stock === undefined) {
        return false
      }
      if (prod.quantity >= prod.stock) {
        return true
      }
      return false
    },
    optionValueStockProductId (val) {
      // Rezolvă product_id-ul de stoc pentru o valoare de opțiune.
      // Format nou: join pe company_option_value_id via productOptionsCovStockMap.
      // Fallback (format vechi): product_id-ul din company_option_value.
      if (!val) return null
      if (val.company_option_value_id != null && this.productOptionsCovStockMap[val.company_option_value_id] != null) {
        return this.productOptionsCovStockMap[val.company_option_value_id]
      }
      if (val.company_option_value && val.company_option_value.product_id != null) {
        return val.company_option_value.product_id
      }
      return null
    },
    optionValueHasNoStock (valId) {
      if (this.stocksForProductOptions[valId] && this.stocksForProductOptions[valId].in_stock === false) {
        return true;
      }
      return false;
    },
    getOptionValueStock (valId) {
      let returnedStock = false
      if (this.stocksForProductOptions[valId] && this.stocksForProductOptions[valId].stock && this.stocksForProductOptions[valId].stock.id && this.stocksForProductOptions[valId].in_stock !== false) {
        returnedStock = this.stocksForProductOptions[valId].stock.stock
      }
      return returnedStock
    },
    openProduct (prod, edit = null, noModal = null, callback = null, forCacheOnly = null, fromSoldWithMenuSuggestion = null) { // noModal infinite loop if true
      const orderMethodRequestId = this.orderMethodRequestId
      let timeoutLoading = null;
      // Ignore extra taps while an interactive open is in progress (no list loader).
      if (!forCacheOnly && !noModal) {
        if (this.openingProduct) {
          return 0
        }
        this.openingProduct = true
      }

      if (fromSoldWithMenuSuggestion) {
        this.showSoldWithMenuSuggestionModal = false
      }
      this.currentProductInInfoPopup = null
      this.showInfoProdModal = false
      // if (this.json.company_id == 39 && !prod.product_options.length && !noModal) { // noModal for not infinite loop
      //   this.addProductDirectlyToCart(prod)
      //   return 0;
      // }
      if (!forCacheOnly && !edit) {
        if (this.productHasNoStock(prod.id)) {
          console.log('productHasNoStock', prod.id);
          this.openingProduct = false
          return 0;
        }
        if (this.productIsIndisponible(prod.id)) {
          console.log('productIsIndisponible', prod.id);
          this.openingProduct = false
          return 0;
        }
      }
      this.clearKeyBoard()
      this.searchText = ''
      var i = 0
      var data2 = this.appendPricingContext({
        company_id: this.json.company_id
        // with_stock: true
      })
      // let domProdElement = this.$refs['product' + prod.id]
      // if (domProdElement && domProdElement.length) {
      //   domProdElement = domProdElement[0]
      //   domProdElement.classList.add("pressed");
      //   setTimeout(() => {
      //     domProdElement.classList.remove("pressed");
      //   }, 1000) // 2 sec
      // }
      if (edit) {
        data2.add_order = true
        data2.index = prod.index
        data2.shopping_cart_id = this.cart.shopping_cart_id
      } else {
        data2.not_customer = true
        data2.with_cache = true
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      this.optionsInSteps = false

      const finishOpeningProduct = () => {
        this.openingProduct = false
      }

      this.apiRequest('product/' + prod.id, 'GET', data2, (resp) => {
        if (orderMethodRequestId !== this.orderMethodRequestId || data2.delivery_method !== this.getPricingDeliveryMethod()) {
          clearTimeout(timeoutLoading)
          return
        }
        if (!forCacheOnly) {
          this.addToCartDisabled = false

          if (!resp || !resp.data || !resp.data.status) {
            console.log('ERROR getting product')
            // Anuntam clientul ce a picat + de la ce apel vine eroarea.
            this.generalErrorSwal('product/' + prod.id, resp, this.$t('general.errProductLoad'))
            finishOpeningProduct()
            return 0;
          }

          this.currentProductInPopup = resp.data.data[0]

          // Preserve lowest price / campaign discount from menu list if single-product payload omitted them.
          const listProd = (this.products || []).find(p => p && p.id == prod.id)
          if (
            listProd &&
            listProd.lowest_price_last_30_days != null &&
            (this.currentProductInPopup.lowest_price_last_30_days == null ||
              this.currentProductInPopup.lowest_price_last_30_days === undefined)
          ) {
            this.currentProductInPopup.lowest_price_last_30_days = listProd.lowest_price_last_30_days
          }
          if (listProd && this.productHasDiscount(listProd) && !this.productHasDiscount(this.currentProductInPopup)) {
            this.currentProductInPopup.discount = listProd.discount
            if (listProd.campaign_discount) {
              this.currentProductInPopup.campaign_discount = listProd.campaign_discount
            }
          }
          
          if (this.currentProductInPopup.product_options_completed) {
            this.currentProductInPopup.product_options = this.currentProductInPopup.product_options_completed
          }
          if (edit) {
            this.currentProductInPopup.index = prod.index
            this.currentProductInPopup.product_options = this.currentProductInPopup.categories
            this.currentProductInPopup.in_edit = true
            this.currentProductInPopup.image_url = []
            this.currentProductInPopup.image_url[0] = {'url': this.currentProductInPopup.image}

            if (this.currentProductInPopup.product_options.length) {
                for (let i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
                  this.currentProductInPopup.product_options[i].values = this.currentProductInPopup.product_options[i].options
                  this.currentProductInPopup.product_options[i].name = this.currentProductInPopup.product_options[i].title
                  this.currentProductInPopup.product_options[i].min_no = this.currentProductInPopup.product_options[i].min
                  this.currentProductInPopup.product_options[i].max_no = this.currentProductInPopup.product_options[i].max

                  // === CAUTĂ optionsSelected2 pentru această categorie ===
                  const optionsSelected2 = this.currentProductInPopup.product_options[i].optionsSelected2 || []
                  const selected2Map = {}
                  optionsSelected2.forEach(sel => {
                      selected2Map[sel.id] = sel
                  })

                  if (this.currentProductInPopup.product_options[i].values.length) {
                    for (let j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                      const valoare = this.currentProductInPopup.product_options[i].values[j]
                      
                      this.currentProductInPopup.product_options[i].values[j].name = valoare.name

                      // === ADAUGĂ AICI: quantity din optionsSelected2 sau default 1 ===
                      const selected2Item = selected2Map[valoare.id]
                      if (selected2Item && selected2Item.quantity) {
                          valoare.quantity = selected2Item.quantity
                      } else {
                          valoare.quantity = 1
                      }

                      // === ADAUGĂ AICI: company_option_value cu prioritate optionsSelected2 ===
                      if (selected2Item) {
                          // Dacă există în optionsSelected2, folosește valorile de acolo
                          valoare.company_option_value = {
                              max_quantity: selected2Item.max_quantity !== undefined ? selected2Item.max_quantity : valoare.max_quantity,
                              min_quantity: selected2Item.min_quantity !== undefined ? selected2Item.min_quantity : valoare.min_quantity,
                              allow_quantity: selected2Item.allow_quantity !== undefined ? selected2Item.allow_quantity : valoare.allow_quantity
                          }
                      } else {
                          // Dacă NU există în optionsSelected2, folosește valorile default ale opțiunii
                          valoare.company_option_value = {
                              max_quantity: valoare.max_quantity,
                              min_quantity: valoare.min_quantity,
                              allow_quantity: valoare.allow_quantity
                          }
                      }

                      if (this.currentProductInPopup.product_options[i].type === 'radio') {
                          if (valoare.checked) {
                              this.currentProductInPopup.product_options[i].checked = valoare.id
                          }
                      }
                    }
                  }
                }
            }
          }
          if (this.currentProductInPopup.product_options && this.currentProductInPopup.product_options.length) {
            for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {

              // add image and show_type_kiosk from company_option
              if (!this.currentProductInPopup.product_options[i].show_type_kiosk && this.currentProductInPopup.product_options[i].company_option) {
                this.currentProductInPopup.product_options[i].show_type_kiosk = this.currentProductInPopup.product_options[i].company_option.show_type_kiosk
                this.currentProductInPopup.product_options[i].image = this.currentProductInPopup.product_options[i].company_option.image
                if (this.currentProductInPopup.product_options[i].show_type_kiosk === 'steps') {
                  this.optionsInSteps = true

                  // fetchAndSetImage
                  if (
                      this.currentProductInPopup.product_options[i].image && 
                      this.currentProductInPopup.product_options[i].image != '' &&
                      this.currentProductInPopup.product_options[i].image.indexOf('placeholder') <= -1
                      ) {
                    this.fetchAndSetImage(this.currentProductInPopup.product_options[i].image)
                  }
                  for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                    if (
                        this.currentProductInPopup.product_options[i].values[j].image && 
                        this.currentProductInPopup.product_options[i].values[j].image != '' &&
                        this.currentProductInPopup.product_options[i].values[j].image.indexOf('placeholder') <= -1
                        ) {
                      this.fetchAndSetImage(this.currentProductInPopup.product_options[i].values[j].image)
                    }
                  }
                  // end fetchAndSetImage
                }
              }

              if (this.currentProductInPopup.product_options[i].required) {
                this.addToCartDisabled = true
              }
              
              if (this.currentProductInPopup.product_options[i].has_default_value && !edit) {
                if (this.currentProductInPopup.product_options[i].type == 'radio') {
                  this.currentProductInPopup.product_options[i].checked = this.currentProductInPopup.product_options[i].values[0].id
                } else if (this.currentProductInPopup.product_options[i].type == 'checkbox' && !edit) {
                  if (this.currentProductInPopup.product_options[i].min_no && this.currentProductInPopup.product_options[i].min_no > 1) {
                    for (let j = 0; j < Math.min(this.currentProductInPopup.product_options[i].min_no, this.currentProductInPopup.product_options[i].values.length); j++) {
                      this.currentProductInPopup.product_options[i].values[j].checked = this.currentProductInPopup.product_options[i].values[j].id
                    }
                  } else {
                    this.currentProductInPopup.product_options[i].values[0].checked = this.currentProductInPopup.product_options[i].values[0].id
                  }
                }
                // this.updateCategories();
              }

              if (this.currentProductInPopup.product_options[i].values.length) {
                if (!edit && this.currentProductInPopup.product_options[i].values.length == 1 && this.currentProductInPopup.product_options[i].required) {
                  if (this.currentProductInPopup.product_options[i].type == 'radio') {
                    this.currentProductInPopup.product_options[i].checked = this.currentProductInPopup.product_options[i].values[0].id
                  } else if (this.currentProductInPopup.product_options[i].type == 'checkbox') {
                    this.currentProductInPopup.product_options[i].values[0].checked = this.currentProductInPopup.product_options[i].values[0].id
                  }
                  // this.updateCategories();
                }
              }
            }
            if (edit) {
              this.setProductOptionStocksFromResponse()
              this.updateCategories()
            } else {
              this.getStocksForProductOptions(() => {
                this.updateCategories();
              })
            }
          }
          // this.updateCategories()
          // this.$modal.show('productModal')
          const openAfterDiscountRefresh = () => {
            if (!noModal) {
              if (!edit) this.prepareDiscountPricesForOpening(this.currentProductInPopup)
              if (
                  this.json.type == 'Kiosk' &&
                  this.currentProductInPopup.sold_with_menu_suggestion &&
                  !fromSoldWithMenuSuggestion
                )
              {
                  this.soldWithCategory = null
                  this.soldWith(this.currentProductInPopup.id, () => {
                    if (this.soldWithCategory && this.soldWithCategory.length) {
                      this.showSoldWithMenuSuggestionModal = true
                    } else {
                      this.showProductModal = true
                    }
                    finishOpeningProduct()
                  }, false)
              } else {
                // Wait for sold-with prefetch before opening the product modal.
                // Otherwise addToCart can run while soldWithCategory is still null
                // (first open = network; second open often hits sync cache and "works").
                this.soldWithCategory = null
                this.soldWith(this.currentProductInPopup.id, () => {
                  this.showProductModal = true
                  finishOpeningProduct()
                })
              }
            } else {
              finishOpeningProduct()
            }
          }

          // Re-check units remaining against cart (unit-limit campaigns keep menu discount for display).
          // When editing a cart line, exclude that line so its claimed discount stays available.
          this.getDiscountsForProducts(() => {
            openAfterDiscountRefresh()
          }, [this.currentProductInPopup.id], edit ? prod.index : null)
        }
        if (callback) {callback()}
      })
    },
    closeShowSoldWithMenuSuggestionModal () {
      this.showSoldWithMenuSuggestionModal = false
      this.showProductModal = true
    },
    closeClientModal (key = true) {
      this.showClientModal = false
      window.removeEventListener('keyup', this.handleKeyUpClientModal)
      if (key) {
        this.definKeyboard()
      }
    },
    handleOrderClick(fingerprint) {
      if (this.selectedFingerprint === 'all') {
        if (parseFloat(this.selectedTotalPrice) === 0) {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.err1'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          return 0;
        }
      }

      if (fingerprint != 'all') {
        this.selectedPeopleAndProducts = {};
        this.selectedPeopleAndProducts[fingerprint] = {selected: true};
      }
      
      this.payNew();
    },
    payNew () {
      if (this.json.type == 'Kiosk' && (this.use_smso || this.loyalty_in_use) ) {
        // this.activeKeyboard = true
        this.showClientModal = true
        window.addEventListener('keyup', this.handleKeyUpClientModal)
        // this.definKeyboard()

        this.activeKeyboardClient = true
        this.definKeyboardClient()

      } else {
        this.payNew2()
      }
    },
    validateAndContinueToPay () {
      if (!this.new_client && !this.client && this.phone_to_send != '') {
        this.searchForClient()
      } else {
        this.payNew2()
      }
    },
    payNew2 () {
      if (this.json.type == 'Kiosk') {
        this.activeKeyboard = false
        this.closeClientModal()

        setTimeout(() => { // for animation
          this.showPaymentModal = true
        }, 100)
        this.showCartModal = false
      } else {
        this.showPaymentModal = true
      }

      this.getPaymentProfile()
      this.onePaymentAllreadyPicked = false
      
      this.qr_code = null

      if (this.use_pager && this.pager == '') {
        this.disablePaymentClass = 'disabled';
        this.openPagerModal()
      }
    },
    openOrder () {
      var dataToBeSent = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'place_order',
        products_need_deleted: true,
        add_order: true,
        comments: this.orderComments,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.json.type != 'Kiosk') {
        dataToBeSent.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', dataToBeSent, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.waitingOpenOrder'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
        }
        if (response && response.data.errors && response.data.errors.close) {
          this.restart()
          console.log('restart')
        }
      })
    },
    verifyOrUpdateCart () { // for multiple users
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'product_validation',
        order_source_id: this.json.type == 'Kiosk' ? 1 : 2,
        products_need_deleted: true,
        add_order: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (this.handleUnavailableCartValidation(response, { showCart: true, closePayment: false })) {
          return
        }
        if (response && response.status === 200 && this.cartValidationErrorsAreClear(response.data && response.data.errors)) {
          this.cart = response.data.data
          this.modificationsInCart()
          this.markUnorderableCartLinesFromResponse(response.data)
        } else if (response && response.data.errors && response.data.errors.close) {
          this.restart()
          console.log('restart')
        } else if (response && response.data.errors.hasOwnProperty('shopping_cart_id')) {
          // Popup + log intai; restart-ul se face dupa OK, din showCartLostPopup().
          this.showCartLostPopup(response)
        }
      })
    },
    unfreezeOrder () {
      if (this.onePaymentAllreadyPicked) return 0;
      this.onePaymentAllreadyPicked = true
      setTimeout(() => {
        this.onePaymentAllreadyPicked = false
      }, 500)
      if (this.json.type != 'Kiosk') {
        // this.freezeOrder (false, ()=>{
          this.showPaymentModal = false
        // });
      } else {
        this.showPaymentModal = false
      }
    },
    freezeOrder (freezStatus=true, callback) { // IS NOT IN USE
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'freeze_order',
        freeze_order: freezStatus,
        products_need_deleted: true,
        add_order: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.json.type != 'Kiosk') {
        data.qr_version = this.qr_version
      }
      this.apiRequest('/update-cart', 'PUT', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
          if (callback) {callback()}
        }
      })
    },
    completeOrderQrVivaWallet (resp) {
      // {
      //     "aid": "A0000000031010",
      //     "status": "success",
      //     "message": "Transaction successful",
      //     "action": "sale",
      //     "clientTransactionId": "tapTable_306_954771776798637453",
      //     "amount": "10",
      //     "rrn": "611119904127",
      //     "verificationMethod": "CONTACTLESS - NO CVM",
      //     "cardType": "Visa Debit",
      //     "accountNumber": "433330******8564",
      //     "referenceNumber": "904127",
      //     "authorisationCode": "510055",
      //     "tid": "16509865",
      //     "orderCode": "6111228678509865",
      //     "transactionDate": "2026-04-21T22:10:54.1745 03:00",
      //     "transactionId": "d3df6bc9-e017-481b-b62b-237734ddae05",
      //     "paymentMethod": "CARD_PRESENT",
      //     "shortOrderCode": "6111228678"
      // }
      if (resp.amount != this.dataToSendToVivaWallet.amount) {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        Swal.fire({
          title: 'Tranzactia nu a putut fi identificata, cereti ajutor chelnerului!',
          target: document.getElementById('swal-template'),
          customClass: {
            container: className,
          }
        });
      }
      this.loader = true
      var dataToSent = {
        token: this.token,
        company_id: this.json.company_id,
        transaction_response: resp,
        table_id: this.dataToSendToVivaWallet.table_id,
        amount: this.dataToSendToVivaWallet.amount,
        order_id: this.dataToSendToVivaWallet.order_id
      }
      this.apiRequest('/viva-wallet-complete-order-qr', 'POST', dataToSent, (response) => {
        if (response && response.data.status) {
          // Succes => deblocam butoanele (flow-ul s-a incheiat).
          this.resetPaymentLock()
          this.showPaymentModal = false
          this.showCart(()=>{
            // this.modificationsInCart()
            this.loader = false
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.vivaPaySuccess'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          })
        } else {
          // Finalizarea comenzii Viva Wallet a esuat: logam in kiosk_logs (DOAR pe eroare).
          this.kioskLog({
            order_id: (this.dataToSendToVivaWallet && this.dataToSendToVivaWallet.order_id) ? this.dataToSendToVivaWallet.order_id : null,
            stage: 'viva_complete_order',
            event: (!response) ? 'null_response'
                 : (response.status && response.status !== 200) ? ('http_' + response.status)
                 : 'errors',
            http_status: (response && response.status) ? response.status : null,
            data_to: resp,
            data_from: response ? (response.data || response) : null
          })
          // Eroare la finalizare => oprim loader-ul si deblocam butoanele
          // (altfel ramaneau blocate + loader pornit "in aer").
          this.loader = false
          this.resetPaymentLock()
        }
      })
    },
    // Deblocheaza butoanele de plata (in TOATE cazurile: succes, eroare, timeout)
    // si opreste timeout-ul de siguranta daca era pornit.
    resetPaymentLock () {
      this.onePaymentAllreadyPicked = false
      this.disablePaymentClass = ''
      this.vivaInProgress = false
      // Curatam si metoda selectata, altfel butoanele card/cash/pos/free raman
      // "disabled" (conditia lor: selectedPaymentMethod !== 'x' && !== '') si s-ar
      // reactiva doar butonul de viva.
      this.selectedPaymentMethod = ''
      if (this.vivaLockTimeout) {
        clearTimeout(this.vivaLockTimeout)
        this.vivaLockTimeout = null
      }
      // Ascundem overlay-ul de asteptare Viva si oprim timer-ul butonului "Reincearca".
      this.showVivaRetry = false
      if (this.vivaRetryTimeout) {
        clearTimeout(this.vivaRetryTimeout)
        this.vivaRetryTimeout = null
      }
    },
    // Porneste timeout-ul de siguranta: daca Viva Wallet nu raspunde in 5 min,
    // deblocam butoanele ca sa nu ramana blocate la infinit.
    armVivaSafetyTimeout () {
      if (this.vivaLockTimeout) {
        clearTimeout(this.vivaLockTimeout)
      }
      this.vivaLockTimeout = setTimeout(() => {
        this.vivaLockTimeout = null
        this.resetPaymentLock()
        this.kioskLog({
          order_id: (this.dataToSendToVivaWallet && this.dataToSendToVivaWallet.order_id) ? this.dataToSendToVivaWallet.order_id : null,
          stage: 'viva_intent',
          event: 'lock_timeout',
          message: 'auto-deblocare butoane dupa 1 min fara raspuns de la Viva Wallet'
        })
      }, 60000 * 1) // 1 min
    },
    // Porneste (sau reporneste) timer-ul de 10s dupa care apare butonul
    // "Reincearca" pe overlay-ul de asteptare Viva. Butonul apare doar daca
    // inca asteptam raspuns (vivaInProgress).
    armVivaRetryButton () {
      this.showVivaRetry = false
      if (this.vivaRetryTimeout) {
        clearTimeout(this.vivaRetryTimeout)
      }
      this.vivaRetryTimeout = setTimeout(() => {
        this.vivaRetryTimeout = null
        if (this.vivaInProgress) {
          this.showVivaRetry = true
        }
      }, 10000) // 10s
    },
    // Reincearca DOAR intentul catre Viva (postMessage catre parinte), FARA a
    // reface split-order / update-cart sau alte requesturi. Refolosim exact
    // acelasi payload deja trimis (dataToSendToVivaWallet).
    retryVivaIntent () {
      if (!this.vivaInProgress || !this.dataToSendToVivaWallet) {
        return
      }
      this.kioskLog({
        order_id: this.dataToSendToVivaWallet.order_id || null,
        stage: 'viva_intent',
        event: 'retry',
        message: 'reincercare manuala intent Viva de pe overlay-ul de asteptare',
        data_to: this.dataToSendToVivaWallet
      })
      // Re-armam timeout-ul de siguranta (inca 1 min) si ascundem butonul 10s.
      this.armVivaSafetyTimeout()
      this.armVivaRetryButton()
      // IMPORTANT: nu se poate trimite in postMessage obiectul reactiv din Vue
      // (Proxy) => DataCloneError. Trimitem o copie simpla (plain object).
      var payload = JSON.parse(JSON.stringify(this.dataToSendToVivaWallet))
      window.parent.postMessage(payload, '*')
    },
    // Anulare de pe overlay-ul de asteptare: cere backendului sa curete comanda
    // ramasa in DRAFT_AWAITING_PAYMENT (in caz de split, sterge comanda-copil
    // creata de /viva-wallet-split-order-qr; altfel revine comanda-mama in
    // OPEN_DRAFT) si deblocheaza butoanele / inchide overlay-ul.
    cancelVivaFromOverlay () {
      this.kioskLog({
        order_id: (this.dataToSendToVivaWallet && this.dataToSendToVivaWallet.order_id) ? this.dataToSendToVivaWallet.order_id : null,
        stage: 'viva_intent',
        event: 'user_cancel_overlay',
        message: 'anulare manuala de pe overlay-ul de asteptare Viva',
        data_to: this.dataToSendToVivaWallet || null
      })
      this.cancelVivaOrder()
      this.resetPaymentLock()
    },
    // La fail / USER_CANCEL de la Viva: cerem backendului sa curete comanda ramasa
    // in DRAFT_AWAITING_PAYMENT (sterge comanda-copil de split sau revine comanda-mama
    // in OPEN_DRAFT), ca sa nu stea agatata aiurea. Fire-and-forget.
    cancelVivaOrder () {
      var oid = (this.dataToSendToVivaWallet && this.dataToSendToVivaWallet.order_id) ? this.dataToSendToVivaWallet.order_id : null
      if (!oid) {
        return
      }
      try {
        this.apiRequest('/viva-wallet-cancel-order-qr', 'POST', {
          token: this.token,
          company_id: this.json.company_id,
          order_id: oid
        }, function () {
          // fire-and-forget
        })
      } catch (e) {
        // nu blocam fluxul daca esueaza curatarea
      }
    },
    payWithVivaWallet () {
      // Anti-spam: daca exista deja un intent Viva in desfasurare, iesim.
      // Asta impiedica crearea de DRAFT_AWAITING_PAYMENT multiple la apasari
      // repetate pe "cu cardul pe dispozitiv".
      if (this.vivaInProgress) {
        return
      }
      this.vivaInProgress = true
      // Disable vizual pe TOATE butoanele de plata prin mecanismul care chiar
      // functioneaza (clasa din disablePaymentClass => .disabled cu pointer-events:none).
      // Se reseteaza in resetPaymentLock (succes / eroare / timeout).
      this.disablePaymentClass = 'disabled'
      // Pornim timeout-ul de siguranta din start: daca nimic nu se intampla in
      // 5 min (nici succes, nici eroare), deblocam butoanele automat.
      this.armVivaSafetyTimeout()
      // NU mai deblocam dupa 100ms: butoanele raman blocate pana vine raspunsul
      // real de la Viva Wallet (sau pana expira timeout-ul de siguranta de 5 min).
      if (
          this.json.type !== 'Kiosk' 
          && Object.keys(this.selectedPeopleAndProducts).length 
        ) {
        
          var dataToSent = {
            token: this.token,
            company_id: this.json.company_id,
            order_id: this.cart.order_id,
            tip_value: Number(this.tipValue),
            shopping_cart_id: this.cart.shopping_cart_id,
            selected_people_and_products: this.selectedPeopleAndProducts
          }
          this.apiRequest('/viva-wallet-split-order-qr', 'POST', dataToSent, (response) => {
            if (response && response.data.status) {
              let data = {
                // Viva Wallet accepta DOAR un intreg de bani (centi). Inmultirea cu 100
                // in JS produce erori de virgula mobila (ex: 52.99 * 100 => 5299.999...),
                // pe care terminalul le respinge => rotunjim la cel mai apropiat intreg.
                amount: Math.round((response.data.data.order.totals_grandtotal - (response.data.data.order.total_pay_from_wallet || 0)) * 100),
                order_id: response.data.data.order.id,
                table_id: this.json.id
              }
              this.dataToSendToVivaWallet = data
              // Logam MEREU intentul trimis catre Viva Wallet (postMessage catre parinte).
              this.kioskLog({
                order_id: data.order_id,
                stage: 'viva_intent',
                event: 'sent',
                data_to: data
              })
              // Guard: daca amount iese <= 0 desi comanda are produse, logam un
              // snapshot al totalurilor ca sa vedem de ce (ex: parti GROUP ne-Completed
              // => updateTotals nu le insumeaza => grandtotal 0 => "comanda gratis").
              if (!(data.amount > 0)) {
                var _o = (response.data && response.data.data) ? response.data.data.order : null
                this.kioskLog({
                  order_id: data.order_id,
                  stage: 'viva_intent',
                  event: 'zero_amount',
                  message: 'split: amount <= 0 desi comanda are produse',
                  data_to: data,
                  data_from: _o ? {
                    status: _o.status,
                    order_type: _o.order_type,
                    is_split_pay: _o.is_split_pay,
                    totals_subtotals: _o.totals_subtotals,
                    totals_grandtotal: _o.totals_grandtotal,
                    total_pay_from_wallet: _o.total_pay_from_wallet,
                    parts_status: (_o.parts && _o.parts.map) ? _o.parts.map(function (p) { return p.status }) : null
                  } : null
                })
              }
              // Am invocat terminalul: pornim timeout-ul de siguranta (5 min).
              this.armVivaSafetyTimeout()
              // Butonul "Reincearca" din overlay apare dupa 10s.
              this.armVivaRetryButton()
              // nu se poate trimite in postMessage obj din vue
              window.parent.postMessage(data, '*');
            } else {
              // Apelul de split viva-wallet a esuat: logam in kiosk_logs (doar pe esec).
              this.kioskLog({
                order_id: this.cart ? this.cart.order_id : null,
                stage: 'viva_split_order',
                event: (!response) ? 'null_response'
                     : (response.status && response.status !== 200) ? ('http_' + response.status)
                     : 'errors',
                http_status: (response && response.status) ? response.status : null,
                data_from: response ? (response.data || response) : null
              })
              // Flow-ul s-a oprit inainte de terminal => deblocam butoanele.
              this.resetPaymentLock()
            }
          })
      } else {
        let data = {
          // Viva Wallet accepta DOAR un intreg de bani (centi). Inmultirea cu 100
          // in JS produce erori de virgula mobila (ex: 52.99 * 100 => 5299.999...),
          // pe care terminalul le respinge => rotunjim la cel mai apropiat intreg.
          amount: Math.round((this.cart.myCart.total_cart_price - (this.cart.myCart.total_pay_from_wallet || 0)) * 100),
          order_id: this.cart.order_id,
          table_id: this.json.id
        }
        this.dataToSendToVivaWallet = data
        // Logam MEREU intentul trimis catre Viva Wallet (postMessage catre parinte).
        this.kioskLog({
          order_id: data.order_id,
          stage: 'viva_intent',
          event: 'sent',
          data_to: data
        })
        // Guard: amount <= 0 pe comanda intreaga (fara split) => logam snapshotul cosului.
        if (!(data.amount > 0)) {
          var _c = (this.cart && this.cart.myCart) ? this.cart.myCart : null
          this.kioskLog({
            order_id: data.order_id,
            stage: 'viva_intent',
            event: 'zero_amount',
            message: 'whole cart: amount <= 0 desi comanda are produse',
            data_to: data,
            data_from: _c ? {
              total_cart_price: _c.total_cart_price,
              total_pay_from_wallet: _c.total_pay_from_wallet
            } : null
          })
        }
        // Am invocat terminalul: pornim timeout-ul de siguranta (5 min).
        this.armVivaSafetyTimeout()
        // Butonul "Reincearca" din overlay apare dupa 10s.
        this.armVivaRetryButton()
        window.parent.postMessage(data, '*');
      }
    },
    orderNow (method) {
      let order_email = null
      let cls = null
      let $btnElement = null

      if (this.onePaymentAllreadyPicked) return 0;

      const cartProducts = (this.cart && this.cart.myCart && this.cart.myCart.products) || []
      if (cartProducts.some((prod) => this.cartLineIsUnorderable(prod))) {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
        Swal.fire({
          title: this.$t('addOrder.productUnavailable'),
          target: document.getElementById('swal-template'),
          customClass: { container: className }
        })
        this.onePaymentAllreadyPicked = false
        this.showPaymentModal = false
        this.showCart()
        return 0
      }

      if (this.disablePaymentClass == 'disabled') {
        if (this.use_pager && this.pager == '') {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.addPager'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          }).then(() => {
            this.disablePaymentClass = 'disabled';
            this.openPagerModal();
          });
        }
        return 0;
      }

      this.selectedPaymentMethod = method;
      this.onePaymentAllreadyPicked = true

      if (this.email_to_send != '') {
        const emailInput = document.getElementById('email_to_send');
        if (emailInput.checkValidity()) {
          order_email = this.email_to_send
        } else {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.emailError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false
          return 0;
        }
      }

      if (method === 'card_pos') {
        cls = 'load_card_pos'
      }
      if (method === 'viva_walet') {
        cls = 'load_viva_walet'
      }
      if (this.json.type == 'Kiosk') {
        if (method === 'qr') {
          cls = 'load_k_qr'
        }
        if (method === 'cash') {
          cls = 'load_k_cash'
        }
        if (method === 'cashMachine') {
          cls = 'load_cashMachine'
        }
        if (method === 'pos') {
          cls = 'load_k_pos'
        }
        if (method === 'free') {
          cls = 'load_free'
        }
      } else {
        if (method === 'card') {
          cls = 'load_card'
        }
        if (method === 'cash') {
          cls = 'load_cash'
        }
        if (method === 'pos') {
          cls = 'load_pos'
        }
        if (method === 'free') {
          cls = 'load_free'
        }
      }
      $btnElement = document.querySelector('.'+cls)
      if ($btnElement) {
        $btnElement.classList.add('loading')
      }

      if (method === 'viva_walet') {
        this.payWithVivaWallet();
        return 0;
      }
      
      // this.selectedPeople = this.cart.people.map(person => person.fingerprint);
      // console.log(this.selectedPeople)

      // "Toate produsele din cos sunt bifate" => e comanda INTREAGA, nu un split partial,
      // deci NU trebuie sa trecem prin copyToNewOrder. Verificam pe baza cosului real
      // (this.cart.people), nu pe intrarile din selectedPeopleAndProducts: map-ul acumuleaza
      // intrari reziduale/goale (create la render de getOrCreateSelectedPerson sau ramase de la
      // reincarcari de cos), iar o singura intrare selected:false facea sa se intre gresit pe copy.
      const allCartProductsSelected =
        this.cart && Array.isArray(this.cart.people) && this.cart.people.length > 0 &&
        this.cart.people.every(person => {
          const pd = this.selectedPeopleAndProducts[person.fingerprint]
          return pd && pd.selected === true
        })

      if (
          this.json.type !== 'Kiosk'
          && method !== 'card'
          && Object.keys(this.selectedPeopleAndProducts).length
          && !allCartProductsSelected
        ) {
        this.copyToNewOrder(method)
        return 0;
      }

      let errors = 0
      if (!errors) {
        let orderForm = this.json.type + ' ' + this.json.zone + ' ' + this.json.number;
        if (this.packingMethod) {
          orderForm = orderForm + ' (' + this.$t('addOrder.' + this.packingMethod) + ')';
        }
        var data2 = {
          token: this.token,
          company_id: this.json.company_id,
          table: {
            ...this.json,
            fiscal_device_id: this.fiscalDeviceId 
          },
          action: 'product_validation',
          products_need_deleted: true,
          add_order: true,
          order_from: orderForm,
          order_source_id: this.json.type == 'Kiosk' ? 1 : 2,
          shopping_cart_id: this.cart.shopping_cart_id
        }
        if (this.json.type != 'Kiosk') {
          data2.qr_version = this.qr_version
        }
        if (order_email) {
          data2['order_email'] = order_email;
        }
        if (this.order_phone) {
          data2['order_phone'] = this.order_phone;
          data2['order_phone_country_code'] = this.order_phone_country_code;
        }
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          setTimeout(() => {
            $btnElement.classList.remove('loading')
          }, 2000) // 2 sec

          // Review corrected prices and unavailable claims before continuing payment.
          if (this.handleUnavailableCartValidation(response, { showCart: true, closePayment: true })) {
            return 0
          }

          if (response && response.status === 200 && this.cartValidationErrorsAreClear(response.data && response.data.errors)) {
            if (response.data && response.data.data && response.data.data.no_availability) {
              this.selectedPaymentMethod = ''
              this.onePaymentAllreadyPicked = false
              this.showPaymentModal = false
              this.showCart()
              this.setIndisponibleFromNoAvailability(response.data.data.no_availability)
              this.checkProductIndisponibility(null, true)
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.productUnavailable'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
              return 0;
            }
            if (response.data && response.data.data && response.data.data.no_stock_products) {
              this.selectedPaymentMethod = ''
              this.onePaymentAllreadyPicked = false
              this.showPaymentModal = false
              this.showCart()
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.productNoStock'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
              return 0;
            }
            if (response && response.data && (
              response.data.reason === 'units_limit_reached' ||
              response.data.reason === 'campaign_discount_unavailable' ||
              response.data.unorderable
            )) {
              this.selectedPaymentMethod = ''
              this.onePaymentAllreadyPicked = false
              this.showPaymentModal = false
              this.showCart()
              this.markUnorderableCartLinesFromResponse(response.data)
              this.getDiscountsForProducts()
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
              Swal.fire({
                title: response.data.reason === 'units_limit_reached'
                  ? (this.$t('addOrder.discountUnitsLimitReached') || this.$t('addOrder.productUnavailable'))
                  : (this.$t('addOrder.campaignDiscountUnavailable') || this.$t('addOrder.productUnavailable')),
                target: document.getElementById('swal-template'),
                customClass: { container: className }
              })
              return 0
            }
            this.cart = response.data.data
            this.modificationsInCart()
            this.markUnorderableCartLinesFromResponse(response.data)
            if ((this.cart.myCart.products || []).some((prod) => this.cartLineIsUnorderable(prod))) {
              this.selectedPaymentMethod = ''
              this.onePaymentAllreadyPicked = false
              this.showPaymentModal = false
              this.showCart()
              this.getDiscountsForProducts()
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall'
              Swal.fire({
                title: this.$t('addOrder.productUnavailable'),
                target: document.getElementById('swal-template'),
                customClass: { container: className }
              })
              return 0
            }
            // if (response.data.some_products_deleted) {
            //   swal({
            //     title: '',
            //     text: this.$t('addOrder.errorProduct1'),
            //     type: 'error',
            //     showConfirmButton: true,
            //     target: document.getElementById('swal-template'),
            //     toast: true
            //   })
            // }
            // if (method == 'qr') {}
            switch (method) {
            case 'free':
                this.completeOrder('free')
                break;
              case 'cash':
                this.completeOrder('cash')
                break;
              case 'cashMachine':
                this.completeOrderWithCashMachine()
                break;
              case 'pos':
                this.completeOrder('pos')
                break;
              case 'qr':
                this.completeOrder('qr_pay')
                break;
              case 'card':
                this.completeOrderWithCard()
                break;
              case 'card_pos':
                if (this.DBfiscalNetWithPos) {
                  this.completeOrderWithFiscalNetPos()
                } else {
                  this.completeOrderWithPos()
                }
                break;
              default:
                console.log('New Method');
            }
          } else if (response && response.data.errors && response.data.errors.close) {
            this.restart()
            console.log('restart')
          } else if (response && response.data.errors.hasOwnProperty('shopping_cart_id')) {
            // Popup + log intai; restart-ul se face dupa OK, din showCartLostPopup().
            this.showCartLostPopup(response)
          }
        })
      }
      setTimeout(() => {
        this.selectedPaymentMethod = '';
      }, 20000);
    },
    completeOrderWithCashMachine () {
      this.insertedMoneyInCashMachine = 0
      this.socket.emit('start_pay', (this.cart.myCart.total_cart_price - (this.cart.myCart.total_pay_from_wallet || 0)) * 100)
      this.showCashMachineModal = true
      this.customMsgCashMachine = null
    },
    copyToNewOrder (method) {
      let orderForm = this.json.type + ' ' + this.json.zone + ' ' + this.json.number;
      if (this.packingMethod) {
        orderForm = orderForm + ' (' + this.$t('addOrder.' + this.packingMethod) + ')';
      }
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        table: this.json,
        action: 'copy_to_new_order',
        payment_type: method,
        products_need_deleted: true,
        add_order: true,
        self_ordering: true,
        order_from: orderForm,
        order_source_id: this.json.type == 'Kiosk' ? 1 : 2,
        shopping_cart_id: this.cart.shopping_cart_id,
        location_token: this.json.location_token,
        selected_people: this.selectedPeopleAndProducts,
        comments: this.orderComments,
        tip_value: Number(this.tipValue),
        cui: this.cui,
        pager: this.pager,
        packing_method: this.packingMethod,
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
      }
      if (this.email_to_send && this.email_to_send != '') {
        data2['order_email'] = this.email_to_send;
      }
      if (this.order_phone) {
        data2['order_phone'] = this.order_phone;
        data2['order_phone_country_code'] = this.order_phone_country_code;
      }
      if (this.client && this.client.id) {
        data2.for_user = this.client.id
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (method == 'card') {
            this.pay_card_new_order(response.data.data);
          } else {
            this.finishOrder(response.data.data.number, method, response.data.data.order_id)
          }
          // setTimeout(() => {
          //   $btnElement.classList.remove('loading')
          // }, 2000) // 2 sec
          // switch (method) {
          // case 'free':
          //     this.completeOrder('free')
          //     break;
          //   case 'cash':
          //     this.completeOrder('cash')
          //     break;
          //   case 'pos':
          //     this.completeOrder('pos')
          //     break;
          //   case 'qr':
          //     this.completeOrder('qr_pay')
          //     break;
          //   case 'card':
          //     this.completeOrderWithCard()
          //     break;
          //   case 'card_pos':
          //     if (this.DBfiscalNetWithPos) {
          //       this.completeOrderWithFiscalNetPos()
          //     } else {
          //       this.completeOrderWithPos()
          //     }
          //     break;
          //   default:
          //     console.log('New Method');
          // }
        } else {
          // copy_to_new_order a esuat: logam in kiosk_logs (DOAR pe eroare).
          this.kioskLog({
            order_id: this.cart ? this.cart.order_id : null,
            stage: 'copy_to_new_order',
            event: (!response) ? 'null_response'
                 : (response.status && response.status !== 200) ? ('http_' + response.status)
                 : 'errors',
            http_status: (response && response.status) ? response.status : null,
            message: method || null,
            data_from: response ? (response.data || response) : null
          })
        }
        if (response && response.data.errors.hasOwnProperty('freeze_order')) {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.order_id_freeze'),
            customClass: {
              container: className,
            }
          });
          return 0;
        }
        if (response && response.data.errors && response.data.errors.close) {
          this.restart()
          console.log('restart')
        }
      })
    },
    pay_card_new_order (orderReq) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        without_qr: 1,
        with_expiration: 3, // number of min
        redirect_url: this.qr_link,
        fingerprints: this.selectedPeopleAndProducts,
        location_token: this.json.location_token,
        shopping_cart_id: orderReq.shopping_cart_id
      }
      if (this.email_to_send != '') {
        const emailInput = document.getElementById('email_to_send');
        if (emailInput.checkValidity()) {
            data['email'] = this.email_to_send
        } else {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.emailError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false
          return 0;
        }
      }
      this.formloadCounter = 0
      this.apiRequest('/get-qr-pay-link', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.onePaymentAllreadyPicked = false
          window.location.href = response.data.data.html
        }
      })
    },
    completeOrderWithPos () {
      this.showPosModal = true
      this.extraInfoJsonToBePrinted = {};
      let url = 'transaction?amount=' + (this.cart.myCart.total_cart_price - (this.cart.myCart.total_pay_from_wallet || 0));
      if (this.receipt_printer_transaction_data && this.receipt_printer_transaction_data.ip) {
        url = url + '&receipt_printer={"ip":"'+ this.receipt_printer_transaction_data.ip +'","port":'+ this.receipt_printer_transaction_data.port +', "receipt_printer_copies":'+ this.receipt_printer_transaction_data.receipt_printer_copies +'}';
      }
      this.localRequest(url, 'GET', {
        'pos': JSON.stringify(this.DBpos)
        }, (response) => {

        // LOG
        let statusRsp = 0;
        let respPos = response;
        if (response && response.data && response.data.status) {
          statusRsp = 1;
          respPos = response.data;
        }
        let logFiscalNetData = {
          token: this.token,
          company_id: this.json.company_id,
          status: statusRsp,
          data_to: 'url:' + url + ' pos:' + JSON.stringify(this.DBpos),
          data_from: respPos,
        }
        this.apiRequest('/noauth/print-fiscal-net-pos-answer/' + this.cart.order_id, 'POST', logFiscalNetData, (responseFiscalNetAnswerPos) => {
          //silence
        })
        // END LOG
          
        if (response && response.data && response.data.status) {
          this.extraInfoJsonToBePrinted = response.data.extraInfoJson;
          this.setOrderAwaitingPayment(() => {
            this.completeOrder('card_pos', response.data.extraInfo);
          });
        } else {
          // error
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.posGeneralError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false;
        }
        this.showPosModal = false
      })
    },
    completeOrderWithFiscalNetPos () {
      this.showPosModal = true

      let totalToSend = this.cart.myCart.total_cart_price - (this.cart.myCart.total_pay_from_wallet || 0)
      totalToSend = totalToSend.toFixed(2)
      totalToSend = totalToSend.replace(',', '')
      totalToSend = parseInt(totalToSend.replace('.', ''))

      this.localRequestFiscalNet('/api/Receipt', 'POST', '"POS^'+totalToSend+'"', (response) => {

        let statusRsp = 0;
        let respPos = response;
        if (response.data && response.data.ReceiptStatus) {
          statusRsp = 1;
          respPos = response.data;
        }

        let logFiscalNetData = {
          token: this.token,
          company_id: this.json.company_id,
          status: statusRsp,
          data_to: '"POS^'+totalToSend+'"',
          data_from: respPos,
        }
        this.apiRequest('/noauth/print-fiscal-net-pos-answer/' + this.cart.order_id, 'POST', logFiscalNetData, (responseFiscalNetAnswerPos) => {
          //silence
        })
            
        if (response.data && response.data.ReceiptStatus) {
          this.setOrderAwaitingPayment(() => {
            this.completeOrder('card_pos', response.data.ReceiptInfo);
          });
        } else {

          const errorCodes = [
            "ERR801" // = EMITENTUL REFUZA TRZ
          ];

          if (response && response.data && 
                (
                  response.data.ErrorInfo === 'PLATA NU A FOST ACCEPTATA!'
                  || (response.data.ErrorCode && errorCodes.includes(response.data.ErrorCode))
                ) 
              ) {
            // error
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.posGeneralError'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          } else {
            // stop Kiosk need Operator
            this.blockKioskFiscalError = true
            this.lastOrderNumberForFiscalError = this.cart.order_id
            this.fiscalErrorInfo = (response && response.data && response.data.ErrorInfo) ? response.data.ErrorInfo : null
            // Comanda nu a fost finalizata (a ramas DRAFT): trebuie pusa + fiscalizata.
            this.fiscalErrorCase = 'place_and_fiscal'
          }

          // if (response && response.data && response.data.ErrorCode === "INF888") {
          //   // stop Kiosk need Operator
          //   this.blockKioskFiscalError = true
          //   this.lastOrderNumberForFiscalError = this.cart.order_id
          // } else {
          //   // error
          //   let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          //   Swal.fire({
          //     title: this.$t('addOrder.posGeneralError'),
          //     target: document.getElementById('swal-template'),
          //     customClass: {
          //       container: className,
          //     }
          //   });
          // }
          this.onePaymentAllreadyPicked = false;
        }
        this.showPosModal = false
      })
      // let url = 'transaction?amount=' + this.cart.myCart.total_cart_price;
      // this.localRequest(url, 'GET', {
      //   'pos': JSON.stringify(this.DBpos)
      //   }, (response) => {
      //   if (response.data.status) {
      //     this.completeOrder('card_pos', response.data.extraInfo);
      //   } else {
      //     // error
      //     let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      //     Swal.fire({
      //       title: this.$t('addOrder.posGeneralError'),
      //       target: document.getElementById('swal-template'),
      //       customClass: {
      //         container: className,
      //       }
      //     });
      //     this.onePaymentAllreadyPicked = false;
      //   }
      //   this.showPosModal = false
      // })
    },
    printOrder (orderNr, date, printContent=null, printTotal=null) {
      if (this.DBprinter) {
        let url = 'print?id=' + orderNr;
        let data = {
          'date': date,
          'company': JSON.stringify({
            'company_id': this.json.company_id,
            'kiosk_name': this.json.type + ' ' + this.json.number
          }),
          'content': JSON.stringify(printContent),
          'totals': JSON.stringify(printTotal),
          'printer': JSON.stringify(this.DBprinter)
        };
        this.localRequest(url, 'GET', data, (response) => {
          if (response.data.status) {
            console.log('Print Done');
          } else {
            console.log('Print Error');
          }
        })
      }
    },
    completeOrderWithCard () {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        without_qr: 1,
        with_expiration: 3, // number of min
        redirect_url: this.qr_link,
        location_token: this.json.location_token,
        shopping_cart_id: this.cart.shopping_cart_id
      }

      if (
          this.json.type !== 'Kiosk' 
          && Object.keys(this.selectedPeopleAndProducts).length 
        ) {
        data.selected_people_and_products = this.selectedPeopleAndProducts;
      }

      if (this.email_to_send != '') {
        const emailInput = document.getElementById('email_to_send');
        if (emailInput.checkValidity()) {
            data['email'] = this.email_to_send
        } else {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.emailError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false
          return 0;
        }
      }
      this.formloadCounter = 0
      this.apiRequest('/get-qr-pay-link', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (1) { // somethig in the future
            this.onePaymentAllreadyPicked = false
            window.location.href = response.data.data.html
          } else {
            this.showIframeModal = true;
            this.paymentLinkForIframe = response.data.data.html;

            const paymentFrame = document.getElementById('paymentFrame');
            window.addEventListener('message', message => {
              let s1 = message.origin.replace("https://", "").replace("/", "");
              let s2 = window.API_HOST.replace("https://", "").replace("/", "");
                if (s1 == s2) {
                  if (message.data == 'ok') {
                    this.showIframeModal = false;
                    this.paymentLinkForIframe = '';
                    this.completeOrder('card')
                  } else {
                    this.showIframeModal = false;
                    let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
                    Swal.fire({
                      title: this.$t('addOrder.euPlatesc_' + message.data),
                      target: document.getElementById('swal-template'),
                      customClass: {
                        container: className,
                      }
                    });
                    this.onePaymentAllreadyPicked = false
                  }
                }
            });
          }

        }
      })
    },
    setOrderAwaitingPayment (callback) {
      // Marcheaza comanda ca DRAFT_AWAITING_PAYMENT imediat dupa ce plata pe card
      // a reusit, INAINTE de complete_order. Astfel comanda iese din DRAFT/OPEN_DRAFT
      // si nu mai poate fi stearsa de sweep-urile de curatare a cosului (login kiosk
      // / refreshCart) cat timp complete_order proceseaza. Continuam finalizarea
      // indiferent de raspuns (plata deja s-a facut); garda din backend acopera si
      // eventualul esec al acestui apel.
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'set_awaiting_payment',
        shopping_cart_id: this.cart.shopping_cart_id,
      }
      this.apiRequest('/update-cart', 'PUT', data, () => {
        callback()
      })
    },
    completeOrder (payMethod, extraInfo = null) {
      this.showCompleteWaitingModal = true;
      this.qr_code = null
      // this.loadingCompleteOrder = true
      let oldOrderId = this.cart.order_id
      let orderForm = this.json.type + ' ' + this.json.zone + ' ' + this.json.number;
      let orderComments = this.orderComments;
      if (this.packingMethod) {
        orderForm = orderForm + ' (' + this.$t('addOrder.' + this.packingMethod) + ')';
        if (this.add_packing_method_to_comment) {
          orderComments = (orderComments ? orderComments + ' ' : '') + '(' + this.$t('addOrder.' + this.packingMethod) + ')';
        }
      }
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'complete_order',
        products_need_deleted: true,
        add_order: true,
        self_ordering: true,
        order_from: orderForm,
        order_source_id: this.json.type == 'Kiosk' ? 1 : 2,
        location_token: this.json.location_token,
        // chosen_hour: this.selectedHour,
        // chosen_date: this.selectedDate,
        shopping_cart_id: this.cart.shopping_cart_id,
        tip_value: Number(this.tipValue),
        payment_type: payMethod,
        packing_method: this.packingMethod,
        transaction_response: extraInfo,
        cui: this.cui,
        pager: this.pager,
        comments: orderComments,
      }
      if (this.json.type != 'Kiosk') {
        data2.qr_version = this.qr_version
        if (this.allow_open_order) {
          if (payMethod == 'cash' || payMethod == 'pos') {
            data2.bill_requested = 1;
            data2.freeze_order = 1;
          } else {
            data2.selected_status = 'DELIVERED'
          }
        }
      }
      if (this.client && this.client.id) {
        data2.for_user = this.client.id
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        this.onePaymentAllreadyPicked = false
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data && response.data.data && response.data.data.no_availability) {
            this.showCompleteWaitingModal = false
            this.selectedPaymentMethod = ''
            this.showPaymentModal = false
            this.showCart()
            this.setIndisponibleFromNoAvailability(response.data.data.no_availability)
            this.checkProductIndisponibility(null, true)
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.productUnavailable'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
            return 0;
          }
          if (payMethod == 'qr_pay') {
            var data3 = {
              token: this.token,
              company_id: this.json.company_id,
              location_token: this.json.location_token,
              shopping_cart_id: this.cart.shopping_cart_id
            }
            this.apiRequest('/get-qr-pay-link', 'GET', data3, (response) => {
              if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
                this.qr_code = response.data.data.qr_code
                this.checkIfPaymentIsComplete()
                this.startCountdown()
              }
            })
          } else if (payMethod == 'card_pos' && this.DBfiscal && !this.DBfiscalNet) {
            this.printFiscalAndFinish(response.data.data, payMethod);
          } else if (this.DBfiscalNet) {
            this.printFiscalNetAndFinish(response.data.data, payMethod);
          } else {
            let orderNumber = response.data.data.number
            if (response.data.data.posnet_order_id) {
              orderNumber = response.data.data.posnet_order_id
            }
            this.finishOrder(orderNumber, payMethod, oldOrderId);
          }
        } else {
          // Apelul complete_order a esuat (ex: 504 timeout de la origine). Logam MEREU in kiosk_logs.
          this.kioskLog({
            order_id: oldOrderId,
            stage: 'complete_order',
            event: (!response) ? 'null_response'
                 : (response.status && response.status !== 200) ? ('http_' + response.status)
                 : 'errors',
            http_status: (response && response.status) ? response.status : null,
            data_from: response ? (response.data || response) : null
          })
          if (payMethod == 'card_pos') {
            // Plata pe POS a reusit deja: NU pierdem comanda cu restart(). Aratam ecranul
            // negru (cere operator), cu numarul comenzii, exact ca la esecul fiscal.
            this.showCompleteWaitingModal = false
            this.blockKioskFiscalError = true
            this.lastOrderNumberForFiscalError = oldOrderId
            this.fiscalErrorInfo = (response && response.status) ? ('complete_order HTTP ' + response.status) : 'complete_order failed'
            // Plata a mers, dar complete_order a esuat: comanda a ramas
            // DRAFT_AWAITING_PAYMENT -> trebuie retrimisa (pusa) + fiscalizata.
            this.fiscalErrorCase = 'place_and_fiscal'
          } else {
            this.restart()
            console.log('restart')
          }
        }
      })
    },
    printFiscalAndFinish (order, payMethod, noFinishJustReprint = false, callback = false) {
      if (
          (payMethod == 'cash' && this.kiosk_is_using_fiscal_receipt_for_cash) ||
          payMethod != 'cash'
      ) {
        var data = {
          token: this.token,
          company_id: this.json.company_id
        }
        this.apiRequest('/noauth/print-fiscal/' + order.order_id + '/' + this.json.id, 'GET', data, (response) => {
          if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.localRequest('/fiscal_print', 'GET', {
                'print': response.data.data,
                'fiscal': JSON.stringify(this.DBfiscal)
              }, (response) => {
              let orderNumber = order.number
              if (order.posnet_order_id) {
                orderNumber = order.posnet_order_id
              }
              if (!noFinishJustReprint) {
                this.finishOrder(orderNumber, payMethod, order.order_id)
              }
              if (callback) {
                callback(1)
              }
            })
          }
        })
      } else {
        if (!noFinishJustReprint) {
          this.finishOrder(order.number, payMethod, order.order_id)
        }
      }
      if (callback) {
        callback(0)
      }
    },
    printFiscalNetAndFinish (order, payMethod, noFinishJustReprint = false, callback = false) {

      if (payMethod == 'card_pos' && this.kiosk_is_using_non_fiscal_receipt_for_card && !noFinishJustReprint) {
        let nefiscalData = this.generateNonFiscalTextFiscalNet(order)
        this.localRequestFiscalNet('/api/Receipt', 'POST', nefiscalData, (responseFiscalNet) => {
          this.finishOrder(order.number, payMethod, order.order_id)
        })
      } else if (
          (payMethod == 'cash' && this.kiosk_is_using_fiscal_receipt_for_cash) ||
          payMethod != 'cash'
      ) {

        let pay_method = 1 // cash
        if (payMethod == 'card_pos') {
          pay_method = 2 // card
        }
        var data = {
          token: this.token,
          pay_method: pay_method,
          company_id: this.json.company_id
        }
        if (this.cui != '') {
          data['cui'] = this.cui
        }
        data['extra_pos_info_json'] = this.extraInfoJsonToBePrinted;
        this.apiRequest('/noauth/print-fiscal-net/' + order.order_id + '/' + this.json.id, 'GET', data, (response) => {
          if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.localRequestFiscalNet('/api/Receipt', 'POST', response.data.data, (responseFiscalNet) => {
              // console.log(response.data);
              // if (response.data && response.data.ErrorCode == '') {
              if (responseFiscalNet && responseFiscalNet.data) {
                data.receipt_number = responseFiscalNet.data
              } else {
                data.receipt_number = 'Timeout'
              }
              data.receipt = response.data.data
              let orderNumber = order.number
              if (order.posnet_order_id) {
                orderNumber = order.posnet_order_id
              }
              if (this.kiosk_is_using_fiscal_receipt_for_sections) {
                this.printFiscalNetSections(order);
              }
              this.apiRequest('/noauth/print-fiscal-net-answer/' + order.order_id, 'POST', data, (responseFiscalNetAnswer) => {
                //silence
              })
              if (!responseFiscalNet || (responseFiscalNet && responseFiscalNet.data && !responseFiscalNet.data.ReceiptStatus)) {
                this.blockKioskFiscalError = true
                this.lastOrderNumberForFiscalError = order.order_id
                this.fiscalErrorInfo = (responseFiscalNet && responseFiscalNet.data && responseFiscalNet.data.ErrorInfo) ? responseFiscalNet.data.ErrorInfo : null
                // Comanda e in cloud, doar fiscalizarea a picat -> doar refiscalizare.
                this.fiscalErrorCase = 'fiscal_only'
                // Logam esecul casei fiscale in kiosk_logs (log generic, doar pe esec).
                this.kioskLog({
                  order_id: order.order_id,
                  stage: 'fiscal_print',
                  event: !responseFiscalNet ? 'null_response' : 'no_receipt_status',
                  data_from: (responseFiscalNet && responseFiscalNet.data) ? responseFiscalNet.data : null
                })
                if (callback) {
                  callback(0)
                  return 0;
                }
              }
              if (!noFinishJustReprint) {
                this.finishOrder(orderNumber, payMethod, order.order_id)
              }
              // }
              if (callback) {
                callback(1)
              }
            })
          } else {
            // Apelul API de generare bon fiscal a esuat (500 / errors / null raspuns).
            // Nu lasam comanda nefiscalizata in tacere: aratam ecranul negru cu eroare
            // (cere operator) exact ca la esecul casei fiscale de mai sus.
            this.blockKioskFiscalError = true
            this.lastOrderNumberForFiscalError = order.order_id
            this.fiscalErrorInfo = (response && response.data && Array.isArray(response.data.errors) && response.data.errors.length)
              ? JSON.stringify(response.data.errors)
              : 'print-fiscal-net request failed'
            // Comanda e in cloud, doar generarea bonului fiscal a picat -> doar refiscalizare.
            this.fiscalErrorCase = 'fiscal_only'
            // Logam esecul in kiosk_logs (log generic, doar pe esec).
            this.kioskLog({
              order_id: order.order_id,
              stage: 'fiscal_generate',
              event: (response && response.data && Array.isArray(response.data.errors) && response.data.errors.length) ? 'errors' : 'null_response',
              http_status: (response && response.status) ? response.status : null,
              data_from: (response && response.data) ? response.data : null
            })
            if (callback) {
              callback(0)
            }
          }
        })
      } else if (payMethod == 'cash' && !this.kiosk_is_using_fiscal_receipt_for_cash && !noFinishJustReprint) {
        let nefiscalData = this.generateNonFiscalTextFiscalNet(order)
        this.localRequestFiscalNet('/api/Receipt', 'POST', nefiscalData, (responseFiscalNet) => {
          this.finishOrder(order.number, payMethod, order.order_id)
        })
      } else {
        if (!noFinishJustReprint) {
          this.finishOrder(order.number, payMethod, order.order_id)
        }
      }
    },
    printFiscalNetSections(order) {
      if (!order.order_id) return;

      this.apiRequest(
        '/noauth/print-fiscal-net-sections/' + order.order_id,
        'POST',
        {},
        async (responseFiscalNetSections) => {
          if (responseFiscalNetSections && responseFiscalNetSections.data && responseFiscalNetSections.data.data) {
            for (const bon of responseFiscalNetSections.data.data) {
              await new Promise((resolve, reject) => {
                this.localRequestFiscalNet('/api/Receipt', 'POST', bon, (response) => {
                  resolve(response);
                });
              });
            }
          }
        }
      );
    },
    // Verifica pe API daca acest kiosk are comenzi nefiscalizate (ultimele 24h, plata
    // != cash). Se apeleaza la fiecare pornire de kiosk (dupa login) si, dupa ce
    // operatorul rezolva o comanda, ca sa treaca la urmatoarea pana nu mai raman.
    // Daca gaseste macar una, blocheaza kioskul pe ecranul negru (cere operator) cu
    // PRIMA comanda + cazul ei (place_and_fiscal / fiscal_only).
    // `excludeOrderId`: comanda tocmai rezolvata, ca sa nu re-blocheze pe ea din cauza
    // intarzierii de scriere in DB.
    checkKioskPendingFiscal (excludeOrderId = null) {
      if (!this.json || this.json.type != 'Kiosk') return 0
      if (!this.json.company_id || !this.json.id) return 0
      // Rulam verificarea DOAR pe kioskuri care chiar fiscalizeaza cardul prin FiscalNet,
      // altfel avem false-pozitive (comenzi legit fara fiscal ar aparea ca nefiscalizate):
      //  - fara FiscalNet (DBfiscalNet false): is_fiscal/fiscal_nr/fiscal_nrz nu se seteaza
      //    niciodata pe comanda (se seteaza doar din print-fiscal-net-answer);
      //  - kiosk_is_using_non_fiscal_receipt_for_card: cardul primeste bon NEFISCAL legit,
      //    deci comanda ramane in mod normal fara fiscal.
      if (!this.DBfiscalNet || this.kiosk_is_using_non_fiscal_receipt_for_card) return 0
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        location_id: this.locationTrueId,
        table_id: this.json.id
      }
      this.apiRequest('/noauth/kiosk-pending-fiscal', 'GET', data, (response) => {
        if (!response || !response.data || !response.data.data) return 0
        var orders = response.data.data.orders || []
        if (excludeOrderId) {
          orders = orders.filter((o) => o.order_id != excludeOrderId)
        }
        this.pendingFiscalOrders = orders
        if (orders.length) {
          var first = orders[0]
          this.blockKioskFiscalError = true
          this.lastOrderNumberForFiscalError = first.order_id
          this.fiscalErrorCase = first.fiscal_case || 'fiscal_only'
          this.fiscalErrorInfo = 'pending fiscal (verificare API)'
          // Ne asiguram ca butonul de settings (gear) apare pe ecranul negru, ca
          // operatorul sa poata deschide meniul secret si sa refiscalizeze.
          this.showSettings = true
          this.kioskLog({
            order_id: first.order_id,
            stage: 'startup_pending_fiscal',
            event: 'blocked',
            message: 'gasite ' + orders.length + ' nefiscalizate; caz ' + this.fiscalErrorCase
          })
        }
      })
    },
    reFiscalForOrder (orderId) {
      this.secretMenuLog('refiscal_click', { order_id: orderId })
      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        id: orderId,
        method: 'self_ordering'
      }
      this.loader = true;
      this.apiRequest('/get-cart-by-id', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          let oldOrder = response.data.data
          let payMethod = 'cash';
          if (oldOrder.payment_type == 'CARD' || oldOrder.payment_type == 'CARD_POS') {
            payMethod = 'card';
          }
          if (oldOrder.status == 'DRAFT' || oldOrder.status == 'DRAFT_AWAITING_PAYMENT') {
            // eroare La PLATA CARD (puneComanda)
            this.lastOrderNumberForFiscalError = null;
            this.blockKioskFiscalError = false;
            this.fiscalErrorInfo = null;
            this.fiscalErrorCase = null;
            this.showSettingsModal = false;
            this.loader = false;
            this.completeOrder('card_pos', 'Manual From Operator');
            // Dupa ce s-a pus + fiscalizat, re-verificam daca mai e vreo comanda
            // nefiscalizata (excludem asta ca sa nu re-blocam pe ea la lag de DB).
            setTimeout(() => { this.checkKioskPendingFiscal(orderId) }, 6000)
          } else {
            // eroare LA FISCAL (refiscalizeaza)
            if (this.DBfiscal && !this.DBfiscalNet) {
              this.printFiscalAndFinish(oldOrder, payMethod, 1, (r) => {
                if (r) {
                  this.lastOrderNumberForFiscalError = null;
                  this.blockKioskFiscalError = false;
                  this.fiscalErrorInfo = null;
                  this.fiscalErrorCase = null;
                  this.closeSettingsModal();
                  // Re-verificam daca mai e vreo comanda nefiscalizata (excludem asta).
                  setTimeout(() => { this.checkKioskPendingFiscal(orderId) }, 6000)
                  return 0;
                } else {
                  this.closeSettingsModal();
                  return 0;
                }
              });
            } else if (this.DBfiscalNet) {
              this.printFiscalNetAndFinish(oldOrder, payMethod, 1, (r) => {
                if (r) {
                  this.lastOrderNumberForFiscalError = null;
                  this.blockKioskFiscalError = false;
                  this.fiscalErrorInfo = null;
                  this.fiscalErrorCase = null;
                  this.closeSettingsModal();
                  // Re-verificam daca mai e vreo comanda nefiscalizata (excludem asta).
                  setTimeout(() => { this.checkKioskPendingFiscal(orderId) }, 6000)
                  return 0;
                } else {
                  this.closeSettingsModal();
                  return 0;
                }
              });
            }
          }
        } else {
          // window.location.href = this.qr_link;
          this.closeSettingsModal();
          return 0;
        }
      })
    },
    generateNonFiscalTextFiscalNet (order) {
      let nonFiscalTextOutput = '';

      // if (order.token) {
      //     nonFiscalTextOutput += `"TL^RO ${order.token}",\n`;
      // }
      if (order.number) {
          nonFiscalTextOutput += `"TL^Nr comanda: ${order.number}",\n`;
      }

      if (this.cart.myCart.products) {
            this.cart.myCart.products.forEach((prod) => {
              if (!prod.is_storno) {
                  nonFiscalTextOutput += `"TL^${prod.quantity}X ${(this.removeDiacritics(prod.name)).replace(/"/g, '')} ${prod.price} ${this.currency_symbol}",\n`;
                  // if (prod.extra && prod.extra != '') {
                  //   nonFiscalTextOutput += `"TL^${(prod.extra).replace(/"/g, '')}",\n`;
                  // }

                  if (prod.extra && prod.extra.trim() !== '') {
                    const extras = prod.extra.split(',').map(e => e.trim()).filter(e => e !== '');
                    extras.forEach(extra => {
                      let e = extra.replace(/"/g, '');
                      nonFiscalTextOutput += `"TL^${this.removeDiacritics(e)}",\n`;
                    });
                  }

                  // if (prod.options) {
                  //     prod.options.forEach((option) => {
                  //         if (option) {
                  //             nonFiscalTextOutput += `"TL^Optiune: ${(option.name).replace(/"/g, '')}   ${prod.quantity}X ${option.price} ${this.currency_symbol}",\n`;
                  //         }
                  //     });
                  // }
              }
          });
      }

      nonFiscalTextOutput += `"TL^Total: ${this.cart.myCart.total_cart_price} ${this.currency_symbol}",\n`;

      if (order.number && this.json.company_id != 201) {
        let barcodeNumber = String(order.number).padStart(13, '0'); 
        nonFiscalTextOutput += `"CB^${barcodeNumber}^2"`;
      }

      return nonFiscalTextOutput
    },
    async finishOrder (orderNr, payMethod, finishOrderId=null) {
      if (payMethod == 'cash' && this.json.type != 'Kiosk') {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        await Swal.fire({
          title: this.$t('addOrder.askcashtxt'),
          confirmButtonText: 'OK',
          timer: 10000,
          timerProgressBar: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
        });
      }
      if (this.json.company_id == 30 || this.json.company_id == 233) {
        this.callCronForPrinters()
      }
      if (this.json.company_id == 30 || this.json.company_id == 243) {
        this.callCronForEbriza()
      }
      if (this.serverPosIp) {
        this.callLocalSectionPrinters (this.serverPosIp, finishOrderId)
        this.callLocalLabelsPrinters (this.serverPosIp, finishOrderId)
      }
      this.showCompleteWaitingModal = false
      this.showLoaderCompleteCashMachine = false
      this.showCashMachineModal = false
      if (this.json.type == 'Kiosk') {
        let created_at = this.cart.created_at;
        let content = [];
        let options = [];
        for (var i = 0; i < this.cart.myCart.products.length; i++) {
          content.push({
            name: this.cart.myCart.products[i].name,
            quantity: this.cart.myCart.products[i].quantity,
            price: Number(this.cart.myCart.products[i].price).toFixed(2) + ' ' + this.currency_symbol,
            options: options
          });
        }
        let totals = [];
        // totals.push({
        //   name: 'Subtotal',
        //   price: this.cart.myCart.totals_subtotals + ' ' + this.currency_symbol,
        // });
        for (var i = 0; i < this.cart.order_totals.length; i++) {
          if (this.cart.order_totals[i].use && this.cart.order_totals[i].value > 0) {
            totals.push({
              name: this.cart.order_totals[i].name,
              price: this.cart.order_totals[i].value + ' ' + this.currency_symbol,
            });
          }
        }
        totals.push({
          name: 'Total',
          price: this.cart.myCart.total_cart_price + ' ' + this.currency_symbol,
        });
        this.cart = null
        // this.loadingCompleteOrder = false
        this.showCompleteModal = true
        this.finishOrderNr = orderNr
        this.printOrder(orderNr, created_at, content, totals)
        if (!this.blockKioskFiscalError) {
          clearTimeout(this.timeoutRestartFinishOrder)
          this.timeoutRestartFinishOrder = setTimeout(() => {
            this.restart()
            console.log('restart')
          }, 5000) // 5 sec
        }
      } else {
          this.successMsgIfCardPay(finishOrderId)
      }
    },
    callLocalSectionPrinters (printToIp, order_id) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        order_id: order_id
      }

      this.apiRequest('/get-order-for-local-printer', 'POST', data, (response) => {
        if (response && response.data.status) {
          const sectionDataToSendToLocal = {
            order: response.data.data.order,
            printers: response.data.data.printers
          }

          const receiptDataToSendToLocal = {
            order: response.data.data.order,
            printers: response.data.data.printersForReceipt
          }

          let $msg = ''
          let oneErrorMsg = 'success'

          if (response.data.data.printers.length && !this.stopSectionPrint) {
            this.localRequest(printToIp, 'POST', sectionDataToSendToLocal, (sectionRsp) => {
              // if (sectionRsp.status === 200) {
              //   sectionRsp.data.data.forEach(printerResponse => {
              //     if (printerResponse.status) {
              //       if (printerResponse.message && printerResponse.message === 'No items to print') {
              //         return
              //       }
              //       $msg += 'Sectia: ' + printerResponse.printerSectionName + ' s-a printat cu succes!\n'
              //     } else {
              //       $msg += 'Eroare sectia: ' + printerResponse.printerSectionName + '\n'
              //       oneErrorMsg = 'error'
              //     }
              //   })
              // } else {
              //   $msg += `Eroare: sectiuni - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
              //   oneErrorMsg = 'error'
              // }
            }, 'http://localhost:3210' + '/print-sections')
          }
          if (response.data.data.printersForReceipt.length && !this.stopReceiptPrint) {
            this.localRequest(printToIp, 'POST', receiptDataToSendToLocal, (sectionRsp) => {
            }, 'http://localhost:3210' + '/print')
          //   this.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, (receiptRsp) => {
          //     if (receiptRsp.status === 200) {
          //       receiptRsp.data.data.forEach(printerResponse => {
          //         if (printerResponse.status) {
          //           $msg += 'Nota de plata s-a printat cu succes!\n'
          //         } else {
          //           $msg += 'Eroare nota de plata' + '\n'
          //           oneErrorMsg = 'error'
          //         }
          //       })
          //     } else {
          //       $msg += `Eroare: bonuri - ${printToIp} inaccesibil sau proxy nu functioneaza.\n`
          //       oneErrorMsg = 'error'
          //     }

          //     swal({
          //       title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
          //       html: $msg.replace(/\n/g, '<br>'),
          //       type: oneErrorMsg,
          //       confirmButtonText: 'OK',
          //       allowOutsideClick: false
          //     })
          //   })
          }
        }
      })
    },
    callLocalLabelsPrinters (printToIp, order_id) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
      }

      this.apiRequest('/noauth/print-labels/' + order_id, 'GET', data, (response) => {
        if (response && response.data.status && response.data.data && response.data.data.printer_data) {
          if (response.data.data.printer_data.length) {
            response.data.data.printer_data.forEach((printerData) => {
              if (printerData.labels && printerData.labels.length) {
                this.localRequest(printToIp, 'POST', printerData, (sectionRsp) => {
                  // console.log('Print response:', sectionRsp);
                }, 'http://localhost:3210//print-labels');
              }
            });
          }
        }
      });
    },
    callCronForPrinters () {
      var data = {
        token: this.token,
        company_id: this.json.company_id
      }
      this.apiRequest('/noauth/print/orders', 'GET', data, (response) => {
        // nothing
      })
    },
    callCronForEbriza () {
      var data = {
        token: this.token,
        company_id: this.json.company_id
      }
      this.apiRequest('/noauth/ebriza/send-orders', 'GET', data, (response) => {
        // nothing
      })
    },
    checkIfPaymentIsComplete () {
      let stopTimeout = false
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      this.apiRequest('/check-if-qr-payment-complete', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data.data.payed) {
            this.stopTimeout = true
            this.finishOrder(response.data.data.number)
          }
        }
        clearTimeout(this.checkIfPaymentIsCompleteTimeout)
        if (this.countdown <= 0) {
          this.restart();
          console.log('restart')
          return 0;
        }
        if (!stopTimeout) {
          this.checkIfPaymentIsCompleteTimeout = setTimeout(() => {
            this.checkIfPaymentIsComplete()
          }, 5000)
        }
      })
    },
    startCountdown () {
      this.countdown = 240; // 4 mins
      this.countDown()
    },
    countDown () {
      clearTimeout(this.countDownTimeout)
      this.countDownTimeout = setTimeout(() => {
        this.countDown()
      }, 1000)
      if (this.countdown > 0) {
        this.countdown--
      } else {
        this.restart()
        console.log('restart')
      }
    },
    goFullScreen () {
      var element = document.querySelector('html')
      this.requestFullScreen(element)
      // if (this.isFullScreen) {
      //   document.exitFullscreen()
      //   this.isFullScreen = false
      // } else {
      //   this.isFullScreen = true
      //   this.requestFullScreen(element)
      // }
    },
    requestFullScreen (element) {
      // Supports most browsers and their versions.
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
      if (requestMethod) { // Native full screen.
        requestMethod.call(element)
      } else if (typeof window.ActiveXObject !== 'undefined') { // Older IE.
        var wscript = new ActiveXObject('WScript.Shell')
        if (wscript !== null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    exitFullScreen () {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.webkitExitFullscreen) { // Safari
            document.webkitExitFullscreen()
        } else if (document.mozCancelFullScreen) { // Firefox
            document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) { // IE/Edge
            document.msExitFullscreen()
        }
    },
    goBackToPickMethod () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.resetQuestion'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: true,
        reverseButtons: true,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.restart()
          console.log('restart')
        }
      })
    },
    refrashPage (callbackIfNotReloading) {
      var dd = {
        token: this.token,
        id: this.json.id,
        company_id: this.json.company_id,
        location_token: this.json.location_token,
      }
      this.apiRequest('/self-ordering-refrash', 'GET', dd, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data.data && response.data.data.refresh) {
            location.reload();
            return 0;
          }
        } else {
          // Requestul de refrash (cel care face reload-ul) a esuat: swall generic + log.
          this.generalErrorSwal('/self-ordering-refrash', response);
        }
        callbackIfNotReloading();
      })
    },
    hardReload () {
      // Cand e o problema de plata (comanda platita/ in aer) NU lasam reload,
      // ca sa nu pierdem comanda. Logam si incercarea permisa si cea blocata.
      if (this.isPaymentProblemActive()) {
        this.secretMenuLog('reload_blocked', { message: 'payment problem active' })
        return 0
      }
      this.secretMenuLog('reload')
      location.reload()
    },
    closeTab () {
      if (this.isPaymentProblemActive()) {
        this.secretMenuLog('close_blocked', { message: 'payment problem active' })
        return 0
      }
      this.secretMenuLog('close')
      this.exitFullScreen();
      this.localRequest('/exit-all', 'GET', {}, (response) => {
        //silence
      })
    },
    ckeckIfPosIsOnline () {
      if ((this.DBpos && (!this.DBfiscalNetWithPos))) {
        this.localRequest('/isOnline', 'GET', {
              'pos': JSON.stringify(this.DBpos)
            }, (response) => {

          if (response.data && response.data.resp == 'isOnline') {
            this.posPaymentEnabled = true
            this.posOffline = false
          }else {
            this.posPaymentEnabled = false
            // Posul bancar e configurat dar nu a raspuns => il aratam ca deconectat.
            this.posOffline = true
          }
          this.posRetrying = false
        })
      } else if (this.DBfiscalNetWithPos && !this.DBfiscalNet) {
        this.posPaymentEnabled = true
        this.posOffline = false
        this.posRetrying = false
      } else {
        this.posPaymentEnabled = false
        this.posRetrying = false
      }
    },
    ckeckIfFiscalIsOnline () {
      if (this.DBfiscalNet) {
        // this.localRequestFiscalNet('/api/Receipt', 'POST', '"MD^Is^Online",', (response) => {
        //   if (response && response.data && response.data.ErrorCode == '0') {
            this.showSettings = true
            if (this.DBfiscalNetWithPos) {
              this.posPaymentEnabled = true
              this.posOffline = false
            }
          // }
        // })
      } else if (this.DBfiscal) {
        this.localRequest('/isOnline', 'GET', {
              'fiscal': JSON.stringify(this.DBfiscal)
            }, (response) => {

          if (response.data && response.data.showSettings) {
            this.showSettings = true
          }
          if (response.data && response.data.resp == 'isOnline') {
            this.posPaymentEnabled = true
            this.posOffline = false
          }else {
            this.posPaymentEnabled = false
            // Fiscalul/posul e configurat dar nu a raspuns => deconectat.
            this.posOffline = true
          }
          this.posRetrying = false
        })
      }
    },
    // Apelat de butonul "Reincearca" din cardul "Posul bancar este deconectat".
    // Reface verificarea /isOnline; daca raspunde pozitiv, posOffline devine false
    // si reapare butonul normal de plata cu card (flow normal).
    retryPosOnline () {
      if (this.posRetrying) {
        return 0
      }
      this.posRetrying = true
      this.ckeckIfPosIsOnline()
      this.ckeckIfFiscalIsOnline()
    },
    removeDiacritics (text) {
      const diacriticsMap = {
          'ă': 'a', 'â': 'a', 'î': 'i', 'ș': 's', 'ț': 't',
          'Ă': 'A', 'Â': 'A', 'Î': 'I', 'Ș': 'S', 'Ț': 'T',
          'ă': 'a', 'â': 'a', 'î': 'i', 'ș': 's', 'ț': 't'
      };

      return text.replace(/[ăâîșțĂÂÎȘȚ]/g, match => diacriticsMap[match] || match);
    },
    getProductNameFromCart (product) {
      if (product.localized_fields && product.localized_fields[this.curentLang]) {
        if (product.localized_fields[this.curentLang].name && product.localized_fields[this.curentLang].name != '') {
          return product.localized_fields[this.curentLang].name
        }
      }
      return product.name
    },
    getProductName (product) {
      if (product.localized_fields && product.localized_fields[this.curentLang]) {
        if (product.localized_fields[this.curentLang].name && product.localized_fields[this.curentLang].name != '') {
          return product.localized_fields[this.curentLang].name
        }
      }
      return product.name
    },
    getCategoryName (category) {
      if (category && category.localized_fields && category.localized_fields[this.curentLang]) {
        if (category.localized_fields[this.curentLang].name && category.localized_fields[this.curentLang].name != '') {
          return category.localized_fields[this.curentLang].name
        }
      }
      return category ? category.name : ''
    },
    getTopCategoryName (topCategory) {
      if (topCategory && topCategory.localized_fields && topCategory.localized_fields[this.curentLang]) {
        if (topCategory.localized_fields[this.curentLang].name && topCategory.localized_fields[this.curentLang].name != '') {
          return topCategory.localized_fields[this.curentLang].name
        }
      }
      return topCategory ? topCategory.name : ''
    },
    getProductDesc (product, inHtml) {
      if (product.localized_fields && product.localized_fields[this.curentLang]) {
        if (product.localized_fields[this.curentLang].description && product.localized_fields[this.curentLang].description != '') {
          if (inHtml && product.localized_fields[this.curentLang].description_html && product.localized_fields[this.curentLang].description_html != '') {
            return product.localized_fields[this.curentLang].description_html
          } else {
            return product.localized_fields[this.curentLang].description
          }
        }
      }

      if (inHtml) {
        return product.description_html
      }
      return product.description
    },
    getProductPrice (product, withCurrency) {
      let priceType = null;
      if (this.json.type == 'Kiosk') {
        priceType = 3;
      } else {
        priceType = 2;
      }
      if (priceType && product.price_list && product.price_list[priceType]) {
        if (product.price_list[priceType].price) {
          product.edit_price = true
          if (withCurrency) {
            return product.price_list[priceType].price + ' ' + this.currency_symbol
          } else {
            return product.price_list[priceType].price
          }
        }
      }
      product.edit_price = false
      if (withCurrency) {
        return product.price_details.price + ' ' + this.currency_symbol
      }
      return product.price_details.price
    },
    // Returns true when the product has an active, claimable campaign discount
    // (discount.discounted_price lower than the product base price, units left).
    productHasDiscount (product) {
      if (!product || !product.discount) {
        return false
      }
      const discounted = product.discount.discounted_price
      if (discounted === null || discounted === undefined) {
        return false
      }
      const original = parseFloat(product.price)
      if (!(parseFloat(discounted) >= 0 && parseFloat(discounted) < original)) {
        return false
      }
      // Exhausted unit pool — no ribbon / promo price on the menu.
      const remaining = this.getDiscountUnitsRemaining(product)
      if (remaining != null && remaining <= 0 && !product.in_edit) {
        return false
      }
      return true
    },
    // Selected options list total (original prices) from price_details.
    // price_details.price = product.price * qty + options_list * qty.
    getProductSelectedOptionsTotal (product) {
      const quantity = parseFloat(product.quantity) || 1
      const baseUnit = parseFloat(product.price) || 0
      const detailsTotal = parseFloat(product.price_details && product.price_details.price) || 0
      const optionsTotal = detailsTotal - baseUnit * quantity
      if (isNaN(optionsTotal) || optionsTotal < 0) {
        return 0
      }
      return optionsTotal
    },
    // Payable selected options total (uses option campaign discounts when present).
    getSelectedOptionsPayableTotal (product) {
      if (!product || !product.product_options || !product.product_options.length) {
        return 0
      }
      const productQty = parseFloat(product.quantity) || 1
      let sum = 0
      for (let i = 0; i < product.product_options.length; i++) {
        const opt = product.product_options[i]
        if (!opt.values || !opt.values.length) {
          continue
        }
        for (let j = 0; j < opt.values.length; j++) {
          const val = opt.values[j]
          const selected = opt.type === 'radio'
            ? (opt.checked === val.id || val.checked)
            : !!val.checked
          if (!selected) {
            continue
          }
          const optQty = (opt.type === 'checkbox') ? (parseFloat(val.quantity) || 1) : 1
          sum += this.getOptionPayableUnitPrice(val) * optQty
        }
      }
      return parseFloat((sum * productQty).toFixed(2))
    },
    // Product unit list price (no selected options) — matches category list cards.
    getProductUnitListPrice (product, withCurrency) {
      const price = parseFloat(product && product.price) || 0
      if (withCurrency) {
        const symbol = (product.price_details && product.price_details.currency_symbol) || this.currency_symbol
        return price + ' ' + symbol
      }
      return price
    },
    // Product unit discounted price (no selected options) — matches category list cards.
    getProductUnitDiscountedPrice (product, withCurrency) {
      const discounted = parseFloat(product.discount.discounted_price)
      if (withCurrency) {
        const symbol = (product.price_details && product.price_details.currency_symbol) || this.currency_symbol
        return discounted + ' ' + symbol
      }
      return discounted
    },
    // Discounted product price + payable selected options, for current quantity (footer total).
    getProductDiscountedPrice (product, withCurrency) {
      const quantity = parseFloat(product.quantity) || 1
      const discountedUnit = parseFloat(product.discount.discounted_price)
      const total = parseFloat((discountedUnit * quantity + this.getSelectedOptionsPayableTotal(product)).toFixed(2))
      if (withCurrency) {
        const symbol = (product.price_details && product.price_details.currency_symbol) || this.currency_symbol
        return total + ' ' + symbol
      }
      return total
    },
    // Total shown in the product modal footer (product + option discounts).
    getProductCartTotalPrice (product, withCurrency) {
      if (this.productHasDiscount(product)) {
        return this.getProductDiscountedPrice(product, withCurrency)
      }
      const quantity = parseFloat(product.quantity) || 1
      const baseUnit = parseFloat(product.price) || 0
      const total = parseFloat((baseUnit * quantity + this.getSelectedOptionsPayableTotal(product)).toFixed(2))
      if (withCurrency) {
        const symbol = (product.price_details && product.price_details.currency_symbol) || this.currency_symbol
        return total + ' ' + symbol
      }
      return total
    },
    // Rounded-up discount percentage vs. the product base price.
    getProductDiscountPercent (product) {
      const original = parseFloat(product.price)
      const discounted = parseFloat(product.discount.discounted_price)
      if (!original) {
        return 0
      }
      return Math.ceil((original - discounted) / original * 100)
    },
    // Cart line (product or option) has a campaign discount amount to show under the list price.
    cartLineHasDiscount (line) {
      if (!line) {
        return false
      }
      if (line.discount && typeof line.discount === 'object') {
        return parseFloat(line.discount.discount) > 0
      }
      return parseFloat(line.discount) > 0
    },
    getCartLineDiscountUnit (line) {
      if (!line) {
        return 0
      }
      if (line.discount && typeof line.discount === 'object') {
        return parseFloat(line.discount.discount) || 0
      }
      return parseFloat(line.discount) || 0
    },
    getCartLineListUnit (line) {
      const original = parseFloat(line && line.original_price)
      if (!isNaN(original) && original > 0) {
        return original
      }
      const discountUnit = this.getCartLineDiscountUnit(line)
      if (discountUnit > 0 && line.discount && typeof line.discount === 'object') {
        return (parseFloat(line.discount.discounted_price) || 0) + discountUnit
      }
      if (line && line.price_unit != null) {
        return parseFloat(line.price_unit) || 0
      }
      return parseFloat(line && line.price) || 0
    },
    formatCartMoney (amount) {
      return parseFloat(amount || 0).toFixed(2) + ' ' + this.currency_symbol
    },
    // Product list (pre-discount) total for quantity — product only, no options.
    getCartProductListTotal (prod) {
      const qty = parseFloat(prod && prod.quantity) || 1
      return parseFloat((this.getCartLineListUnit(prod) * qty).toFixed(2))
    },
    getCartProductDiscountTotal (prod) {
      if (!this.cartLineHasDiscount(prod)) {
        return 0
      }
      const qty = parseFloat(prod && prod.quantity) || 1
      return parseFloat((this.getCartLineDiscountUnit(prod) * qty).toFixed(2))
    },
    // Main amount on the product row: list price when discounted / options broken out, else line total.
    getCartProductMainPrice (prod) {
      const hasOptions = Array.isArray(prod && prod.options) && prod.options.length > 0
      if (this.cartLineHasDiscount(prod) || hasOptions) {
        return this.getCartProductListTotal(prod)
      }
      return parseFloat(prod && prod.price) || 0
    },
    getCartOptionListTotal (prod, opt) {
      const pQty = parseFloat(prod && prod.quantity) || 1
      const oQty = parseFloat(opt && opt.quantity) || 1
      const sgr = parseFloat(opt && opt.price_sgr) || 0
      return parseFloat(((this.getCartLineListUnit(opt) + sgr) * oQty * pQty).toFixed(2))
    },
    getCartOptionDiscountTotal (prod, opt) {
      if (!this.cartLineHasDiscount(opt)) {
        return 0
      }
      const pQty = parseFloat(prod && prod.quantity) || 1
      const oQty = parseFloat(opt && opt.quantity) || 1
      return parseFloat((this.getCartLineDiscountUnit(opt) * oQty * pQty).toFixed(2))
    },
    successMsgIfCardPay (orderId) {
      clearTimeout(this.timeoutCartReload) //sa nu se mai faca cart reload
      if (this.withVivaWallet) {
        window.location.href = this.qr_link;
        return 0;
      }
      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        id: orderId,
        method: 'self_ordering'
      }
      this.apiRequest('/get-cart-by-id', 'GET', data, (response) => {
        if (response && response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.loader = false;
          let oldOrder = response.data.data
          this.oldOrder = oldOrder
          this.showPaymentSuccessModal = true
        } else {
          window.location.href = this.qr_link;
        }
      })
    },
    finishOrderNew () {
      window.location.href = this.qr_link;
    },
    errorMsgIfCardPay (errorTxt) {
      this.loader = false;
      Swal.fire({
        icon: 'error',
        title: errorTxt,
        text: this.$t('addOrder.errorFinishOrderMsg'),
        target: document.getElementById('swal-template'),
        customClass: {
          container: 'smallSwall errorPaymentSwall',
        }
      }).then( (result) => {
        window.location.href = this.qr_link;
        return 0;
      })
    },
    scrollToId(idToScroll, baseClass) {
      setTimeout(() => {
        const container = document.querySelector(baseClass);
        const el = document.getElementById(idToScroll);

        if (container && el) {
          const containerRect = container.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();

          const scrollTop = elRect.top - containerRect.top + container.scrollTop;

          container.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      }, 500);
    },
    restart () {
      // A response from the previous customer must not change the new session.
      this.orderMethodRequestId++
      this.settingOrderMethod = false
      this.loader = true
      Swal.close()
      if (this.json.type == 'Kiosk') {
        this.packed = false
        this.showSplashScreenModal = true
      } else {
        this.loader = true
        this.showSplashScreenModal = false
      }

      this.showCompleteWaitingModal = false
      this.showLoaderCompleteCashMachine = false
      this.showCashMachineModal = false
      this.client = null
      this.new_client = null
      this.onePaymentAllreadyPicked = false
      this.infoShown.permanentDisabled = false
      this.closeClientModal(false)
      this.showOptionModal = false
      this.showProductModal = false
      this.showCartModal = false
      this.showCouponModal = false
      this.showSoldWithModal = false
      this.showSoldWithMenuSuggestionModal = false
      this.soldWithCategory = null;
      this.openingProduct = false
      this.loading = false
      this.showPaymentModal = false
      this.showCompleteModal = false
      this.showSettingsModal = false
      this.showPaymentSuccessModal = false
      this.showPagerModal = false
      this.posPaymentEnabled = false
      this.posOffline = false
      this.posRetrying = false
      this.isOrdersHistoryCollapsed = false
      this.countdown = 120
      this.insertedMoneyInCashMachine = 0
      this.cui = ''
      this.phone_to_send = ''
      this.order_phone = null
      this.pagerText = ''
      this.pager = ''
      this.searchText = ''
      this.orderComments = '',
      this.couponText = '',
      this.tipValue = '',
      this.customTip= '',
      this.selectedPaymentMethod = '',
      this.dataToSendToVivaWallet = null;
      clearTimeout(this.sliderNextTimeout)
      clearTimeout(this.countDownTimeout)
      clearTimeout(this.activitiDetected)
      clearTimeout(this.timeoutRestartFinishOrder)
      // New order/customer: allow the "order something else?" popup again.
      clearTimeout(this.reorderPopupTimer)
      this.reorderPopupDone = false
      this.checkIfIsClose();
      if (!this.error) {
        this.getCurrentLocation((ask_to_empty_the_order)=> { // -> doThelogin
          if (!this.onCreatedAfterLoginFlag) {
            this.onCreatedAfterLogin()
          }
          this.selectedFingerprint = this.fingerprint.toString()
          // console.log(this.$route); // in v3
          let uri = window.location.search.substring(1); 
          let params = new URLSearchParams(uri);
          if (params.get("error") != null && this.json.type != 'Kiosk') {
            this.errorMsgIfCardPay(decodeURI(params.get("error")))
          } else if (params.get("success") != null && this.json.type != 'Kiosk') {
            this.successMsgIfCardPay(params.get("orderid"))
          } else {
            this.refrashPage(()=>{
              if (ask_to_empty_the_order && this.json.type != 'Kiosk') {
                this.loader = false;
                let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
                Swal.fire({
                  title: this.$t('addOrder.relogin'),
                  confirmButtonText: this.$t('addOrder.deleteOrder'),
                  cancelButtonText: this.$t('addOrder.couninueOrder'),
                  showCancelButton: true,
                  showCloseButton: true,
                  reverseButtons: true,
                  target: document.getElementById('swal-template'),
                  customClass: {
                    container: className,
                  }
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.continueRestart(true);
                  } else {
                    this.continueRestart();
                  }
                })
              } else {
                this.continueRestart();
              }
            })
          }
        })
      } else {
        this.loader = false
      }
    },
    continueRestart (withTableUsers = false) {
      clearTimeout(this.checkIfPaymentIsCompleteTimeout)
      if (this.json.type == 'Kiosk') {
        this.createCacheForMenu();
        this.showSplashScreenModal = true
        this.packed = false
      }
      this.getBanner()
      if (this.json.type != 'Kiosk') {
        this.getTheCart(()=>{
          if (this.withVivaWallet) {
            if (this.cart.status != 'DRAFT') {
              this.showSplashScreenModal = false;
            } else {
              this.showSplashScreenModal = true
            }
          } else {
            this.showSplashScreenModal = true
          }
          if (withTableUsers) {
            this.emptyCart(withTableUsers)
          }
          this.loader = false
        })
      } else {
        this.getTheCart(()=>{
          this.emptyCart()
          this.loader = false
          this.ckeckIfPosIsOnline()
          this.ckeckIfFiscalIsOnline()
        })
      }
      
      if (!this.useMethods) {
        this.getProducts(null,null,null,null, ()=> {
          // if (this.json.company_id == 39) {
          //   // tutorial
          //   var storedTutorial = localStorage['showTutorial_' + this.json.company_id];
          //   if (storedTutorial) {
          //     storedTutorial = JSON.parse(storedTutorial);
          //   }
          //   if (!storedTutorial || (storedTutorial && (storedTutorial.time + 86400 * 1000) <= Date.now() )) {
          //     this.showP9Modal = true
          //     let tutorial = {
          //       'show': 1,
          //       'time': Date.now(),
          //     }
          //     localStorage['showTutorial_' + this.json.company_id] = JSON.stringify(tutorial);
          //   }
          //   // let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          //   // Swal.fire({
          //   //   title: 'Salut! Bine ai venit la Piata9!',
          //   //   target: document.getElementById('swal-template'),
          //   //   customClass: {
          //   //     container: className,
          //   //   }
          //   // });
          // }

          if (this.json.type != 'Kiosk') {
            this.createCacheForMenu();
          }

          if (this.json.type == 'Kiosk') {
            this.definKeyboard()
          }
        })
      }
      // document.querySelector(".input").addEventListener("input", event => {
      //   this.keyboard.setInput(event.target.value);
      //   // this.activeKeyboard = true
      // });
    },
    getCompanyData () {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
      }
      this.apiRequest('/get-table-data', 'GET', data, (response) => {
        if (response && response.data.status) {
          if (this.refresh_products_date != response.data.data.refresh_products_date) {
            this.refresh_products_date = response.data.data.refresh_products_date
            window.appInstanceCache = {}
          }
        }
      })
    },
    createCacheForMenu () {
      const givenDate = new Date(this.refresh_products_date + " GMT")
      if (window.cache_date <= givenDate) {
        console.log('ClearCache')
        window.appInstanceCache = {}

        let deleteRequest = indexedDB.deleteDatabase(this.databaseName);
        deleteRequest.onsuccess = function(event) {
          console.log('Database deleted successfully');
        };
        deleteRequest.onerror = function(event) {
          console.error('Error deleting database:', event.target.error);
        };
        deleteRequest.onblocked = function(event) {
          console.warn('Database deletion blocked:', event.target.error);
        };

        // localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id] = JSON.stringify(window.appInstanceCache)
        window.cache_date = new Date()
        localStorage['tapTable_cache_date_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id] = window.cache_date.toISOString()

        let timeTimeout = 0
        if (this.category) {
          for (var i = 0; i < this.category.length; i++) {
            if (this.category[i]) {
              timeTimeout += 100
              this.getCatForCache(this.category[i].id, null, timeTimeout)
            }
          }
        } else {
          this.getCatForCache(null, null, timeTimeout)
        }
        timeTimeout = 0
        let CatId = null;
        let TopCatId = null;
        if (this.top_category && this.top_category.length) {
          for (var i = 0; i < this.top_category.length; i++) {
            for (var j = 0; j < this.top_category[i].categories.length; j++) {
              if (this.top_category[i].categories[j].id) {
                timeTimeout += 100
                this.getCatForCache(this.top_category[i].categories[j].id, this.top_category[i].id, timeTimeout)
              }
            }
          }
        }
        // console.log(catId);
      }
    },
    openAllProducts (productsFromRequest) {
      if (productsFromRequest.length) {
        let timeTimeout = 100
        // Incarcam in cache doar primele 12 produse; daca sunt zeci/sute,
        // deschiderea tuturor blocheaza kioskul.
        let limit = Math.min(12, productsFromRequest.length)
        for (var i = 0; i < limit; i++) {
          if (productsFromRequest[i]) {
            timeTimeout += 100
            this.getProductsForCache(productsFromRequest[i], timeTimeout)
          }
        }
      }
    },
    getProductsForCache (product, timeTimeout) {
      setTimeout( () => {
        this.openProduct (product, null, null, null, true)
      }, timeTimeout)
    },
    getCatForCache (CatId, TopCatId, timeTimeout) {
      setTimeout( () => {
        this.getProducts(CatId, TopCatId, null,null, ()=> {}, true)
      }, timeTimeout)
    }
  }
}
